export const blacklistNames = [
  '‘abbas ibn ‘abd al-muttalib',
  '`abd allah ibn `abbas',
  "`abdu'l-bahá",
  '13th dalai lama',
  '14th dalai lama',
  '50 cent',
  'a. a. milne',
  'a. c. bhaktivedanta swami prabhupada',
  'a. j. ayer',
  'a. j. cronin',
  'a. p. j. abdul kalam',
  'a. r. rahman',
  'aage bohr',
  'aaliyah',
  'aamir khan',
  'aaron',
  'aaron burr',
  'aaron ciechanover',
  'aaron copland',
  'aaron eckhart',
  'aaron johnson (english actor)',
  'aaron klug',
  'aaron lennon',
  'aaron mokoena',
  'aaron ramsey',
  'aaron sorkin',
  'aaron spelling',
  'aaron swartz',
  'abai qunanbaiuli',
  'abbas i of persia',
  'abbas ii of egypt',
  'abbas kiarostami',
  'abbé pierre',
  'abbot suger',
  'abd al-karim qasim',
  'abd al-malik ibn marwan',
  'abd al-rahman al-sufi',
  'abd al-rahman i',
  'abd rabbuh mansur hadi',
  'abd-ar-rahman iii',
  'abdelaziz bouteflika',
  'abdelkader el djezairi',
  'abdou diouf',
  'abdoulaye wade',
  'abdul hamid i',
  'abdul hamid ii',
  'abdul kader keïta',
  'abdul qadeer khan',
  'abdul-qadir gilani',
  'abdülaziz',
  'abdullah ahmad badawi',
  'abdullah gül',
  'abdullah i of jordan',
  'abdullah ii of jordan',
  'abdullah öcalan',
  'abdullah of saudi arabia',
  'abdullahi yusuf ahmed',
  'abdülmecid i',
  'abdülmecid ii',
  'abdur rahman khan',
  'abdurrahman wahid',
  'abdus salam',
  'abebe bikila',
  'abedi pele',
  'abel pacheco',
  'abel tasman',
  'abhishek bachchan',
  'abhisit vejjajiva',
  'abigail adams',
  'abigail breslin',
  'abijah of judah',
  'abou diaby',
  'abraham',
  'abraham de moivre',
  'abraham ibn ezra',
  'abraham lincoln',
  'abraham maslow',
  'abraham ortelius',
  'absalom',
  'abu al-qasim al-zahrawi',
  "abū al-wafā' būzjānī",
  'abu bakr',
  'abū ḥanīfa',
  'abu musab al-zarqawi',
  'abu muslim khorasani',
  'abu nuwas',
  'abū rayḥān al-bīrūnī',
  'abu sufyan ibn harb',
  'abu talib ibn ‘abd al-muttalib',
  'abulhassan banisadr',
  'achinoam nini',
  'ada lovelace',
  'adad-nirari i',
  'adalbert of prague',
  'adam brody',
  'adam clayton',
  'adam de la halle',
  'adam johnson (footballer)',
  'adam lambert',
  'adam levine',
  'adam małysz',
  'adam mickiewicz',
  'adam of bremen',
  'adam riess',
  'adam sandler',
  'adam savage',
  'adam smith',
  'adam weishaupt',
  'addys mercedes',
  'adela noriega',
  'adelbert von chamisso',
  'adele',
  'aden abdullah osman daar',
  'adewale akinnuoye-agbaje',
  'adi shankara',
  'adil rami',
  'adlai stevenson ii',
  'adnan menderes',
  'adnan oktar',
  'adolf anderssen',
  'adolf butenandt',
  'adolf dassler',
  'adolf eichmann',
  'adolf erik nordenskiöld',
  'adolf frederick, king of sweden',
  'adolf galland',
  'adolf hitler',
  'adolf loos',
  'adolf otto reinhold windaus',
  'adolf von baeyer',
  'adolfo bioy casares',
  'adolfo pérez esquivel',
  'adolfo suárez',
  'adolph menzel',
  'adolphe adam',
  'adolphe quetelet',
  'adolphe sax',
  'adolphe thiers',
  'adrian mutu',
  'adrian năstase',
  'adrian smith',
  'adrian sutil',
  'adriana karembeu',
  'adriana lima',
  'adriano celentano',
  'adriano correia',
  'adriano leite ribeiro',
  'adrien brody',
  'adrien-marie legendre',
  'ælfweard of wessex',
  'aemilianus',
  'aeschylus',
  'aesop',
  'æthelred of wessex',
  'æthelred the unready',
  'æthelstan',
  'æthelwulf of wessex',
  'afonso de albuquerque',
  'afonso i of portugal',
  'afonso ii of portugal',
  'afonso iii of portugal',
  'afonso iv of portugal',
  'afonso pena',
  'afonso v of portugal',
  'agatha christie',
  'agatha of sicily',
  'agathias',
  'agathocles of syracuse',
  'agesilaus ii',
  'agnes of rome',
  'ágnes szávay',
  'agnetha fältskog',
  'agnieszka radwańska',
  'agostinho neto',
  'agota kristof',
  'agrippa i',
  'agrippina the younger',
  'agustín de iturbide',
  'ahab',
  'ahaz',
  'ahaziah of judah',
  'ahmad ibn fadlan',
  'ahmad ibn hanbal',
  'ahmad shah durrani',
  'ahmad shah massoud',
  'ahmadou ahidjo',
  'ahmed ben bella',
  'ahmed hassan al-bakr',
  'ahmed i',
  'ahmed ii',
  'ahmed iii',
  'ahmed nazif',
  'ahmed ouyahia',
  'ahmed sékou touré',
  'ahmed shafik',
  'ahmed yassin',
  'ahmed zewail',
  'ahmet necdet sezer',
  'ahmose i',
  'ai sugiyama',
  'ai weiwei',
  'aiden mcgeady',
  'aigars kalvītis',
  'aimé césaire',
  'aisha',
  'aishwarya rai',
  'ajay devgan',
  'akbar',
  'akbar hashemi rafsanjani',
  'akechi mitsuhide',
  'akhenaten',
  'akhmad kadyrov',
  'aki kaurismäki',
  'akihito',
  'akio morita',
  'akira kurosawa',
  'akira suzuki (chemist)',
  'akira toriyama',
  'akira yoshizawa',
  'akiva ben joseph',
  'akon',
  'akseli gallen-kallela',
  'akshay kumar',
  'al capone',
  'al gore',
  'al oerter',
  'al pacino',
  'al-farabi',
  'al-ghazali',
  'al-kindi',
  "al-ma'mun",
  'al-mansur',
  'al-masudi',
  'al-maʿarri',
  'al-shafi‘i',
  'al-walid i',
  'alain bernard',
  'alain delon',
  'alain juppé',
  'alain prost',
  'alain resnais',
  'alain robbe-grillet',
  'alain robert',
  'alain-fournier',
  'alan alda',
  'alan arkin',
  'alan baker (mathematician)',
  'alan ball, jr.',
  'alan dzagoev',
  'alan garcía',
  'alan greenspan',
  'alan hutton',
  'alan j. heeger',
  'alan j. pakula',
  'alan jones (racing driver)',
  'alan lloyd hodgkin',
  'alan macdiarmid',
  'alan moore',
  'alan parker',
  'alan parsons',
  'alan rickman',
  'alan shearer',
  'alan shepard',
  'alan sillitoe',
  'alan smith (footballer born 1980)',
  'alan turing',
  'alanis morissette',
  'alaric i',
  'alaric ii',
  'alasdair macintyre',
  'alassane ouattara',
  'alban berg',
  'alben w. barkley',
  'albert abraham michelson',
  'albert bandura',
  'albert camus',
  'albert claude',
  'albert einstein',
  'albert fert',
  'albert finney',
  'albert françois lebrun',
  'albert hofmann',
  'albert i of belgium',
  'albert i of germany',
  'albert ii of belgium',
  'albert ii of germany',
  'albert ii, prince of monaco',
  'albert kesselring',
  'albert lortzing',
  'albert lutuli',
  'albert riera',
  'albert sabin',
  'albert schweitzer',
  'albert speer',
  'albert szent-györgyi',
  'albert uderzo',
  'albert, duke in prussia',
  'albert, prince consort',
  'alberto aquilani',
  'alberto ascari',
  'alberto contador',
  'alberto del rio',
  'alberto fujimori',
  'alberto giacometti',
  'alberto gilardino',
  'alberto granado',
  'alberto korda',
  'alberto moravia',
  'alberto santos-dumont',
  'alberto sordi',
  'alberto tomba',
  'albertus magnus',
  'alboin',
  'albrecht altdorfer',
  'albrecht dürer',
  'albrecht kossel',
  'albrecht von wallenstein',
  'alcaeus of mytilene',
  'alcibiades',
  'alcide de gasperi',
  'alcmaeon of croton',
  'alcman',
  'alcuin',
  'aldair',
  'aldo moro',
  'aldous huxley',
  'aldus manutius',
  'alec baldwin',
  'alec douglas-home',
  'alec guinness',
  'aleister crowley',
  'alejandro amenábar',
  'alejandro gonzález iñárritu',
  'alejandro jodorowsky',
  'alejandro sanz',
  'alejandro toledo',
  'alejandro valverde',
  'alejo carpentier',
  'aleksandar kolarov',
  'aleksander griboyedov',
  'aleksander kwaśniewski',
  'aleksandr anyukov',
  'aleksandr dedyushko',
  'aleksandr karelin',
  'aleksandr kerzhakov',
  'aleksandr kuprin',
  'aleksandr lyapunov',
  'aleksandr solzhenitsyn',
  'aleksandr vasilevsky',
  'aleksei berezutski',
  'aleksei brusilov',
  'aleksey konstantinovich tolstoy',
  'aleksey nikolayevich tolstoy',
  'aleksis kivi',
  'alessandra ambrosio',
  'alessandro baricco',
  'alessandro costacurta',
  'alessandro del piero',
  'alessandro diamanti',
  'alessandro manzoni',
  'alessandro matri',
  'alessandro nesta',
  'alessandro petacchi',
  'alessandro scarlatti',
  'alessandro volta',
  'alex ferguson',
  'alex haley',
  'alex jones',
  'alex oxlade-chamberlain',
  'alex pettyfer',
  'alex rodrigo dias da costa',
  'alex salmond',
  'alex song',
  'alexander (byzantine emperor)',
  'alexander alekhine',
  'alexander alexandrovich fadeyev',
  'alexander balas',
  'alexander belyayev',
  'alexander berkman',
  'alexander blok',
  'alexander borodin',
  'alexander calder',
  'alexander dovzhenko',
  'alexander dubček',
  'alexander fleming',
  'alexander frei',
  'alexander friedmann',
  'alexander glazunov',
  'alexander gottlieb baumgarten',
  'alexander graham bell',
  'alexander grin',
  'alexander grothendieck',
  'alexander haig',
  'alexander hamilton',
  'alexander herzen',
  'alexander hleb',
  'alexander i of macedon',
  'alexander i of russia',
  'alexander i of scotland',
  'alexander i of serbia',
  'alexander i of yugoslavia',
  'alexander ii of russia',
  'alexander ii of scotland',
  'alexander iii of russia',
  'alexander iii of scotland',
  'alexander ilyich yegorov',
  'alexander iv of macedon',
  'alexander kerensky',
  'alexander khalifman',
  'alexander kolchak',
  'alexander lebed',
  'alexander litvinenko',
  'alexander lukashenko',
  'alexander mackenzie',
  'alexander mcqueen',
  'alexander nevsky',
  'alexander of battenberg',
  'alexander of greece',
  'alexander oparin',
  'alexander ostrovsky',
  'alexander pokryshkin',
  'alexander pope',
  'alexander popov (swimmer)',
  'alexander prokhorov',
  'alexander pushkin',
  'alexander r. todd, baron todd',
  'alexander radishchev',
  'alexander rodchenko',
  'alexander rybak',
  'alexander scriabin',
  'alexander selkirk',
  'alexander severus',
  'alexander stepanovich popov',
  'alexander suvorov',
  'alexander the great',
  'alexander vinokourov',
  'alexander von humboldt',
  'alexander wurz',
  'alexandra feodorovna (alix of hesse)',
  'alexandra feodorovna (charlotte of prussia)',
  'alexandra kollontai',
  'alexandra maria lara',
  'alexandra of denmark',
  'alexandra stan',
  'alexandre cabanel',
  'alexandre dumas',
  'alexandre dumas, fils',
  'alexandre millerand',
  'alexandre pato',
  'alexandros tzorvas',
  'alexandru ioan cuza',
  'alexei alexeyevich abrikosov',
  'alexei kosygin',
  'alexei nikolaevich, tsarevich of russia',
  'alexei shirov',
  'alexej von jawlensky',
  'alexey leonov',
  'alexey pajitnov',
  'alexey stakhanov',
  'alexi laiho',
  'alexios i komnenos',
  'alexios ii komnenos',
  'alexios iii angelos',
  'alexios iv angelos',
  'alexios v doukas',
  'alexis bledel',
  'alexis carrel',
  'alexis clairaut',
  'alexis de tocqueville',
  'alexis of russia',
  'alexis sánchez',
  'alexy ii of moscow',
  'alfonso cuarón',
  'alfonso garcía robles',
  'alfonso ii of aragon',
  'alfonso iii of asturias',
  'alfonso v of aragon',
  'alfonso vi of león and castile',
  'alfonso vii of león and castile',
  'alfonso viii of castile',
  'alfonso x of castile',
  'alfonso xi of castile',
  'alfonso xii of spain',
  'alfonso xiii of spain',
  'alfred adler',
  'alfred binet',
  'alfred brehm',
  'alfred de musset',
  'alfred de vigny',
  'alfred döblin',
  'alfred dreyfus',
  'alfred g. gilman',
  'alfred gusenbauer',
  'alfred hermann fried',
  'alfred hershey',
  'alfred hitchcock',
  'alfred hugenberg',
  'alfred jarry',
  'alfred jodl',
  'alfred kastler',
  'alfred kinsey',
  'alfred marshall',
  'alfred moisiu',
  'alfred molina',
  'alfred nobel',
  'alfred north whitehead',
  'alfred radcliffe-brown',
  'alfred rosenberg',
  'alfred russel wallace',
  'alfred schnittke',
  'alfred sisley',
  'alfred tarski',
  'alfred the great',
  'alfred von schlieffen',
  'alfred von tirpitz',
  'alfred wegener',
  'alfred werner',
  'alfred, lord tennyson',
  'alfredo di stéfano',
  'alfredo palacio',
  'alfredo stroessner',
  'algirdas brazauskas',
  'alhazen',
  'ali',
  'ali abdullah saleh',
  'ali al-ridha',
  'ali bongo ondimba',
  'ali daei',
  'ali hassan al-majid',
  "ali ibn al-husayn zayn al-'abidin",
  'ali karimi',
  'ali khamenei',
  'ali larter',
  'ali pasha',
  "ali-shir nava'i",
  'alice cooper',
  'alice walker',
  'alicia keys',
  'alicia silverstone',
  'alija izetbegović',
  'alina kabaeva',
  'alison krauss',
  'alizé cornet',
  'alizée',
  'alla pugacheva',
  'allan kardec',
  'allan mcleod cormack',
  'allan simonsen',
  'allen ginsberg',
  'allen iverson',
  'allison mack',
  'allvar gullstrand',
  'allyson felix',
  'almazbek atambayev',
  'alois alzheimer',
  'alois hitler',
  'alois senefelder',
  'alona bondarenko',
  'alonzo church',
  'alou diarra',
  'aloysius gonzaga',
  'alp arslan',
  'alpha condé',
  'alpha oumar konaré',
  'alphonse daudet',
  'alphonse de lamartine',
  'alphonse mucha',
  'alphonsus maria de liguori',
  'alsou',
  'alva myrdal',
  'alvar aalto',
  'álvar núñez cabeza de vaca',
  'álvaro arbeloa',
  'álvaro colom',
  'álvaro negredo',
  'álvaro obregón',
  'álvaro pereira',
  'álvaro recoba',
  'álvaro siza vieira',
  'álvaro uribe',
  'alvin e. roth',
  'alvin toffler',
  'aly michalka',
  'alyattes of lydia',
  'alyson hannigan',
  'alyssa milano',
  'amadeo i of spain',
  'amadou toumani touré',
  'amalasuntha',
  'amália rodrigues',
  'amanda bynes',
  'amanda peet',
  'amanda seyfried',
  'amanda tapping',
  'amānullāh khān',
  "amar'e stoudemire",
  'amartya sen',
  'amauri',
  'amaury nolasco',
  'amaziah of judah',
  'ambiorix',
  'ambrogio lorenzetti',
  'ambroise paré',
  'ambroise thomas',
  'ambrose',
  'ambrose bierce',
  'amedeo avogadro',
  'amedeo modigliani',
  'amelia earhart',
  'amélie mauresmo',
  'amélie nothomb',
  'amenemhat i',
  'amenemhat ii',
  'amenemhat iii',
  'amenemhat iv',
  'amenhotep i',
  'amenhotep ii',
  'amenhotep iii',
  'america ferrera',
  'amerigo vespucci',
  'amílcar cabral',
  'amilcare ponchielli',
  'amin maalouf',
  'amintore fanfani',
  'amir khusrow',
  'amitabh bachchan',
  'ammianus marcellinus',
  'amon of judah',
  'amos (prophet)',
  'amos oz',
  'amr diab',
  'amr moussa',
  'amy adams',
  'amy lee',
  'amy macdonald',
  'amy winehouse',
  'ana ivanovic',
  'anabel medina garrigues',
  'anacreon',
  'anahí',
  'anaïs nin',
  'ananda',
  'ananda mahidol',
  'anastacia',
  'anastas mikoyan',
  'anastasia myskina',
  'anastasia pavlyuchenkova',
  'anastasio somoza debayle',
  'anastasios ii',
  'anastasius i (emperor)',
  'anatole france',
  'anatoliy tymoshchuk',
  'anatoly fomenko',
  'anatoly karpov',
  'anatoly lunacharsky',
  'anaxagoras',
  'anaximander',
  'anaximenes of miletus',
  'ancus marcius',
  'anders behring breivik',
  'anders celsius',
  'anders fogh rasmussen',
  'anders jonas ångström',
  'anders lindegaard',
  'anders svensson (footballer)',
  'anders zorn',
  'anderson luís de abreu oliveira',
  'andie macdowell',
  'andoni zubizarreta',
  'andranik margaryan',
  'andranik ozanian',
  'andre agassi',
  'andré breton',
  'andré chénier',
  'andré citroën',
  'andré derain',
  'andré frédéric cournand',
  'andre geim',
  'andré gide',
  'andré grétry',
  'andre iguodala',
  'andré le nôtre',
  'andré malraux',
  'andré masséna',
  'andré maurois',
  'andré michel lwoff',
  'andré ooijer',
  'andré previn',
  'andré rieu',
  'andré schürrle',
  'andré the giant',
  'andré villas-boas',
  'andré-marie ampère',
  'andré-pierre gignac',
  'andrea barzagli',
  'andrea bocelli',
  'andrea del castagno',
  'andrea del sarto',
  'andrea del verrocchio',
  'andrea gabrieli',
  'andrea mantegna',
  'andrea palladio',
  'andrea pirlo',
  'andreas baader',
  'andreas brehme',
  'andreas isaksson',
  'andreas ivanschitz',
  'andreas köpke',
  'andreas möller',
  'andreas ottl',
  'andreas papandreou',
  'andreas thorkildsen',
  'andreas vesalius',
  'andrei arshavin',
  'andrei bely',
  'andrei chikatilo',
  'andrei grechko',
  'andrei gromyko',
  'andrei kirilenko',
  'andrei rublev',
  'andrei sakharov',
  'andrei tarkovsky',
  'andrei tupolev',
  'andrei voznesensky',
  'andrei zhdanov',
  'andrés bonifacio',
  'andrés escobar',
  'andrés guardado',
  'andrés iniesta',
  'andrés palop',
  'andrés segovia',
  'andreu fontàs',
  'andrew carnegie',
  'andrew cole',
  'andrew fire',
  'andrew garfield',
  'andrew huxley',
  'andrew i of hungary',
  'andrew ii of hungary',
  'andrew iii of hungary',
  'andrew jackson',
  'andrew johnson',
  'andrew johnson (english footballer)',
  'andrew lincoln',
  'andrew lloyd webber',
  'andrew s. tanenbaum',
  'andrew schally',
  'andrew the apostle',
  'andrew wiles',
  'andrey bogolyubsky',
  'andrey kolmogorov',
  'andrey korotayev',
  'andrey markov',
  'andrey silnov',
  'andrey vlasov',
  'andrey vyshinsky',
  'andrey yeryomenko',
  'andrija mohorovičić',
  'andris bērziņš (latvian president)',
  'andrius kubilius',
  'andriy pyatov',
  'andriy shevchenko',
  'andriy voronin',
  'andriyan nikolayev',
  'andronikos i komnenos',
  'andronikos ii palaiologos',
  'andronikos iii palaiologos',
  'andronikos iv palaiologos',
  'andrus ansip',
  'andry rajoelina',
  'andrzej wajda',
  'andy carroll',
  'andy fletcher (musician)',
  'andy garcía',
  'andy kaufman',
  'andy murray',
  'andy richter',
  'andy roddick',
  'andy schleck',
  'andy serkis',
  'andy warhol',
  'andy whitfield',
  'andy williams',
  'anedjib',
  'anerood jugnauth',
  'anette olzon',
  'ang lee',
  'ángel di maría',
  'angela davis',
  'angela gossow',
  'angela lansbury',
  'angela merkel',
  'angelina jolie',
  'angelique kerber',
  'angelo peruzzi',
  'angelo taylor',
  'angelos basinas',
  'angelos charisteas',
  'anggun',
  'angus young',
  'ani lorak',
  'aníbal cavaco silva',
  'anita ekberg',
  'anja pärson',
  'anjelica huston',
  'ankhesenamun',
  'ann radcliffe',
  'ann-margret',
  'anna akhmatova',
  'anna bergendahl',
  'anna chakvetadze',
  'anna faris',
  'anna freud',
  'anna gavalda',
  'anna hazare',
  'anna kendrick',
  'anna komnene',
  'anna kournikova',
  'anna lindh',
  'anna magnani',
  'anna maria jopek',
  'anna netrebko',
  'anna nicole smith',
  'anna of russia',
  'anna paquin',
  'anna pavlova',
  'anna pavlovna of russia',
  'anna politkovskaya',
  'anna popplewell',
  'anna seghers',
  'anna torv',
  'anna-maria ravnopolska-dean',
  'annasophia robb',
  'anne bancroft',
  'anne baxter',
  'anne boleyn',
  'anne brontë',
  'anne frank',
  'anne hathaway',
  'anne heche',
  'anne of austria',
  'anne of brittany',
  'anne of cleves',
  'anne of denmark',
  'anne rice',
  'anne-robert-jacques turgot, baron de laune',
  'anne-sophie mutter',
  'anne, princess royal',
  'anne, queen of great britain',
  'annette bening',
  'annibale carracci',
  'annibale de gasparis',
  'annie besant',
  'annie girardot',
  'annie jump cannon',
  'annie leibovitz',
  'annie lennox',
  'annise parker',
  'anote tong',
  'anouk (singer)',
  'anouk aimée',
  'anousheh ansari',
  'ansel adams',
  'anselm of canterbury',
  'ansgar',
  'antanas smetona',
  'ante gotovina',
  'ante pavelić',
  'anthemius',
  'anthemius of tralles',
  'anthony burgess',
  'anthony davidson',
  'anthony eden',
  'anthony giddens, baron giddens',
  'anthony hopkins',
  'anthony james leggett',
  'anthony kiedis',
  'anthony minghella',
  'anthony of padua',
  'anthony perkins',
  'anthony quinn',
  'anthony réveillère',
  'anthony the great',
  'anthony van dyck',
  'antigonus i monophthalmus',
  'antigonus ii gonatas',
  'antigonus iii doson',
  'antinous',
  'antiochus i soter',
  'antiochus ii theos',
  'antiochus iii the great',
  'antiochus iv epiphanes',
  'antiochus ix cyzicenus',
  'antiochus v',
  'antiochus vi dionysus',
  'antiochus vii sidetes',
  'antiochus xi epiphanes',
  'antipater',
  'antipope benedict xiii',
  'antipope felix ii',
  'antipope felix v',
  'antipope john xxiii',
  'antipope laurentius',
  'antipope ursicinus',
  'antisthenes',
  'antoine de saint-exupéry',
  'antoine françois prévost',
  'antoine laurent de jussieu',
  'antoine lavoisier',
  'antoine watteau',
  'antoine-jean gros',
  'antolín alcaraz',
  'anton bruckner',
  'anton chekhov',
  'anton denikin',
  'anton drexler',
  'anton ferdinand',
  'antón lamazares',
  'anton lavey',
  'anton makarenko',
  'anton praetorius',
  'anton raphael mengs',
  'anton rubinstein',
  'anton shunin',
  'anton webern',
  'antonello da messina',
  'antoni gaudí',
  'antoni grabowski',
  'antoni tàpies',
  'antonie van leeuwenhoek',
  'antonin artaud',
  'antonín dvořák',
  'antonín novotný',
  'antonín panenka',
  'antoninus pius',
  'antonio adán',
  'antonio banderas',
  'antonio canova',
  'antônio carlos jobim',
  'antonio cassano',
  'antonio conte',
  'antonio da correggio',
  'antónio de oliveira salazar',
  'antonio di natale',
  'antónio egas moniz',
  'antonio gramsci',
  'antónio guterres',
  'antonio josé de sucre',
  'antonio lópez de santa anna',
  'antonio machado',
  'antonio meucci',
  'antonio negri',
  'antonio nocerino',
  'antonio pigafetta',
  'antonio puerta',
  'antonio saca',
  'antonio salieri',
  'antonio segni',
  'antonio stradivari',
  'antonio tabucchi',
  'antonio valencia',
  'antonio vivaldi',
  'antonios nikopolidis',
  'antonis samaras',
  'antony hewish',
  'anwar ibrahim',
  'anwar sadat',
  'apelles',
  'aphex twin',
  'apl.de.ap',
  'apollodorus of athens',
  'apollodorus of damascus',
  'apollonius of perga',
  'apollonius of rhodes',
  'apollonius of tyana',
  'appian',
  'appius claudius caecus',
  'apuleius',
  'aram khachaturian',
  'arantxa sánchez vicario',
  'arash (singer)',
  'aratus',
  'aravind adiga',
  'arcadius',
  'arcangelo corelli',
  'arcesilaus',
  'archduke charles, duke of teschen',
  'archduke franz ferdinand of austria',
  'archer john porter martin',
  'archibald hill',
  'archibald primrose, 5th earl of rosebery',
  'archilochus',
  'archimedes',
  'archytas',
  'arda turan',
  'ardashir i',
  'ardashir ii',
  'aretha franklin',
  'aribert heim',
  'ariel ortega',
  'ariel sharon',
  'aristarchus of samos',
  'aristide briand',
  'aristide maillol',
  'aristides',
  'aristides pereira',
  'aristippus',
  'aristophanes',
  'aristotle',
  'aristotle onassis',
  'arius',
  'arjen robben',
  'arkady and boris strugatsky',
  'armand fallières',
  'armand traoré',
  'armando guebuza',
  'armin mueller-stahl',
  'armin van buuren',
  'arminius',
  'arnaldur indriðason',
  'arnaut daniel',
  'arne friedrich',
  'arne jacobsen',
  'arne tiselius',
  'arno allan penzias',
  'arnold böcklin',
  'arnold j. toynbee',
  'arnold rüütel',
  'arnold schoenberg',
  'arnold schwarzenegger',
  'arnold sommerfeld',
  'arnold vosloo',
  'arnulf of carinthia',
  'aron nimzowitsch',
  'arpachshad',
  'árpád',
  'arrian',
  'arrigo boito',
  'arrigo sacchi',
  'arsaces i of parthia',
  'arsène wenger',
  'arses of persia',
  'arsinoe ii',
  'arsinoe iii of egypt',
  'art clokey',
  'art garfunkel',
  'art tatum',
  'artabasdos',
  'artaxerxes i of persia',
  'artaxerxes ii of persia',
  'artaxerxes iii',
  'artem milevskiy',
  'artemisia gentileschi',
  'arthur adamov',
  'arthur ashe',
  'arthur balfour',
  'arthur c. clarke',
  'arthur cayley',
  'arthur compton',
  'arthur conan doyle',
  'arthur de gobineau',
  'arthur eddington',
  'arthur evans',
  'arthur harden',
  'arthur henderson',
  'arthur honegger',
  'arthur koestler',
  'arthur kornberg',
  'arthur leonard schawlow',
  'arthur lewis (economist)',
  'arthur miller',
  'arthur penn',
  'arthur rimbaud',
  'arthur rubinstein',
  'arthur schnitzler',
  'arthur schopenhauer',
  'arthur seyss-inquart',
  'arthur sullivan',
  'arthur wellesley, 1st duke of wellington',
  'arthur, prince of wales',
  'arto paasilinna',
  'artturi ilmari virtanen',
  'artur boruc',
  'artur rasizade',
  'arturo pérez-reverte',
  'arturo toscanini',
  'arturo vidal',
  'arundhati roy',
  'arvid carlsson',
  'arvo pärt',
  'arvydas sabonis',
  'aryabhata',
  'as-saffah',
  'asa of judah',
  'asafa powell',
  'asamoah gyan',
  'asaph hall',
  'ásgeir ásgeirsson',
  'ashanti (entertainer)',
  'ashikaga takauji',
  'ashlee simpson',
  'ashley cole',
  'ashley greene',
  'ashley judd',
  'ashley tisdale',
  'ashley young',
  'ashoka',
  'ashton kutcher',
  'ashurbanipal',
  'ashurnasirpal ii',
  'asif ali zardari',
  'askar akayev',
  'aslan maskhadov',
  'asparukh of bulgaria',
  'aspasia',
  'assia djebar',
  'ástor piazzolla',
  'astrid lindgren',
  'astyages',
  'atahualpa',
  'atal bihari vajpayee',
  'ataulf',
  'atb',
  'athalaric',
  'athaliah',
  'athanaric',
  'athanasius kircher',
  'athanasius of alexandria',
  'athenaeus',
  'athenagoras of athens',
  'atifete jahjaga',
  'atle selberg',
  'atom egoyan',
  'atsuto uchida',
  'attalus iii',
  'attar of nishapur',
  'attila',
  'attila józsef',
  'aubrey beardsley',
  'audrey hepburn',
  'audrey tautou',
  'august bebel',
  'august ferdinand möbius',
  'august krogh',
  'august macke',
  'august schleicher',
  'august strindberg',
  'august von mackensen',
  'august wilhelm schlegel',
  'auguste comte',
  'auguste de marmont',
  'auguste marie françois beernaert',
  'auguste piccard',
  'auguste rodin',
  'augustin pyramus de candolle',
  'augustin-jean fresnel',
  'augustin-louis cauchy',
  'augustine of canterbury',
  'augustine of hippo',
  'augusto césar sandino',
  'augusto de luca',
  'augusto pinochet',
  'augusto roa bastos',
  'augustus',
  'augustus de morgan',
  'augustus ii the strong',
  'augustus iii of poland',
  'aulus gellius',
  'aung san',
  'aung san suu kyi',
  'aurangzeb',
  'aurelian',
  'aurelius victor',
  'ausonius',
  'austen chamberlain',
  'ava gardner',
  'avempace',
  'averroes',
  'avicenna',
  'avicii',
  'avidius cassius',
  'avigdor lieberman',
  'avitus',
  'avraam papadopoulos',
  'avram grant',
  'avram hershko',
  'avril lavigne',
  'axel oxenstierna',
  'axl rose',
  'ay',
  'ayaan hirsi ali',
  'ayman al-zawahiri',
  'ayn rand',
  'ayrton senna',
  'aysel teymurzadeh',
  'ayub khan (field marshal)',
  'ayumi hamasaki',
  'b. f. skinner',
  'b. h. liddell hart',
  'b. j. habibie',
  'b. r. ambedkar',
  'b.b. king',
  'b.o.b',
  'baasha of israel',
  'báb',
  'babe ruth',
  'babrak karmal',
  'babur',
  'bacary sagna',
  'bacchylides',
  "bahá'u'lláh",
  'bahadur shah ii',
  'bahrām chobin',
  'bahram i',
  'bahram ii',
  'bahram v',
  'bai juyi',
  'baibars',
  'bakili muluzi',
  'bal gangadhar tilak',
  'balbinus',
  'baldassare castiglione',
  'baldassare galuppi',
  'baldur von schirach',
  'baldwin i of constantinople',
  'baldwin i of jerusalem',
  'baldwin iv of jerusalem',
  'baldwin spencer',
  'baltasar gracián',
  'bam margera',
  'bamir topi',
  'ban ki-moon',
  'banksy',
  'bao dai',
  'bar refaeli',
  'barabbas',
  'barack obama',
  'barbara mcclintock',
  'barbara stanwyck',
  'barbra streisand',
  'barnabas',
  "baron d'holbach",
  'baron münchhausen',
  'barry gibb',
  'barry levinson',
  'barry manilow',
  'barry marshall',
  'barry white',
  'bartholomew the apostle',
  'bartolomé de las casas',
  'bartolomé esteban murillo',
  'bartolomeu dias',
  'baruch samuel blumberg',
  'baruch spinoza',
  'baruj benacerraf',
  'bashar al-assad',
  'basil i',
  'basil ii',
  'basil of caesarea',
  'basiliscus',
  'basshunter',
  'bastian schweinsteiger',
  'bathsheba',
  'batu khan',
  'baudouin of belgium',
  'bayezid i',
  'bayezid ii',
  'bear grylls',
  'beatrix of the netherlands',
  'beatrix potter',
  'beau bridges',
  'bébé',
  'bebeto',
  'beck',
  'bede',
  'bedřich smetana',
  'behgjet pacolli',
  'béla bartók',
  'béla ii of hungary',
  'béla iii of hungary',
  'béla iv of hungary',
  'béla kun',
  'bela lugosi',
  'belinda carlisle',
  'belisarius',
  'bella akhmadulina',
  'bella thorne',
  'belshazzar',
  'ben affleck',
  'ben barnes (actor)',
  'ben bernanke',
  'ben browder',
  'ben foster (actor)',
  'ben foster (footballer)',
  'ben gazzara',
  'ben johnson (sprinter)',
  'ben jonson',
  'ben kingsley',
  'ben roy mottelson',
  'ben stiller',
  'ben wallace',
  'benazir bhutto',
  'benedetto croce',
  'benedict anderson',
  'benedict arnold',
  'benedict cumberbatch',
  'benedict of nursia',
  'benedikt höwedes',
  'bengt i. samuelsson',
  'benicio del toro',
  'benigno aquino iii',
  'benigno aquino, jr.',
  'benito juárez',
  'benito mussolini',
  'benito pérez galdós',
  'benjamin',
  'benjamin angus wright',
  'benjamin britten',
  'benjamin constant',
  'benjamin disraeli',
  'benjamin franklin',
  'benjamin harrison',
  'benjamin netanyahu',
  'benjamin thompson',
  'benni mccarthy',
  'benny andersson',
  'benny benassi',
  'benny goodman',
  'benny hill',
  'benoît assou-ekotto',
  'benoit mandelbrot',
  'bent larsen',
  'benvenuto cellini',
  'berengar i of italy',
  'bérénice bejo',
  'berenice ii',
  'bernadette soubirous',
  'bernard bolzano',
  'bernard herrmann',
  'bernard hinault',
  'bernard katz',
  'bernard kouchner',
  'bernard le bovier de fontenelle',
  'bernard lewis',
  'bernard madoff',
  'bernard montgomery, 1st viscount montgomery of alamein',
  'bernard of clairvaux',
  'bernard parker',
  'bernard werber',
  'bernardo bertolucci',
  'bernardo houssay',
  "bernardo o'higgins",
  'bernd schneider (footballer)',
  'bernd schuster',
  'bernhard riemann',
  'bernhard schlink',
  'bernhard von bülow',
  'bernie ecclestone',
  'bernie mac',
  'bert sakmann',
  'bert van marwijk',
  'bertel thorvaldsen',
  'bertha von suttner',
  'berthe morisot',
  'berti vogts',
  'bertie ahern',
  'bertil ohlin',
  'bertolt brecht',
  'bertram brockhouse',
  'bertrand delanoë',
  'bertrand russell',
  'bessie smith',
  'bessus',
  'bette davis',
  'bette midler',
  'bettie page',
  'bettina von arnim',
  'bettino craxi',
  'betty ford',
  'betty friedan',
  'betty white',
  'betty williams (nobel laureate)',
  'beyoncé knowles',
  'bhagwan shree rajneesh',
  'bharrat jagdeo',
  'bhāskara ii',
  'bhumibol adulyadej',
  'big show',
  'bilal ibn rabah al-habashi',
  'bilawal bhutto zardari',
  'bill bryson',
  'bill clinton',
  'bill cosby',
  'bill evans',
  'bill gates',
  'bill goldberg',
  'bill kaulitz',
  'bill maher',
  'bill murray',
  'bill nighy',
  'bill paxton',
  'bill russell',
  'bill shankly',
  'billie holiday',
  'billie jean king',
  'billie joe armstrong',
  'billy bob thornton',
  'billy boyd (actor)',
  'billy connolly',
  'billy crystal',
  'billy graham',
  'billy idol',
  'billy joel',
  'billy mays',
  'billy ray cyrus',
  'billy the kid',
  'billy wilder',
  'billy zane',
  'bing crosby',
  'bingu wa mutharika',
  'bipasha basu',
  'birgit prinz',
  'bixente lizarazu',
  'bjarne stroustrup',
  'björk',
  'björn borg',
  'bjørn dæhlie',
  'björn ulvaeus',
  'bjørnstjerne bjørnson',
  'blackbeard',
  'blaise cendrars',
  'blaise compaoré',
  'blaise pascal',
  'blake clark',
  'blake edwards',
  'blake griffin',
  'blake lively',
  'blanche of castile',
  'blanka vlašić',
  'bo diddley',
  'boa',
  'bob beamon',
  'bob dylan',
  'bob geldof',
  'bob hope',
  'bob hoskins',
  'bob marley',
  'bob sinclar',
  'bobby charlton',
  'bobby farrell',
  'bobby fischer',
  'bobby jindal',
  'bobby mcferrin',
  'bobby moore',
  'bobby robson',
  'bobby zamora',
  'bode miller',
  'bodhidharma',
  'boethius',
  'bogdan lobonț',
  'bohdan khmelnytsky',
  'bohemond i of antioch',
  'bohumil hrabal',
  'bohuslav martinů',
  'bojan krkić',
  'bolesław bierut',
  'bolesław i chrobry',
  'bolesław ii the generous',
  'bolesław iii wrymouth',
  'bon scott',
  'bona sforza',
  'bonar law',
  'bonaventura cavalieri',
  'bonaventure',
  'bongani khumalo',
  'bonnie hunt',
  'bonnie tyler',
  'bonnie wright',
  'bono',
  'booker t (wrestler)',
  'boris akunin',
  'boris becker',
  'boris berezovsky (businessman)',
  'boris gelfand',
  'boris godunov',
  'boris i of bulgaria',
  'boris iii of bulgaria',
  'boris johnson',
  'boris karloff',
  'boris kolker',
  'boris pasternak',
  'boris shaposhnikov',
  'boris spassky',
  'boris tadić',
  'boris trajkovski',
  'boris vian',
  'boris yeltsin',
  'borut pahor',
  'boudewijn zenden',
  'boudica',
  'bourvil',
  'boutros boutros-ghali',
  'boyko borisov',
  'brad delson',
  'brad friedel',
  'brad guzan',
  'brad pitt',
  'brad renfro',
  'bradley cooper',
  'bradley manning',
  'bradley wiggins',
  'brahmagupta',
  'bram stoker',
  'brandon flowers',
  'brandon lee',
  'brandon routh',
  'brandy norwood',
  'branislav ivanović',
  'branislav nušić',
  'branko crvenkovski',
  'brenda song',
  'brendan',
  'brendan fraser',
  'brendan gleeson',
  'brendan rodgers',
  'bret easton ellis',
  'bret hart',
  'brett emerton',
  'brett holman',
  'brian boru',
  'brian clough',
  'brian cowen',
  'brian cox (actor)',
  'brian david josephson',
  'brian de palma',
  'brian eno',
  'brian epstein',
  'brian greene',
  'brian johnson',
  'brian jones',
  'brian joubert',
  'brian kobilka',
  'brian may',
  'brian molko',
  'brian mulroney',
  'brian schmidt',
  'briana banks',
  'bridget fonda',
  'bridget of sweden',
  'bridgit mendler',
  'brigham young',
  'brigitte bardot',
  'brigitte nielsen',
  'britney spears',
  'brittany murphy',
  'bronisław geremek',
  'bronisław komorowski',
  'bronzino',
  'brook taylor',
  'brooke shields',
  'bruce beutler',
  'bruce campbell',
  'bruce dickinson',
  'bruce lee',
  'bruce mclaren',
  'bruce springsteen',
  'bruce willis',
  'bruno alves',
  'bruno bauer',
  'bruno ganz',
  'bruno kreisky',
  'bruno mars',
  'bruno of cologne',
  'bruno schulz',
  'bruno senna',
  'bryan adams',
  'bryan cranston',
  'bryan ferry',
  'bryan robson',
  'bryan singer',
  'bryce dallas howard',
  'buckethead',
  'buckminster fuller',
  'bud abbott',
  'bud spencer',
  'buddy holly',
  'buenaventura durruti',
  'buffalo bill',
  'bujar nishani',
  'bulat okudzhava',
  'bülent ecevit',
  'burebista',
  'burhanuddin rabbani',
  'burt bacharach',
  'burt lancaster',
  'burt reynolds',
  'burton richter',
  'busta rhymes',
  'buster keaton',
  'buvaisar saitiev',
  'buzz aldrin',
  'c. f. powell',
  'c. s. lewis',
  'c. v. raman',
  'c. wright mills',
  'cab calloway',
  'cacau',
  'cadel evans',
  'caesarion',
  'caetano veloso',
  'cafu',
  'cai lun',
  'caiaphas',
  'caligula',
  'călin popescu-tăriceanu',
  'calista flockhart',
  'callicrates',
  'callimachus',
  'calvin coolidge',
  'calvin harris',
  'calvin klein (fashion designer)',
  'cam gigandet',
  'cambyses i',
  'cambyses ii',
  'cameron diaz',
  'camilla belle',
  'camilla, duchess of cornwall',
  'camille claudel',
  'camille flammarion',
  'camille jordan',
  'camille pissarro',
  'camille saint-saëns',
  'camillo benso, count of cavour',
  'camillo golgi',
  'camilo cienfuegos',
  'camilo josé cela',
  'canaletto',
  'candice accola',
  'candice bergen',
  'candice swanepoel',
  'cannonball adderley',
  'cantinflas',
  'cao cao',
  'cao pi',
  'cao xueqin',
  'cara black',
  'caracalla',
  'caravaggio',
  'cardinal mazarin',
  'cardinal richelieu',
  'carey mulligan',
  'carinus',
  'carl barks',
  'carl bildt',
  'carl bosch',
  'carl czerny',
  'carl david anderson',
  'carl ditters von dittersdorf',
  'carl ferdinand cori',
  'carl friedrich abel',
  'carl friedrich gauss',
  'carl gustaf emil mannerheim',
  'carl gustav jacob jacobi',
  'carl jung',
  'carl larsson',
  'carl lewis',
  'carl linnaeus',
  'carl maria von weber',
  'carl menger',
  'carl michael bellman',
  'carl nielsen',
  'carl orff',
  'carl philipp emanuel bach',
  'carl ritter',
  'carl rogers',
  'carl sagan',
  'carl sandburg',
  'carl schmitt',
  'carl spitteler',
  'carl spitzweg',
  'carl theodor dreyer',
  'carl van vechten',
  'carl von clausewitz',
  'carl von ossietzky',
  'carl wieman',
  'carl wilhelm scheele',
  'carl woese',
  'carl xvi gustaf of sweden',
  'carl zeiss',
  'carla bruni',
  'carla del ponte',
  'carla gugino',
  'carles puyol',
  'carlo ancelotti',
  'carlo azeglio ciampi',
  'carlo buonaparte',
  'carlo collodi',
  'carlo cudicini',
  'carlo gesualdo',
  'carlo goldoni',
  'carlo maderno',
  'carlo rubbia',
  'carloman (mayor of the palace)',
  'carloman i',
  'carloman ii',
  'carloman of bavaria',
  'carlos alberto parreira',
  'carlos alberto torres',
  'carlos andrés pérez',
  'carlos bocanegra',
  'carlos castaneda',
  'carlos cuéllar',
  'carlos filipe ximenes belo',
  'carlos fuentes',
  'carlos gamarra',
  'carlos gardel',
  'carlos i of portugal',
  'carlos marchena',
  'carlos menem',
  'carlos mesa',
  'carlos moyá',
  'carlos ruiz zafón',
  'carlos saavedra lamas',
  'carlos sainz',
  'carlos salcido',
  'carlos santana',
  'carlos sastre',
  'carlos saura',
  'carlos slim',
  'carlos tévez',
  'carlos the jackal',
  'carlos valderrama',
  'carlos vela',
  'carlota of mexico',
  'carly colón',
  'carly rae jepsen',
  'carmelo anthony',
  'carmen electra',
  'carmen miranda',
  'carneades',
  'carol i of romania',
  'carol ii of romania',
  'carol reed',
  'carol w. greider',
  'carola häggkvist',
  'carole king',
  'carole lombard',
  'carolina klüft',
  'caroline herschel',
  'caroline of ansbach',
  'caroline wozniacki',
  'caroline, princess of hanover',
  'carrie fisher',
  'carrie underwood',
  'carrie-anne moss',
  'carrot top',
  'carus',
  'cary grant',
  'casey affleck',
  'casey stoner',
  'casimir i the restorer',
  'casimir iii the great',
  'casimir iv jagiellon',
  'caspar david friedrich',
  'cassander',
  'cassiodorus',
  'cassius dio',
  'caster semenya',
  'cat stevens',
  'cate blanchett',
  'catherine ashton',
  "catherine de' medici",
  'catherine deneuve',
  'catherine howard',
  'catherine i of russia',
  'catherine of alexandria',
  'catherine of aragon',
  'catherine of siena',
  'catherine of valois',
  'catherine parr',
  'catherine the great',
  'catherine zeta-jones',
  'catherine, duchess of cambridge',
  'cathy freeman',
  'catiline',
  'cato the elder',
  'cato the younger',
  'catullus',
  'cecil b. demille',
  'cecil rhodes',
  'cecilia bartoli',
  'cédric carrasso',
  'cedric the entertainer',
  'cee lo green',
  'celâl bayar',
  'celeste holm',
  'celia cruz',
  'celine dion',
  'cemal gürsel',
  'césar azpilicueta',
  'césar cielo',
  'césar cui',
  'césar franck',
  'césar milstein',
  'césar pelli',
  'césar vallejo',
  'cesare beccaria',
  'cesare borgia',
  'cesare lombroso',
  'cesare maldini',
  'cesare pavese',
  'cesare prandelli',
  'cesária évora',
  'cesc fàbregas',
  'cevdet sunay',
  'chace crawford',
  'chad kroeger',
  'chad michael murray',
  'chadli bendjedid',
  'chagatai khan',
  'chaim herzog',
  'chaim soutine',
  'chaim weizmann',
  'chaka khan',
  'chanakya',
  'chandragupta maurya',
  'chandrika kumaratunga',
  'chang myon',
  'channing tatum',
  'charibert i',
  'charlemagne',
  'charlene, princess of monaco',
  'charles albert gobat',
  'charles albert of sardinia',
  'charles augustin sainte-beuve',
  'charles aznavour',
  'charles babbage',
  'charles barkley',
  'charles baudelaire',
  'charles borromeo',
  'charles brenton huggins',
  'charles bronson',
  'charles bukowski',
  'charles cornwallis, 1st marquess cornwallis',
  'charles curtis',
  'charles darwin',
  "charles de batz-castelmore d'artagnan",
  'charles de gaulle',
  'charles dickens',
  'charles durning',
  'charles édouard guillaume',
  'charles edward stuart',
  'charles fourier',
  'charles francis richter',
  'charles g. dawes',
  'charles george gordon',
  'charles glover barkla',
  'charles goodyear',
  'charles gounod',
  'charles greeley abbot',
  'charles grey, 2nd earl grey',
  'charles hard townes',
  'charles hermite',
  'charles i of austria',
  'charles i of england',
  'charles i of hungary',
  'charles i of naples',
  'charles ii of england',
  'charles ii of spain',
  'charles iii of spain',
  'charles iv of france',
  'charles iv of spain',
  'charles iv, holy roman emperor',
  'charles ives',
  'charles ix of france',
  'charles ix of sweden',
  'charles j. pedersen',
  'charles k. kao',
  'charles laughton',
  'charles le brun',
  'charles lindbergh',
  'charles louis alphonse laveran',
  'charles lucien bonaparte',
  'charles lyell',
  'charles m. schulz',
  'charles manson',
  'charles martel',
  'charles maurice de talleyrand-périgord',
  'charles messier',
  'charles mingus',
  'charles nicolle',
  'charles perrault',
  'charles pic',
  'charles rennie mackintosh',
  'charles richet',
  'charles scott sherrington',
  'charles simonyi',
  'charles taylor (liberian politician)',
  'charles taze russell',
  'charles the bald',
  'charles the bold',
  'charles the fat',
  'charles the simple',
  'charles thomson rees wilson',
  'charles trenet',
  'charles v of france',
  'charles v, holy roman emperor',
  'charles vi of france',
  'charles vi, holy roman emperor',
  'charles vii of france',
  'charles vii, holy roman emperor',
  'charles viii of france',
  'charles viii of sweden',
  'charles w. fairbanks',
  'charles watson-wentworth, 2nd marquess of rockingham',
  'charles x gustav of sweden',
  'charles x of france',
  'charles xi of sweden',
  'charles xii of sweden',
  'charles xiii of sweden',
  'charles xiv john of sweden',
  'charles xv of sweden',
  'charles-augustin de coulomb',
  'charles-marie widor',
  'charles-valentin alkan',
  'charles, count of valois',
  'charles, duke of orléans',
  'charles, prince of wales',
  'charlie chaplin',
  'charlie kaufman',
  'charlie parker',
  'charlie sheen',
  'charlie watts',
  'charlize theron',
  'charlotte brontë',
  'charlotte corday',
  'charlotte perrelli',
  'charlotte rampling',
  'charlotte, grand duchess of luxembourg',
  'charlton heston',
  'chauncey billups',
  'chavela vargas',
  'chazz palminteri',
  'che guevara',
  'cheech marin',
  'chen guangcheng',
  'chen ning yang',
  'chen shui-bian',
  'cher',
  'cheryl cole',
  'chester a. arthur',
  'chester bennington',
  'chester w. nimitz',
  'chet atkins',
  'chet baker',
  'chiang ching-kuo',
  'chiang kai-shek',
  'chick corea',
  'chief seattle',
  'childebert i',
  'childebert ii',
  'childebert iii',
  'childeric ii',
  'childeric iii',
  'chilperic i',
  'chilperic ii',
  'chinedu obasi',
  'chinghiz aitmatov',
  'chinua achebe',
  'chiune sugihara',
  'chlodio',
  'chlodomer',
  'chlodwig, prince of hohenlohe-schillingsfürst',
  'chloë grace moretz',
  'chloë sevigny',
  'chlothar i',
  'chlothar ii',
  'chlothar iii',
  'choi kyu-hah',
  'choummaly sayasone',
  'chow yun-fat',
  'chrétien de troyes',
  'chris benoit',
  'chris bosh',
  'chris brown (american entertainer)',
  'chris colfer',
  'chris columbus (filmmaker)',
  'chris cooper (actor)',
  'chris cornell',
  'chris diamantopoulos',
  'chris eagles',
  'chris evans (actor)',
  'chris evert',
  'chris hemsworth',
  'chris hoy',
  'chris jericho',
  'chris martin',
  "chris o'donnell",
  'chris paul',
  'chris penn',
  'chris pine',
  'chris rock',
  'chris smalling',
  'chris tucker',
  'chris watson',
  'christa wolf',
  'christiaan barnard',
  'christiaan eijkman',
  'christiaan huygens',
  'christian (wrestler)',
  'christian abbiati',
  'christian b. anfinsen',
  'christian bale',
  'christian de duve',
  'christian dior',
  'christian doppler',
  'christian eriksen',
  'christian goldbach',
  'christian heinrich friedrich peters',
  'christian i of denmark',
  'christian ii of denmark',
  'christian iii of denmark',
  'christian iv of denmark',
  'christian ix of denmark',
  'christian karembeu',
  'christian klien',
  'christian lorenz',
  'christian lous lange',
  'christian maggio',
  'christian morgenstern',
  'christian panucci',
  'christian poulsen',
  'christian slater',
  'christian v of denmark',
  'christian vi of denmark',
  'christian vieri',
  'christian vii of denmark',
  'christian viii of denmark',
  'christian wilhelmsson',
  'christian wolff (philosopher)',
  'christian wulff',
  'christian x of denmark',
  'christian ziege',
  'christiane nüsslein-volhard',
  'christijan albers',
  'christina aguilera',
  'christina applegate',
  'christina ricci',
  'christina, queen of sweden',
  'christine de pizan',
  'christine lagarde',
  'christoph martin wieland',
  'christoph metzelder',
  'christoph schneider',
  'christoph waltz',
  'christoph willibald gluck',
  'christophe lemaitre',
  'christopher a. pissarides',
  'christopher a. sims',
  'christopher clavius',
  'christopher columbus',
  'christopher hitchens',
  'christopher lambert',
  'christopher lee',
  'christopher lloyd',
  'christopher marlowe',
  'christopher nolan',
  'christopher paolini',
  'christopher plummer',
  'christopher reeve',
  'christopher tolkien',
  'christopher walken',
  'christopher wolstenholme',
  'christopher wren',
  'chrysippus',
  'chuck berry',
  'chuck norris',
  'chuck palahniuk',
  'chuck schuldiner',
  'chuck yeager',
  'chūichi nagumo',
  'chulalongkorn',
  'chun doo-hwan',
  'ciara',
  'cicero',
  'cicinho',
  'cillian murphy',
  'cimabue',
  'cimon',
  'cincinnatus',
  'cindy crawford',
  'ciprian marica',
  'claire danes',
  'claire forlani',
  'clara schumann',
  'clara zetkin',
  'clare of assisi',
  'clarence seedorf',
  'clark gable',
  'claude adrien helvétius',
  'claude bernard',
  'claude berri',
  'claude chabrol',
  'claude cohen-tannoudji',
  'claude debussy',
  'claude henri de rouvroy, comte de saint-simon',
  'claude jade',
  'claude joseph rouget de lisle',
  'claude lelouch',
  'claude lévi-strauss',
  'claude lorrain',
  'claude makélélé',
  'claude monet',
  'claude of france',
  'claude shannon',
  'claude simon',
  'claudette colbert',
  'claudia cardinale',
  'claudia schiffer',
  'claudio abbado',
  'claudio caniggia',
  'claudio lópez (footballer)',
  'claudio marchisio',
  'claudio monteverdi',
  'claudio pizarro',
  'claudio ranieri',
  'cláudio taffarel',
  'claudius',
  'claudius gothicus',
  'claus von stauffenberg',
  'cleanthes',
  'cleisthenes',
  'clemens brentano',
  'clemens fritz',
  'clement attlee',
  'clément marot',
  'clement of alexandria',
  'clement of ohrid',
  'cleomenes i',
  'cleon',
  'cleopatra',
  'cleopatra i syra',
  'cleopatra ii of egypt',
  'cleopatra iii of egypt',
  'cliff burton',
  'cliff richard',
  'cliff robertson',
  'clifford d. simak',
  'clifford geertz',
  'clifford shull',
  'clint dempsey',
  'clint eastwood',
  'clint mansell',
  'clinton davisson',
  'clive barker',
  'clive granger',
  'clive owen',
  'clodius albinus',
  'clovis i',
  'clovis ii',
  'clovis iv',
  'clyde drexler',
  'clyde tombaugh',
  'cm punk',
  'cnut the great',
  'cobie smulders',
  'coco chanel',
  'coenraad jacob temminck',
  'colbie caillat',
  'cole porter',
  'colette',
  'colin farrell',
  'colin firth',
  'colin greenwood',
  'colin maclaurin',
  'colin mcrae',
  'colin powell',
  'colleen mccullough',
  'coloman, king of hungary',
  'colonel sanders',
  'columba',
  'commodus',
  'comte de lautréamont',
  "conan o'brien",
  'conchita martínez',
  'condoleezza rice',
  'confucius',
  'connie francis',
  'connie nielsen',
  'conrad bain',
  'conrad gessner',
  'conrad i of germany',
  'conrad ii, holy roman emperor',
  'conrad iii of germany',
  'conrad iv of germany',
  'constance, queen of sicily',
  'constans',
  'constans ii',
  'constantin brâncuși',
  'constantin fehrenbach',
  'constantin stanislavski',
  'constantine i of greece',
  'constantine ii (emperor)',
  'constantine ii of greece',
  'constantine iii (byzantine emperor)',
  'constantine iv',
  'constantine ix monomachos',
  'constantine p. cavafy',
  'constantine the great',
  'constantine v',
  'constantine vi',
  'constantine vii',
  'constantine viii',
  'constantine x doukas',
  'constantine xi palaiologos',
  'constantius chlorus',
  'constantius ii',
  'constantius iii',
  'coolio',
  'corazon aquino',
  'corbin bleu',
  'cordell hull',
  'corey taylor',
  'cormac mccarthy',
  'corneille heymans',
  'cornelia funke',
  'cornelius nepos',
  'corry brokken',
  'cory doctorow',
  'cory monteith',
  "cosimo de' medici",
  "cosimo i de' medici, grand duke of tuscany",
  "cosimo ii de' medici, grand duke of tuscany",
  'cosmin contra',
  'costa-gavras',
  'costas simitis',
  'count basie',
  'count franz conrad von hötzendorf',
  'courteney cox',
  'courtney love',
  'craig bellamy',
  'craig david',
  'craig gordon',
  'craig mello',
  'craig venter',
  'craterus',
  'crazy horse',
  'crispin glover',
  'criss angel',
  'cristian chivu',
  'cristian riveros',
  'cristian zaccardo',
  'cristiano lucarelli',
  'cristiano ronaldo',
  'cristina fernández de kirchner',
  'critias',
  'croesus',
  'crown prince naruhito',
  'ctesias',
  'ctesibius',
  'cuauhtémoc',
  'cuauhtémoc blanco',
  'cuba gooding, jr.',
  'curtis mayfield',
  'cyaxares the great',
  'cybill shepherd',
  'cyd charisse',
  'cyndi lauper',
  'cynthia nixon',
  'cyprian',
  'cyrano de bergerac',
  'cyril norman hinshelwood',
  'cyril of alexandria',
  'cyril of jerusalem',
  'cyrus i',
  'cyrus the great',
  'cyrus the younger',
  'cyrus vance',
  'czesław miłosz',
  'd. b. cooper',
  'd. h. lawrence',
  'd. w. griffith',
  'daddy yankee',
  'dado pršo',
  'dag hammarskjöld',
  'dagobert i',
  'dagobert iii',
  'dakota fanning',
  'dale carnegie',
  'dale t. mortensen',
  'dalia grybauskaitė',
  'dalida',
  'damian marley',
  'damien duff',
  'damien hirst',
  'damon albarn',
  'damon hill',
  'dan aykroyd',
  'dan brown',
  'dan castellaneta',
  'dan quayle',
  'dan shechtman',
  'dan simmons',
  'dana delany',
  'dana international',
  'danica patrick',
  'daniel',
  'daniel agger',
  'daniel alves',
  'daniel arap moi',
  'daniel auber',
  'daniel auteuil',
  'daniel barenboim',
  'daniel bernoulli',
  'daniel bovet',
  'daniel brühl',
  'daniel c. tsui',
  'daniel carleton gajdusek',
  'daniel cohn-bendit',
  'daniel craig',
  'daniel d. tompkins',
  'daniel dae kim',
  'daniel day-lewis',
  'daniel defoe',
  'daniel dennett',
  'daniel gabriel fahrenheit',
  'daniel güiza',
  'daniel jarque',
  'daniel kahneman',
  'daniel libeskind',
  'daniel mcfadden',
  'daniel nathans',
  'daniel nestor',
  'daniel of moscow',
  'daniel ortega',
  'daniel passarella',
  'daniel radcliffe',
  'daniel ricciardo',
  'daniel schneidermann',
  'daniel sturridge',
  'daniel van buyten',
  'daniela hantuchová',
  'daniele bonera',
  'daniele de rossi',
  'daniella monet',
  'danielle steel',
  'daniil kharms',
  'danijel pranjić',
  'danilo türk',
  'dannii minogue',
  'danny (footballer)',
  'danny aiello',
  'danny boyle',
  'danny devito',
  'danny elfman',
  'danny glover',
  'danny kaye',
  'danny murphy (footballer born 1977)',
  'danny trejo',
  'danny welbeck',
  'dante alighieri',
  'dante gabriel rossetti',
  'daphne du maurier',
  'darijo srna',
  'darin (singer)',
  'dario fo',
  'dario šimić',
  'darius i',
  'darius ii',
  'darius iii',
  'darius milhaud',
  'daron malakian',
  'darren aronofsky',
  'darren bent',
  'darren criss',
  'darren fletcher',
  'darron gibson',
  'daryl hannah',
  'daryl sabara',
  'dashiell hammett',
  'date masamune',
  'dave batista',
  'dave brubeck',
  'dave gahan',
  'dave grohl',
  'dave murray (musician)',
  'dave mustaine',
  'david',
  'david alaba',
  'david albelda',
  'david alfaro siqueiros',
  'david archuleta',
  'david arquette',
  'david attenborough',
  'david baltimore',
  'david beckham',
  'david ben-gurion',
  'david bisbal',
  'david bohm',
  'david boreanaz',
  'david bowie',
  'david brewster',
  'david bryan',
  'david c. jewitt',
  'david cameron',
  'david carradine',
  'david caruso',
  'david cook (singer)',
  'david copperfield (illusionist)',
  'david coulthard',
  'david coverdale',
  'david cronenberg',
  'david dacko',
  'david duchovny',
  'david ferrer',
  'david fincher',
  'david gilmour',
  'david gross',
  'david guetta',
  'david h. hubel',
  'david hasselhoff',
  'david henrie',
  'david hilbert',
  'david hume',
  'david i of scotland',
  'david ii of scotland',
  'david irving',
  'david iv of georgia',
  'david j. wineland',
  'david james (footballer)',
  'david jarolím',
  'david lean',
  'david lee (physicist)',
  'david letterman',
  'david livingstone',
  'david lloyd george',
  'david luiz',
  'david lynch',
  'david miliband',
  'david morse (actor)',
  'david moyes',
  'david nalbandian',
  'david niven',
  'david o. selznick',
  'davíð oddsson',
  'david odonkor',
  'david oistrakh',
  'david paterson',
  'david petraeus',
  'david pizarro',
  'david ricardo',
  'david robinson (basketball)',
  'david rozehnal',
  'david rudisha',
  'david schwimmer',
  'david scott',
  'david seaman',
  'david silva',
  'david spade',
  'david strathairn',
  'david suazo',
  'david suchet',
  'david tennant',
  'david thewlis',
  'david trezeguet',
  'david trimble',
  'david villa',
  'david wenham',
  'davide santon',
  'davor šuker',
  'davy crockett',
  'dayana mendoza',
  'dayron robles',
  'deadmau5',
  'dean acheson',
  'dean koontz',
  'dean martin',
  'debbie harry',
  'debbie reynolds',
  'debby ryan',
  'deborah kerr',
  'debra messing',
  'debra winger',
  'decebalus',
  'decimus junius brutus albinus',
  'decius',
  'deco',
  'deepika padukone',
  'dejan savićević',
  'dejan stanković',
  'delta goodrem',
  'demba ba',
  'demetrio albertini',
  'demetris christofias',
  'demetrius i of macedon',
  'demetrius i soter',
  'demetrius ii nicator',
  'demetrius vikelas',
  'demi lovato',
  'demi moore',
  'demis roussos',
  'democritus',
  'demosthenes',
  'demy de zeeuw',
  'den (pharaoh)',
  'deng xiaoping',
  'denílson pereira neves',
  'denis',
  'denis diderot',
  'denis law',
  'denis of portugal',
  'denis papin',
  'denis sassou nguesso',
  'denise richards',
  'dennis aogo',
  'dennis bergkamp',
  'dennis gabor',
  'dennis hopper',
  'dennis quaid',
  'dennis ritchie',
  'dennis rodman',
  'dennis rommedahl',
  'dennis tito',
  'denny hulme',
  'denzel washington',
  'denzil douglas',
  'deodoro da fonseca',
  'derek barton',
  'derek jacobi',
  'derek walcott',
  'deron williams',
  'derrick rose',
  'deryck whibley',
  'dési bouterse',
  'desiderius',
  'desiderius erasmus',
  'désirée clary',
  'desmond tutu',
  'dev patel',
  'devon aoki',
  'diadumenian',
  'dian fossey',
  'diana ross',
  'diana, princess of wales',
  'diane keaton',
  'diane kruger',
  'diane lane',
  'dianna agron',
  'dianne wiest',
  'dick advocaat',
  'dick cheney',
  'dida (footballer born 1973)',
  'didi (footballer)',
  'didier deschamps',
  'didier drogba',
  'didier zokora',
  'didius julianus',
  'dido (queen of carthage)',
  'dido (singer)',
  'diego benaglio',
  'diego cavalieri',
  'diego contento',
  'diego de almagro',
  'diego forlán',
  'diego godín',
  'diego lugano',
  'diego maradona',
  'diego milito',
  'diego pérez (footballer)',
  'diego ribas da cunha',
  'diego rivera',
  'diego velázquez',
  'dieter bohlen',
  'dieterich buxtehude',
  'dietmar hamann',
  'dietrich bonhoeffer',
  'dietrich fischer-dieskau',
  'dileita mohamed dileita',
  'dilma rousseff',
  'dima bilan',
  'dimitar berbatov',
  'dimitris p. kraniotis',
  'dimitris salpingidis',
  'dinara safina',
  'diniyar bilyaletdinov',
  'dino buzzati',
  'dino de laurentiis',
  'dino zoff',
  'diocletian',
  'diodorus siculus',
  'diodotus tryphon',
  'diogenes laërtius',
  'diogenes of apollonia',
  'diogenes of sinope',
  'dionne warwick',
  'dionysius exiguus',
  'dionysius of halicarnassus',
  'dionysius the areopagite',
  'diophantus',
  'diosdado macapagal',
  'dirk bogarde',
  'dirk kuyt',
  'dirk nowitzki',
  'dita von teese',
  'dizzy gillespie',
  'dj bobo',
  'dj shadow',
  'djalma santos',
  'django reinhardt',
  'djedefre',
  'djer',
  'djet',
  'djibril cissé',
  'djimon hounsou',
  'djoser',
  'dmitri mendeleev',
  'dmitri shostakovich',
  'dmitri torbinski',
  'dmitriy ustinov',
  'dmitry donskoy',
  'dmitry kabalevsky',
  'dmitry medvedev',
  'dmitry tursunov',
  'dmx (rapper)',
  'dmytro chygrynskiy',
  'do-aklin',
  'doda (singer)',
  'dokka umarov',
  'dolly parton',
  'dolores ibárruri',
  'dolph lundgren',
  'domenico cimarosa',
  'domenico criscito',
  'domenico ghirlandaio',
  'domenico modugno',
  'domenico scarlatti',
  'dominic howard',
  'dominic monaghan',
  'dominic purcell',
  'dominika cibulková',
  'dominique de villepin',
  'dominique strauss-kahn',
  'domitian',
  'don cheadle',
  'don delillo',
  'don johnson',
  'don mclean',
  'don rickles',
  'don rosa',
  'donald a. glaser',
  'donald bradman',
  'donald j. cram',
  'donald knuth',
  'donald pleasence',
  'donald rumsfeld',
  'donald sutherland',
  'donald trump',
  'donald tusk',
  'donatello',
  'donato bramante',
  'doni (footballer)',
  'donna reed',
  'donna summer',
  'donnie yen',
  'doris day',
  'doris lessing',
  'doris leuthard',
  'dorothea lange',
  'dorothy hodgkin',
  'dost mohammad khan',
  'doug savant',
  'douglas adams',
  'douglas engelbart',
  'douglas fairbanks',
  'douglas haig, 1st earl haig',
  'douglas hyde',
  'douglas macarthur',
  'douglas osheroff',
  'douglass north',
  'doutzen kroes',
  'dr. alban',
  'dr. dre',
  'dr. seuss',
  'draco (lawgiver)',
  'dragan đokanović',
  'dragan džajić',
  'dragan stojković',
  'drake (entertainer)',
  'dražen petrović',
  'drew barrymore',
  'du fu',
  'duccio',
  'dudley r. herschbach',
  'duff mckagan',
  'duffy (singer)',
  'duke ellington',
  'duncan edwards',
  'duncan i of scotland',
  'dunga',
  'duns scotus',
  'dustin hoffman',
  'dusty springfield',
  'dwayne johnson',
  'dwight d. eisenhower',
  'dwight f. davis',
  'dwight howard',
  'dwight yorke',
  'dwyane wade',
  'dylan thomas',
  'dzhokhar dudayev',
  'dziga vertov',
  'e. donnall thomas',
  'e. e. cummings',
  'e. h. carr',
  'e. m. forster',
  'e. o. wilson',
  'e. t. a. hoffmann',
  'eadred',
  'eadweard muybridge',
  'eadwig',
  'éamon de valera',
  'earl warren',
  'earl wilbur sutherland, jr.',
  'eartha kitt',
  'eazy-e',
  'eckhart tolle',
  'ed gein',
  'ed harris',
  'ed miliband',
  "ed o'brien",
  'ed sheeran',
  'ed westwick',
  'ed wood',
  'eddie fenech adami',
  'eddie guerrero',
  'eddie irvine',
  'eddie izzard',
  'eddie murphy',
  'eddie van halen',
  'eddie vedder',
  'eddy merckx',
  'eden hazard',
  'edgar adrian, 1st baron adrian',
  'edgar allan poe',
  'edgar cayce',
  'edgar davids',
  'edgar degas',
  'edgar f. codd',
  'edgar mitchell',
  'edgar rice burroughs',
  'edgar the ætheling',
  'edgar the peaceful',
  'edgar wallace',
  'edgard varèse',
  'edge (wrestler)',
  'edin džeko',
  'edinson cavani',
  'édith cresson',
  'édith piaf',
  'edith stein',
  'edmílson (footballer born 1976)',
  'edmond h. fischer',
  'edmond halley',
  'edmond rostand',
  'edmondo de amicis',
  'edmund barton',
  'edmund burke',
  'edmund hillary',
  'edmund husserl',
  'edmund i',
  'edmund ironside',
  'edmund phelps',
  'edmund spenser',
  'edmund stoiber',
  'édouard balladur',
  'édouard daladier',
  'édouard lalo',
  'édouard manet',
  'edsger w. dijkstra',
  'edson braafheid',
  'eduard bernstein',
  'eduard buchner',
  'eduard khil',
  'eduard kokoity',
  'eduard limonov',
  'eduard mörike',
  'eduard shevardnadze',
  'eduard von böhm-ermolli',
  'eduardo carvalho',
  'eduardo chillida',
  'eduardo da silva',
  'eduardo duhalde',
  'eduardo frei montalva',
  'eduardo frei ruiz-tagle',
  'eduardo galeano',
  'edvard beneš',
  'edvard grieg',
  'edvard munch',
  'edward adelbert doisy',
  'edward albee',
  'edward asner',
  'edward b. lewis',
  'edward burne-jones',
  'edward burnett tylor',
  'edward c. prescott',
  'edward calvin kendall',
  'edward cave',
  'edward drinker cope',
  'edward elgar',
  'edward emerson barnard',
  'edward furlong',
  'edward g. robinson',
  'edward gibbon',
  'edward heath',
  'edward higgins white',
  'edward hopper',
  'edward i of england',
  'edward ii of england',
  'edward iii of england',
  'edward iv of england',
  'edward james olmos',
  'edward jenner',
  'edward lawrie tatum',
  'edward lear',
  'edward mills purcell',
  'edward norton',
  'edward norton lorenz',
  'edward rydz-śmigły',
  'edward said',
  'edward sapir',
  'edward smith (sea captain)',
  'edward smith-stanley, 14th earl of derby',
  'edward teller',
  'edward the confessor',
  'edward the elder',
  'edward the martyr',
  'edward thorndike',
  'edward v of england',
  'edward vi of england',
  'edward victor appleton',
  'edward vii',
  'edward viii',
  'edward witten',
  'edward, king of portugal',
  'edward, the black prince',
  'edwin g. krebs',
  'edwin hubble',
  'edwin mcmillan',
  'edwin moses',
  'edwin van der sar',
  'eero saarinen',
  'egbert of wessex',
  'egon krenz',
  'egon schiele',
  'ehud barak',
  'ehud olmert',
  'ei-ichi negishi',
  'eiður guðjohnsen',
  'eiichiro oda',
  'einar gerhardsen',
  'einhard',
  'eisaku satō',
  'ejnar hertzsprung',
  'el cid',
  'el greco',
  'el hadji diouf',
  'el lissitzky',
  'elagabalus',
  'elano',
  'elbridge gerry',
  'eldar gasimov',
  'eleanor of aquitaine',
  'eleanor of provence',
  'eleanor roosevelt',
  'eleftherios venizelos',
  'elena ceaușescu',
  'elena dementieva',
  'elena gheorghe',
  'elena paparizou',
  'elena vesnina',
  'elfriede jelinek',
  'eli wallach',
  'elia kazan',
  'elias canetti',
  'elias james corey',
  'elias lönnrot',
  'élie ducommun',
  'élie metchnikoff',
  'elie wiesel',
  'eliezer ben-yehuda',
  'elif şafak',
  'elihu root',
  'elijah',
  'elijah wood',
  'elinor ostrom',
  'elio di rupo',
  'eliot spitzer',
  'eliphas levi',
  'elisa bonaparte',
  'elisabeth of france (1602–1644)',
  'elisabeth schwarzkopf',
  'elisabeth shue',
  'elisha',
  'elisha cuthbert',
  'eliza dushku',
  'elizabeth (biblical figure)',
  'elizabeth banks',
  'elizabeth barrett browning',
  'elizabeth báthory',
  'elizabeth blackburn',
  'elizabeth gaskell',
  'elizabeth hurley',
  'elizabeth i of england',
  'elizabeth ii',
  'elizabeth mitchell',
  'elizabeth of hungary',
  'elizabeth of russia',
  'elizabeth of york',
  'elizabeth taylor',
  'elizabeth woodville',
  'eljero elia',
  'ella fitzgerald',
  'elle fanning',
  'elle macpherson',
  'ellen barkin',
  'ellen burstyn',
  'ellen degeneres',
  'ellen johnson sirleaf',
  'ellen page',
  'ellen pompeo',
  'ellie goulding',
  'elliott smith',
  'elmer bernstein',
  'elsa morante',
  'elton john',
  'elton mayo',
  'elvira lindo',
  'elvis costello',
  'elvis presley',
  'emanuel lasker',
  'emanuel swedenborg',
  'emanuele giaccherini',
  'emeric, king of hungary',
  'emerson ferreira da rosa',
  'emerson fittipaldi',
  'emil adolf von behring',
  'emil boc',
  'emil cioran',
  'emil constantinescu',
  'emil hácha',
  'emil jannings',
  'emil kraepelin',
  'emil nolde',
  'emil theodor kocher',
  'emil zátopek',
  'emile berliner',
  'émile borel',
  'émile durkheim',
  'émile friant',
  'emile heskey',
  'emile hirsch',
  'émile lahoud',
  'émile loubet',
  'emile verhaeren',
  'émile zola',
  'emilia fox',
  'emilia plater',
  'emiliano insúa',
  'emiliano zapata',
  'emilie de ravin',
  'émilie du châtelet',
  'emilio aguinaldo',
  'emilio butragueño',
  'emilio estevez',
  'emilio g. segrè',
  'emílio garrastazu médici',
  'emilio salgari',
  'emily blunt',
  'emily brontë',
  'emily browning',
  'emily deschanel',
  'emily dickinson',
  'emily greene balch',
  'emily osment',
  'emina jahović',
  'eminem',
  'emir kusturica',
  'emma bunton',
  'emma goldman',
  'emma roberts',
  'emma stone',
  'emma thompson',
  'emma watson',
  'emmanuel adebayor',
  'emmanuel eboué',
  'emmanuel frimpong',
  'emmanuel joseph sieyès',
  'emmanuel lévinas',
  'emmanuel petit',
  'emmanuelle béart',
  'emmeline pankhurst',
  'emmerich kálmán',
  'emmy noether',
  'emmy rossum',
  'emomalii rahmon',
  'empedocles',
  'emperor annei',
  'emperor gaozu of han',
  'emperor itoku',
  'emperor jimmu',
  'emperor kōmei',
  'emperor meiji',
  'emperor norton',
  'emperor suizei',
  'emperor taishō',
  'emperor taizong of tang',
  'emperor wu of han',
  'empress dowager cixi',
  'empress elisabeth of austria',
  'empress matilda',
  'empress michiko',
  'emre belözoğlu',
  'enda kenny',
  'endre ady',
  'engelbert dollfuss',
  'engelbert humperdinck',
  'engelbert humperdinck (singer)',
  'enheduanna',
  'enid blyton',
  'ennio morricone',
  'ennius',
  'enoch (ancestor of noah)',
  'enrico berlinguer',
  'enrico caruso',
  'enrico dandolo',
  'enrico de nicola',
  'enrico fermi',
  'enrique granados',
  'enrique iglesias',
  'enrique peña nieto',
  'enver hoxha',
  'enver pasha',
  'enya',
  'enzo bearzot',
  'enzo ferrari',
  'enzo francescoli',
  'eoin colfer',
  'epaminondas',
  'ephraim katzir',
  'ephrem the syrian',
  'epictetus',
  'epicurus',
  'erasmus darwin',
  'eratosthenes',
  'eren derdiyok',
  'erhard milch',
  'éric abidal',
  'eric allin cornell',
  'eric bana',
  'eric bloodaxe',
  'éric boullier',
  'eric burdon',
  'eric cantona',
  'eric clapton',
  'eric dane',
  'eric hobsbawm',
  'eric idle',
  'eric ix of sweden',
  'eric kandel',
  'eric maskin',
  'eric of pomerania',
  'eric prydz',
  'eric roberts',
  'éric rohmer',
  'eric s. raymond',
  'eric saade',
  'eric schmidt',
  'eric xiv of sweden',
  'erica durance',
  'erich fromm',
  'erich hartmann',
  'erich honecker',
  'erich kästner',
  'erich ludendorff',
  'erich maria remarque',
  'erich raeder',
  'erich von däniken',
  'erich von falkenhayn',
  'erich von manstein',
  'erich von stroheim',
  'erich wolfgang korngold',
  'erik axel karlfeldt',
  'erik erikson',
  'erik mongrain',
  'erik satie',
  'erik the red',
  'ernest bai koroma',
  'ernest borgnine',
  'ernest hemingway',
  'ernest renan',
  'ernest rutherford',
  'ernest shackleton',
  'ernest walton',
  'ernesto geisel',
  'ernesto sabato',
  'ernesto teodoro moneta',
  'ernesto zedillo',
  'ernests gulbis',
  'ernő rubik',
  'ernst abbe',
  'ernst barlach',
  'ernst bloch',
  'ernst boris chain',
  'ernst busch (military)',
  'ernst cassirer',
  'ernst haeckel',
  'ernst happel',
  'ernst jünger',
  'ernst kaltenbrunner',
  'ernst kummer',
  'ernst ludwig kirchner',
  'ernst mach',
  'ernst mayr',
  'ernst otto fischer',
  'ernst röhm',
  'ernst ruska',
  'ernst thälmann',
  'ernst zermelo',
  'eros ramazzotti',
  'errico malatesta',
  'errol flynn',
  'erskine caldwell',
  'ertuğrul',
  'erwin neher',
  'erwin rommel',
  'erwin schrödinger',
  'erwin von witzleben',
  'erykah badu',
  'esarhaddon',
  'esau',
  'essam sharaf',
  'esteban cambiasso',
  'esteban granero',
  'esther',
  'ethan hawke',
  'étienne bonnot de condillac',
  'étienne geoffroy saint-hilaire',
  'etta james',
  'euclid',
  'eudoxus of cnidus',
  'eugen bleuler',
  "eugen d'albert",
  'eugène boudin',
  'eugene cernan',
  'eugène de beauharnais',
  'eugène delacroix',
  'eugène ionesco',
  'eugene merle shoemaker',
  "eugene o'neill",
  "eugène terre'blanche",
  'eugène viollet-le-duc',
  'eugene wigner',
  'eugenio montale',
  'eumenes',
  'eumenes ii',
  'euric',
  'eurico gaspar dutra',
  'euripides',
  'eusébio',
  'eusebius',
  'eutropius (historian)',
  'euzebiusz smolarek',
  'eva braun',
  'eva green',
  'eva herzigová',
  'eva longoria',
  'eva marie saint',
  'eva mendes',
  'eva perón',
  'eva rivas',
  'evan bourne',
  'evan rachel wood',
  'evander holyfield',
  'evangeline lilly',
  'evangelista torricelli',
  'evanna lynch',
  'évariste galois',
  'eveline widmer-schlumpf',
  'evelyn waugh',
  'éver banega',
  'evgeni plushenko',
  'evliya çelebi',
  'evo morales',
  'evonne goolagong cawley',
  'ewan mcgregor',
  'eyvind johnson',
  'ezekiel',
  'ezequiel garay',
  'ezequiel lavezzi',
  'ezer weizman',
  'ezra',
  'ezra pound',
  'f. murray abraham',
  'f. scott fitzgerald',
  'f. w. de klerk',
  'f. w. murnau',
  'fabian cancellara',
  'fabian gottlieb von bellingshausen',
  'fabien barthez',
  'fábio aurélio',
  'fabio borini',
  'fabio cannavaro',
  'fabio capello',
  'fábio coentrão',
  'fabio grosso',
  'fábio pereira da silva',
  'fabio quagliarella',
  'fabius maximus',
  'fabricio coloccini',
  'fabrizio de andré',
  'fahd of saudi arabia',
  'fahri korutürk',
  'faisal i of iraq',
  'faisal ii of iraq',
  'faisal of saudi arabia',
  'faith hill',
  'fakhruddin ali ahmed',
  'falco (musician)',
  'false dmitriy i',
  'famke janssen',
  'fanny ardant',
  'farah pahlavi',
  'farinelli',
  'farouk of egypt',
  'farrah fawcett',
  'fat joe',
  'father damien',
  'fatih akın',
  'fatih terim',
  'fatimah',
  'fatmir sejdiu',
  'fatos nano',
  'fats domino',
  'faure gnassingbé',
  'fausto coppi',
  'faye dunaway',
  'federica pellegrini',
  'federico balzaretti',
  'federico fellini',
  'federico franco',
  'federico garcía lorca',
  'federico macheda',
  'fedor emelianenko',
  'fedor von bock',
  'feist (singer)',
  'feliciano lópez',
  'felicity huffman',
  'felipe calderón',
  'felipe gonzález',
  'felipe massa',
  'felipe melo',
  'felipe, prince of asturias',
  'felix baumgartner',
  'felix bloch',
  'felix dzerzhinsky',
  'félix faure',
  'felix hausdorff',
  'félix houphouët-boigny',
  'felix klein',
  'felix magath',
  'felix mendelssohn',
  'felix wankel',
  'feodor chaliapin',
  'feodor felix konrad lynen',
  'feodor i of russia',
  'feodor ii of russia',
  'feodor iii of russia',
  'ferdinand buisson',
  'ferdinand de lesseps',
  'ferdinand de saussure',
  'ferdinand foch',
  'ferdinand hodler',
  'ferdinand i of austria',
  'ferdinand i of bulgaria',
  'ferdinand i of león and castile',
  'ferdinand i of portugal',
  'ferdinand i, holy roman emperor',
  'ferdinand ii of aragon',
  'ferdinand ii, holy roman emperor',
  'ferdinand iii of castile',
  'ferdinand iii, holy roman emperor',
  'ferdinand iv, king of the romans',
  'ferdinand lassalle',
  'ferdinand magellan',
  'ferdinand marcos',
  'ferdinand of romania',
  'ferdinand porsche',
  'ferdinand schörner',
  'ferdinand tönnies',
  'ferdinand vi of spain',
  'ferdinand vii of spain',
  'ferdinand von lindemann',
  'ferdinand von wrangel',
  'ferdinand von zeppelin',
  "ferdinando i de' medici, grand duke of tuscany",
  'ferdowsi',
  'ferenc gyurcsány',
  'ferenc mádl',
  'ferenc molnár',
  'ferenc puskás',
  'ferenc szálasi',
  'fergie (singer)',
  'ferhat abbas',
  'ferid murad',
  'fernand braudel',
  'fernand léger',
  'fernanda montenegro',
  'fernandel',
  'fernando alonso',
  'fernando álvarez de toledo, 3rd duke of alba',
  'fernando arrabal',
  'fernando belaúnde terry',
  'fernando botero',
  'fernando collor de mello',
  'fernando da piedade dias dos santos',
  'fernando de la rúa',
  'fernando gago',
  'fernando gonzález',
  'fernando henrique cardoso',
  'fernando hierro',
  'fernando llorente',
  'fernando lugo',
  'fernando morientes',
  'fernando muslera',
  'fernando pessoa',
  'fernando redondo',
  'fernando sor',
  'fernando torres',
  'fernando verdasco',
  'ferruccio busoni',
  'ferry corsten',
  'festus mogae',
  'fethullah gülen',
  'fibonacci',
  'fidel castro',
  'fidel v. ramos',
  'filip vujanović',
  'filippino lippi',
  'filippo brunelleschi',
  'filippo inzaghi',
  'filippo lippi',
  'filippo tommaso marinetti',
  'finn e. kydland',
  'fiona apple',
  'flavia pennetta',
  'flavius aetius',
  'flavius valerius severus',
  'flea (musician)',
  'flo rida',
  'florence griffith-joyner',
  'florence nightingale',
  'florent malouda',
  'florentino pérez',
  'flórián albert',
  'florian mayer',
  'floriano peixoto',
  'florianus',
  'floyd landis',
  'folke bernadotte',
  'forest whitaker',
  'fouad mebazaa',
  'fouad siniora',
  'fra angelico',
  'fra bartolomeo',
  'fradique de menezes',
  'fraizer campbell',
  'fran drescher',
  'france gall',
  'france prešeren',
  'frances hodgson burnett',
  'frances mcdormand',
  'francesca schiavone',
  'francesco bartolomeo rastrelli',
  'francesco borromini',
  'francesco cavalli',
  'francesco cossiga',
  'francesco guicciardini',
  'francesco hayez',
  "francesco i de' medici, grand duke of tuscany",
  'francesco redi',
  'francesco toldo',
  'francesco totti',
  'francis bacon',
  'francis bacon (artist)',
  'francis beaufort',
  'francis crick',
  'francis de sales',
  'francis drake',
  'francis ford coppola',
  'francis fukuyama',
  'francis galton',
  'francis i of france',
  'francis i, holy roman emperor',
  'francis ii of france',
  'francis ii, holy roman emperor',
  'francis of assisi',
  'francis peyton rous',
  'francis picabia',
  'francis poulenc',
  'francis william aston',
  'francis xavier',
  'francisco de miranda',
  'francisco de orellana',
  'francisco de paula rodrigues alves',
  'francisco de quevedo',
  'francisco de zurbarán',
  'francisco franco',
  'francisco gento',
  'francisco goya',
  'francisco i. madero',
  'francisco javier rodríguez',
  'francisco macías nguema',
  'francisco pizarro',
  'francisco solano lópez',
  'francisco tárrega',
  'francisco varallo',
  'francisco vásquez de coronado',
  'franck ribéry',
  'franco alfano',
  'franco baresi',
  'franco modigliani',
  'franco zeffirelli',
  'françois arago',
  'françois bayrou',
  'françois boucher',
  'françois bozizé',
  'françois couperin',
  'françois de la rochefoucauld (writer)',
  'françois duvalier',
  'françois fillon',
  'françois guizot',
  'françois hollande',
  'françois jacob',
  'françois mauriac',
  'françois mitterrand',
  'françois ozon',
  'françois quesnay',
  'françois rabelais',
  'françois tombalbaye',
  'françois viète',
  'françois villon',
  'françois-adrien boieldieu',
  'françois-andré danican philidor',
  'françois-noël babeuf',
  'françois-rené de chateaubriand',
  'françoise barré-sinoussi',
  'françoise sagan',
  'franjo tuđman',
  'frank abagnale',
  'frank b. kellogg',
  'frank capra',
  'frank darabont',
  'frank de boer',
  'frank drake',
  'frank gehry',
  'frank herbert',
  'frank lampard',
  'frank lloyd',
  'frank lloyd wright',
  'frank macfarlane burnet',
  'frank mccourt',
  'frank miller (comics)',
  'frank oz',
  'frank p. ramsey',
  'frank rijkaard',
  'fränk schleck',
  'frank sherwood rowland',
  'frank sinatra',
  'frank wedekind',
  'frank welker',
  'frank wilczek',
  'frank zappa',
  'frank-walter steinmeier',
  'franka potente',
  'frankie muniz',
  'franklin d. roosevelt',
  'franklin pierce',
  'frans eemil sillanpää',
  'frans hals',
  'frantz fanon',
  'franz beckenbauer',
  'franz berwald',
  'franz boas',
  'franz bopp',
  'franz brentano',
  'franz grillparzer',
  'franz halder',
  'franz josef strauss',
  'franz joseph i of austria',
  'franz kafka',
  'franz lehár',
  'franz liszt',
  'franz marc',
  'franz mesmer',
  'franz müntefering',
  'franz schubert',
  'franz von papen',
  'franz werfel',
  'fred astaire',
  'fred durst',
  'fred hoyle',
  'fred thompson',
  'fred zinnemann',
  'freddie highmore',
  'freddie mercury',
  'freddie prinze, jr.',
  'frédéric auguste bartholdi',
  'frédéric bastiat',
  'frédéric chopin',
  'frédéric joliot-curie',
  'frédéric kanouté',
  'frédéric mistral',
  'frédéric passy',
  'frederick banting',
  'frederick chapman robbins',
  'frederick chiluba',
  'frederick douglass',
  'frederick forsyth',
  'frederick gowland hopkins',
  'frederick i of denmark',
  'frederick i of prussia',
  'frederick i, holy roman emperor',
  'frederick ii of denmark',
  'frederick ii, holy roman emperor',
  'frederick iii of denmark',
  'frederick iii, german emperor',
  'frederick iii, holy roman emperor',
  'frederick iv of denmark',
  'frederick ix of denmark',
  'frederick north, lord north',
  'frederick reines',
  'frederick sanger',
  'frederick soddy',
  'frederick the great',
  'frederick v of denmark',
  'frederick v, elector palatine',
  'frederick vi of denmark',
  'frederick vii of denmark',
  'frederick viii of denmark',
  'frederick william i of prussia',
  'frederick william ii of prussia',
  'frederick william iii of prussia',
  'frederick william iv of prussia',
  'frederick william, elector of brandenburg',
  'frederick winslow taylor',
  'frederik, crown prince of denmark',
  'fredric march',
  'fredrik bajer',
  'fredrik ljungberg',
  'fredrik reinfeldt',
  'freeman dyson',
  'freida pinto',
  'frida kahlo',
  'frida lyngstad',
  'fridtjof nansen',
  'friedensreich hundertwasser',
  'friedrich august kekulé von stradonitz',
  'friedrich bergius',
  'friedrich bessel',
  'friedrich carl von savigny',
  'friedrich dürrenmatt',
  'friedrich ebert',
  'friedrich engels',
  'friedrich fröbel',
  'friedrich georg wilhelm von struve',
  'friedrich gottlieb klopstock',
  'friedrich hayek',
  'friedrich hölderlin',
  'friedrich kellner',
  'friedrich mohs',
  'friedrich nietzsche',
  'friedrich paulus',
  'friedrich ratzel',
  'friedrich schiller',
  'friedrich schleiermacher',
  'friedrich von flotow',
  'friedrich wilhelm joseph schelling',
  'friedrich wöhler',
  'fritigern',
  'frits zernike',
  'fritz albert lipmann',
  'fritz haber',
  'fritz kreisler',
  'fritz lang',
  'fritz pregl',
  'fritz sauckel',
  'fritz todt',
  'fritz walter',
  'fritz zwicky',
  'frontinus',
  'fu xi',
  'fuad i of egypt',
  'fuad ii of egypt',
  'fulgencio batista',
  'fulk, king of jerusalem',
  'fuzûlî',
  'fyodor dostoyevsky',
  'fyodor tolbukhin',
  'fyodor tyutchev',
  'g. e. moore',
  'g. h. hardy',
  'g. k. chesterton',
  'g. stanley hall',
  'gaafar nimeiry',
  'gabdulkhay akhatov',
  'ğabdulla tuqay',
  'gabriel agbonlahor',
  'gabriel batistuta',
  'gabriel byrne',
  'gabriel cramer',
  'gabriel fauré',
  'gabriel garcía márquez',
  'gabriel heinze',
  'gabriel lippmann',
  'gabriel marcel',
  'gabriel milito',
  'gabriel narutowicz',
  'gabriel obertan',
  'gabriela mistral',
  'gabriela sabatini',
  "gabriele d'annunzio",
  'gabriella cilmi',
  'gabrielle giffords',
  'gackt',
  'gaël clichy',
  'gael garcía bernal',
  'gaël givet',
  'gaël monfils',
  'gaetano donizetti',
  'gaius caesar',
  'gaius cassius longinus',
  'gaius gracchus',
  'gaius julius hyginus',
  'gaius lucilius',
  'gaius maecenas',
  'gaius marius',
  'gaizka mendieta',
  'galba',
  'galeazzo ciano',
  'galen',
  'galerius',
  'galileo galilei',
  'galina vishnevskaya',
  'galla placidia',
  'gallienus',
  'gamal abdel nasser',
  'game (rapper)',
  'gao xingjian',
  'gareth bale',
  'gareth barry',
  'garret hobart',
  'garrett hedlund',
  'garrincha',
  'garry kasparov',
  'gary becker',
  'gary cahill',
  'gary coleman',
  'gary cooper',
  'gary lineker',
  'gary moore',
  'gary neville',
  'gary oldman',
  'gary sinise',
  'gary speed',
  'gaspard ii de coligny',
  'gaspard monge',
  'gaspard ulliel',
  'gaspard-gustave coriolis',
  'gaspare spontini',
  'gaston bachelard',
  'gaston doumergue',
  'gastón gaudio',
  'gaston leroux',
  'gaston thorn',
  'gautama buddha',
  'gavrila derzhavin',
  'gavrilo princip',
  'gebhard leberecht von blücher',
  'gediminas',
  'gediminas kirkilas',
  'geena davis',
  'geert wilders',
  'geir haarde',
  'gelimer',
  'gelson fernandes',
  'gemistus pletho',
  'gemma arterton',
  'gene hackman',
  'gene kelly',
  'gene roddenberry',
  'gene simmons',
  'gene wilder',
  'genevieve',
  'genghis khan',
  'gennady zyuganov',
  'gennaro gattuso',
  'genseric',
  'geoff hurst',
  'geoffrey chaucer',
  'geoffrey of monmouth',
  'geoffrey plantagenet, count of anjou',
  'geoffrey rush',
  'geoffrey wilkinson',
  'georg bednorz',
  'georg büchner',
  'georg cantor',
  'georg michaelis',
  'georg ohm',
  'georg philipp telemann',
  'georg simmel',
  'georg solti',
  'georg trakl',
  'georg von békésy',
  'georg von hertling',
  'georg von küchler',
  'georg wilhelm friedrich hegel',
  'georg wittig',
  'george a. romero',
  'george abela',
  'george akerlof',
  'george andrew olah',
  'george arliss',
  'george armstrong custer',
  'george berkeley',
  'george bernard shaw',
  'george best',
  'george biddell airy',
  'george boole',
  'george c. scott',
  'george canning',
  'george carlin',
  'george clinton (vice president)',
  'george clooney',
  'george cukor',
  'george curzon, 1st marquess curzon of kedleston',
  'george davis snell',
  'george de hevesy',
  'george e. smith',
  'george eastman',
  'george eliot',
  'george emil palade',
  'george enescu',
  'george everest',
  'george f. kennan',
  'george foreman',
  'george frideric handel',
  'george gamow',
  'george gershwin',
  'george grenville',
  'george grosz',
  'george gurdjieff',
  'george h. hitchings',
  'george h. w. bush',
  'george habash',
  'george hamilton-gordon, 4th earl of aberdeen',
  'george harrison',
  'george herbert mead',
  'george herbert, 5th earl of carnarvon',
  'george i of great britain',
  'george i of greece',
  'george ii of great britain',
  'george ii of greece',
  'george iii of the united kingdom',
  'george iv of the united kingdom',
  'george kennedy',
  'george lazenby',
  'george lucas',
  'george m. dallas',
  'george marshall',
  'george martin',
  'george maxwell richards',
  'george meade',
  'george michael',
  'george minot',
  'george orwell',
  'george paget thomson',
  'george papandreou',
  'george peppard',
  'george pólya',
  'george porter',
  'george r. r. martin',
  'george s. patton',
  'george sand',
  'george santayana',
  'george smoot',
  'george soros',
  'george stephenson',
  'george stevens',
  'george stigler',
  'george takei',
  'george tupou v',
  'george v',
  'george vancouver',
  'george vi',
  'george w. bush',
  'george wald',
  'george washington',
  'george washington carver',
  'george weah',
  'george wells beadle',
  'george westinghouse',
  'george whipple',
  'georges bataille',
  'georges bizet',
  'georges braque',
  'georges brassens',
  'georges charpak',
  'georges clemenceau',
  'georges cuvier',
  'georges danton',
  'georges de la tour',
  'georges dumézil',
  'georges j. f. köhler',
  'georges lemaître',
  'georges méliès',
  'georges perec',
  'georges pompidou',
  'georges seurat',
  'georges simenon',
  'georges-eugène haussmann',
  'georges-louis leclerc, comte de buffon',
  'georgi dimitrov',
  'georgi parvanov',
  'georgi plekhanov',
  "georgia o'keeffe",
  'georgie henley',
  'georgios papadopoulos',
  'georgios papandreou',
  'georgios samaras',
  'georgius agricola',
  'georgy gapon',
  'georgy lvov',
  'georgy zhukov',
  'gerald asamoah',
  'gerald durrell',
  'gerald edelman',
  'gerald ford',
  'geraldine chaplin',
  'geraldine page',
  "gerard 't hooft",
  'gerard butler',
  'gérard de nerval',
  'gérard debreu',
  'gérard depardieu',
  'gérard desargues',
  'gérard houllier',
  'gerard kuiper',
  'gérard philipe',
  'gerard piqué',
  'gerard way',
  'gerardo torrado',
  'gerardus mercator',
  'gerd binnig',
  'gerd kanter',
  'gerd müller',
  'gerd von rundstedt',
  'geremi njitap',
  'gerhard armauer hansen',
  'gerhard berger',
  'gerhard domagk',
  'gerhard ertl',
  'gerhard herzberg',
  'gerhard schröder',
  'gerhart hauptmann',
  'geri halliwell',
  'germaine de staël',
  'germaine greer',
  'germanicus',
  'gerolamo cardano',
  'geronimo',
  'gerrit rietveld',
  'gerry adams',
  'gerry rafferty',
  'gertrude b. elion',
  'gertrude stein',
  'gerty cori',
  'gervinho',
  'getúlio vargas',
  'géza ii of hungary',
  'géza, grand prince of the hungarians',
  'ghalib',
  'gheorghe gheorghiu-dej',
  'gheorghe hagi',
  'gherman titov',
  'giacinto facchetti',
  'giacomo barozzi da vignola',
  'giacomo casanova',
  'giacomo leopardi',
  'giacomo meyerbeer',
  'giacomo puccini',
  'giambattista vico',
  'giambologna',
  'giampaolo pazzini',
  'giampiero boniperti',
  'gian carlo menotti',
  'gian lorenzo bernini',
  'giancarlo fisichella',
  'gianfranco zola',
  'gianluca ramazzotti',
  'gianluca vialli',
  'gianluca zambrotta',
  'gianluigi buffon',
  'gianni rivera',
  'gianni rodari',
  'gianni versace',
  'gichin funakoshi',
  'gideon sundback',
  'gigliola cinquetti',
  'gilad shalit',
  'gilbert arenas',
  'gilbert du motier, marquis de lafayette',
  'gilbert gottfried',
  'gilbert n. lewis',
  'gilberto gil',
  'gilberto silva',
  'gilgamesh',
  'gilles binchois',
  'gilles deleuze',
  'gilles simon',
  'gilles villeneuve',
  'gillian anderson',
  'gina lollobrigida',
  'ginger rogers',
  'ginnifer goodwin',
  'gino bartali',
  'gioachino rossini',
  'giordano bruno',
  'giorgio armani',
  'giorgio chiellini',
  'giorgio de chirico',
  'giorgio napolitano',
  'giorgio vasari',
  'giorgione',
  'giorgos karagounis',
  'giorgos seferis',
  'giosuè carducci',
  'giotto',
  'giovani dos santos',
  'giovanni alfonso borelli',
  'giovanni battista belzoni',
  'giovanni battista pergolesi',
  'giovanni battista piranesi',
  'giovanni battista sammartini',
  'giovanni battista tiepolo',
  'giovanni bellini',
  'giovanni boccaccio',
  'giovanni da pian del carpine',
  'giovanni da verrazzano',
  'giovanni domenico cassini',
  'giovanni falcone',
  'giovanni gabrieli',
  'giovanni gentile',
  'giovanni giolitti',
  'giovanni gronchi',
  'giovanni leone',
  'giovanni paisiello',
  'giovanni pico della mirandola',
  'giovanni pierluigi da palestrina',
  'giovanni ribisi',
  'giovanni schiaparelli',
  'giovanni trapattoni',
  'giovanni van bronckhorst',
  'giovanni verga',
  'girija prasad koirala',
  'girma wolde-giorgis',
  'girolamo frescobaldi',
  'girolamo savonarola',
  'gisela dulko',
  'gisele bündchen',
  'giuliano amato',
  "giuliano de' medici",
  'giulietta masina',
  'giulio andreotti',
  'giulio caccini',
  'giulio natta',
  'giulio romano',
  'giuseppe arcimboldo',
  'giuseppe bergomi',
  'giuseppe di stefano',
  'giuseppe farina',
  'giuseppe favalli',
  'giuseppe garibaldi',
  'giuseppe mazzini',
  'giuseppe meazza',
  'giuseppe peano',
  'giuseppe piazzi',
  'giuseppe rossi',
  'giuseppe saragat',
  'giuseppe tartini',
  'giuseppe tomasi di lampedusa',
  'giuseppe torelli',
  'giuseppe tornatore',
  'giuseppe ungaretti',
  'giuseppe verdi',
  'gjorge ivanov',
  'gladwyn jebb',
  'glen johnson (english footballer)',
  'glenda jackson',
  'glenn close',
  'glenn ford',
  'glenn gould',
  'glenn hoddle',
  'glenn miller',
  'glenn t. seaborg',
  'gloria estefan',
  'gloria gaynor',
  'gloria macapagal-arroyo',
  'gloria stuart',
  'gloria swanson',
  'glycerius',
  'gnaeus naevius',
  'gnassingbé eyadéma',
  'godfrey hounsfield',
  'godfrey of bouillon',
  'goh chok tong',
  'gökhan inler',
  'golda meir',
  'goldie hawn',
  'gong li',
  'gonzalo higuaín',
  'goodluck jonathan',
  'goran bregović',
  'goran hadžić',
  'goran ivanišević',
  'goran pandev',
  'göran persson',
  'gordian i',
  'gordian ii',
  'gordian iii',
  'gordon bajnai',
  'gordon banks',
  'gordon brown',
  'gordon cooper',
  'gordon moore',
  'gore verbinski',
  'gore vidal',
  'gorgias',
  'gottfried benn',
  'gottfried keller',
  'gottfried wilhelm leibniz',
  'gotthard heinrici',
  'gotthold ephraim lessing',
  'gottlieb daimler',
  'gottlob frege',
  'gotye',
  'gough whitlam',
  'grace hopper',
  'grace kelly',
  'grafite',
  'graham chapman',
  'graham greene',
  'graham hill',
  'grand duchess anastasia nikolaevna of russia',
  'grand duchess maria nikolaevna of russia (1899–1918)',
  'grand duchess olga nikolaevna of russia',
  'grand duke michael alexandrovich of russia',
  'grant wood',
  'gratian',
  'grazia deledda',
  'greer garson',
  'greg cipes',
  'greg grunberg',
  'greg kinnear',
  'gregor mendel',
  'gregor schlierenzauer',
  'gregorio allegri',
  'grégory coupet',
  'grégory lemarchal',
  'gregory of nazianzus',
  'gregory of nyssa',
  'gregory of tours',
  'gregory palamas',
  'gregory peck',
  'gregory the illuminator',
  'gregory van der wiel',
  'greta garbo',
  'greyson chance',
  'grigori perelman',
  'grigori rasputin',
  'grigory ordzhonikidze',
  'grigory potemkin',
  'grigory zinoviev',
  'gro harlem brundtland',
  'groucho marx',
  'grover cleveland',
  'grzegorz lato',
  'guadalupe victoria',
  'guan yu',
  'guangxu emperor',
  'guglielmo marconi',
  'guido of arezzo',
  'guido reni',
  'guido van rossum',
  'guido westerwelle',
  'guillaume apollinaire',
  "guillaume de l'hôpital",
  'guillaume de machaut',
  'guillaume depardieu',
  'guillaume dufay',
  'guillermo cañas',
  'guillermo coria',
  'guillermo del toro',
  'guillermo ochoa',
  'guillermo stábile',
  'guillermo vilas',
  'gunnar myrdal',
  'gunnar nordahl',
  'günter blobel',
  'günter grass',
  'günter netzer',
  'günter verheugen',
  'günther von kluge',
  'guntis ulmanis',
  'guntram',
  'gurbanguly berdimuhamedow',
  'guru nanak',
  'gus grissom',
  'gus van sant',
  'gustaf dalén',
  'gustaf v of sweden',
  'gustaf vi adolf of sweden',
  'gustav bauer',
  'gustav fechner',
  'gustav heinemann',
  'gustav holst',
  'gustáv husák',
  'gustav i of sweden',
  'gustav iii of sweden',
  'gustav iv adolf of sweden',
  'gustav kirchhoff',
  'gustav klimt',
  'gustav ludwig hertz',
  'gustav mahler',
  'gustav meyrink',
  'gustav stresemann',
  'gustav vigeland',
  'gustave caillebotte',
  'gustave courbet',
  'gustave doré',
  'gustave eiffel',
  'gustave flaubert',
  'gustave le bon',
  'gustave moreau',
  'gustavo adolfo bécquer',
  'gustavo kuerten',
  'gustavus adolphus of sweden',
  'guti (footballer)',
  'guus hiddink',
  'guy berryman',
  'guy de maupassant',
  'guy debord',
  'guy demel',
  'guy fawkes',
  'guy iii of spoleto',
  'guy of lusignan',
  'guy pearce',
  'guy ritchie',
  'guy verhofstadt',
  'güyük khan',
  'gwen stefani',
  'gwyneth paltrow',
  'gyanendra of nepal',
  'györgy ligeti',
  'györgy lukács',
  'gyula cseszneky',
  'gyula horn',
  'h. g. wells',
  'h. h. asquith',
  'h. jon benjamin',
  'h. p. lovecraft',
  'h. rider haggard',
  'h. robert horvitz',
  'haakon vii of norway',
  'haakon, crown prince of norway',
  'habib bourguiba',
  'haddaway',
  'hadise',
  'hadrian',
  'hafez',
  'hafez al-assad',
  'hafizullah amin',
  'hagar',
  'hagen kleinert',
  'haile gebrselassie',
  'haile selassie i',
  'haj amin al-husseini',
  'hakan şükür',
  'hakan yakin',
  'hakeem olajuwon',
  'hal holbrook',
  'haldan keffer hartline',
  'haley joel osment',
  'halford mackinder',
  'halldór ásgrímsson',
  'halldór laxness',
  'halle berry',
  'ham (son of noah)',
  'hamad bin isa al khalifa',
  'hamad bin khalifa al thani',
  'hamid karzai',
  'hamilcar barca',
  'hamilton o. smith',
  'hamit altıntop',
  'hammurabi',
  'han fei',
  'hana mandlíková',
  'hande yener',
  'hank aaron',
  'hank azaria',
  'hank williams',
  'hanna reitsch',
  'hanna schygulla',
  'hannah arendt',
  'hannes alfvén',
  'hannes kolehmainen',
  'hannibal',
  'hannibal hamlin',
  'hanno the navigator',
  'hans adolf krebs',
  'hans asperger',
  'hans baldung',
  'hans bethe',
  'hans blix',
  'hans christian andersen',
  'hans christian gram',
  'hans christian ørsted',
  'hans egede',
  'hans eysenck',
  'hans fallada',
  'hans fischer',
  'hans frank',
  'hans geiger',
  'hans georg dehmelt',
  'hans holbein the elder',
  'hans holbein the younger',
  'hans kelsen',
  'hans krankl',
  'hans küng',
  'hans luther',
  'hans magnus enzensberger',
  'hans martin sutermeister',
  'hans memling',
  'hans morgenthau',
  'hans sachs',
  'hans sloane',
  'hans spemann',
  'hans von aachen',
  'hans von euler-chelpin',
  'hans von seeckt',
  'hans zimmer',
  'hans-adam ii, prince of liechtenstein',
  'hans-dietrich genscher',
  'hans-georg gadamer',
  'hans-jörg butt',
  'hans-rudolf merz',
  'hans-ulrich rudel',
  'har gobind khorana',
  'harald bluetooth',
  'harald fairhair',
  'harald hardrada',
  'harald ii of denmark',
  'harald v of norway',
  'harald zur hausen',
  'harel skaat',
  'haris silajdžić',
  'harlow shapley',
  'harold alexander, 1st earl alexander of tunis',
  'harold e. varmus',
  'harold godwinson',
  'harold harefoot',
  'harold lloyd',
  'harold macmillan',
  'harold pinter',
  'harold shipman',
  'harold urey',
  'harold wilson',
  'harper lee',
  'harri holkeri',
  'harriet beecher stowe',
  'harriet tubman',
  'harrison ford',
  'harrison schmitt',
  'harry belafonte',
  'harry harrison',
  'harry houdini',
  'harry kewell',
  'harry kroto',
  'harry markowitz',
  'harry martinson',
  'harry mulisch',
  'harry redknapp',
  'harry s. truman',
  'harsha',
  'harthacnut',
  'hartmut michel',
  'haruki murakami',
  'harun al-rashid',
  'harvey keitel',
  'harvey milk',
  'hasan ibn ali',
  'hasan salihamidžić',
  'hasdrubal (barcid)',
  'hasekura tsunenaga',
  'hashim thaçi',
  'hassan al-banna',
  'hassan gouled aptidon',
  'hassan ii of morocco',
  'hassan nasrallah',
  'hassan-i sabbah',
  'hassanal bolkiah',
  'hastings banda',
  'hatem ben arfa',
  'hatshepsut',
  'hattie mcdaniel',
  'hattusili iii',
  'hayao miyazaki',
  'hayato ikeda',
  'hayden christensen',
  'hayden panettiere',
  'hayley williams',
  'hayreddin barbarossa',
  'heath ledger',
  'heather graham',
  'heather locklear',
  'heather morris',
  'hebe camargo',
  'hecataeus of miletus',
  'hector berlioz',
  'hedo türkoğlu',
  'hedwiges maduro',
  'hedy lamarr',
  'heidi klum',
  'heike kamerlingh onnes',
  'heikki kovalainen',
  'heiko westermann',
  'heinrich böll',
  'heinrich brüning',
  'heinrich cornelius agrippa',
  'heinrich harrer',
  'heinrich heine',
  'heinrich hertz',
  'heinrich himmler',
  'heinrich ignaz franz biber',
  'heinrich lenz',
  "heinrich louis d'arrest",
  'heinrich lübke',
  'heinrich mann',
  'heinrich müller (gestapo)',
  'heinrich otto wieland',
  'heinrich rohrer',
  'heinrich schliemann',
  'heinrich schütz',
  'heinrich von kleist',
  'heinrich wilhelm matthias olbers',
  'heinz fischer',
  'heinz guderian',
  'heinz-harald frentzen',
  'heitor villa-lobos',
  'hélder postiga',
  'helen clark',
  'helen hayes',
  'helen hunt',
  'helen keller',
  'helen mirren',
  'helena (empress)',
  'helena blavatsky',
  'helena bonham carter',
  'helle thorning-schmidt',
  'helmut kohl',
  'helmut schmidt',
  'helmuth von moltke the elder',
  'helmuth von moltke the younger',
  'hendrick avercamp',
  'hendrik lorentz',
  'hendrik verwoerd',
  'henning mankell',
  'henri barbusse',
  'henri becquerel',
  'henri bergson',
  'henri cartier-bresson',
  "henri de la tour d'auvergne, vicomte de turenne",
  'henri de toulouse-lautrec',
  'henri fantin-latour',
  'henri fayol',
  'henri la fontaine',
  'henri lebesgue',
  'henri matisse',
  'henri moissan',
  'henri poincaré',
  'henri rousseau',
  'henri troyat',
  'henri, count of chambord',
  'henri, grand duke of luxembourg',
  'henrietta maria of france',
  'henrietta swan leavitt',
  'henrik dam',
  'henrik ibsen',
  'henrik larsson',
  'henrik pontoppidan',
  'henrique capriles radonski',
  'henrique hilário',
  'henry a. wallace',
  'henry addington, 1st viscount sidmouth',
  'henry bessemer',
  'henry campbell-bannerman',
  'henry cavendish',
  'henry cavill',
  'henry david thoreau',
  'henry dunant',
  'henry fielding',
  'henry fonda',
  'henry ford',
  'henry fox talbot',
  'henry fuseli',
  'henry hallett dale',
  'henry hudson',
  'henry i of england',
  'henry i of france',
  'henry ian cusick',
  'henry ii of england',
  'henry ii of france',
  'henry ii, holy roman emperor',
  'henry iii of england',
  'henry iii of france',
  'henry iii, holy roman emperor',
  'henry iv of england',
  'henry iv of france',
  'henry iv, holy roman emperor',
  'henry james',
  'henry john temple, 3rd viscount palmerston',
  'henry kissinger',
  'henry louis le chatelier',
  'henry mancini',
  'henry miller',
  'henry moore',
  'henry morgan',
  'henry morton stanley',
  'henry moseley',
  'henry norris russell',
  'henry pelham',
  'henry purcell',
  'henry taube',
  'henry the fowler',
  'henry the lion',
  'henry the navigator',
  'henry the young king',
  'henry v of england',
  'henry v, holy roman emperor',
  'henry van de velde',
  'henry vi of england',
  'henry vi, holy roman emperor',
  'henry vii of england',
  'henry vii, holy roman emperor',
  'henry viii of england',
  'henry wadsworth longfellow',
  'henry way kendall',
  'henry wilson',
  'henry, king of portugal',
  'henryk górecki',
  'henryk sienkiewicz',
  'henryk wieniawski',
  'hera björk',
  'heraclitus',
  'heraclius',
  'heraklonas',
  'herbert a. hauptman',
  'herbert a. simon',
  'herbert c. brown',
  'herbert hoover',
  'herbert kitchener, 1st earl kitchener',
  'herbert kroemer',
  'herbert marcuse',
  'herbert spencer',
  'herbert spencer gasser',
  'herbert von karajan',
  'herbie hancock',
  'herennius etruscus',
  'hergé',
  'herman cain',
  'herman hollerith',
  'herman melville',
  'herman van rompuy',
  'hermann ebbinghaus',
  'hermann emil fischer',
  'hermann göring',
  'hermann hesse',
  'hermann hoth',
  'hermann joseph muller',
  'hermann maier',
  'hermann minkowski',
  'hermann müller (politician)',
  'hermann oberth',
  'hermann staudinger',
  'hermann von helmholtz',
  'hermann weyl',
  'hernán cortés',
  'hernán crespo',
  'hernando de soto',
  'hero of alexandria',
  'herod antipas',
  'herod archelaus',
  'herod the great',
  'herodotus',
  'herostratus',
  'herta müller',
  'hesiod',
  'heurelho gomes',
  'heydar aliyev',
  'hezekiah',
  'hicham el guerrouj',
  'hide (musician)',
  'hideki shirakawa',
  'hideki tōjō',
  'hideki yukawa',
  'hidetoshi nakata',
  'hieronymus bosch',
  'hifikepunye pohamba',
  'hikaru utada',
  'hilary duff',
  'hilary of poitiers',
  'hilary putnam',
  'hilary swank',
  'hildegard of bingen',
  'hillary rodham clinton',
  'hillel slovak',
  'hipólito yrigoyen',
  'hipparchus',
  'hippasus',
  'hippias',
  'hippocrates',
  'hippodamus of miletus',
  'hippolyte fizeau',
  'hippolyte taine',
  'hippolytus of rome',
  'hiram bingham iii',
  'hirohito',
  'hiroo onoda',
  'hiroshige',
  'hisham ibn abd al-malik',
  'hjalmar branting',
  'hjalmar schacht',
  'ho chi minh',
  'hokusai',
  'holger badstuber',
  'holly hunter',
  'holly marie combs',
  'homare sawa',
  'homer',
  'hong taiji',
  'hongwu emperor',
  'honoré daumier',
  'honoré de balzac',
  'honoré gabriel riqueti, comte de mirabeau',
  'honorius (emperor)',
  'hope solo',
  'hor-aha',
  'horace',
  'horace walpole',
  'horatio nelson, 1st viscount nelson',
  'horemheb',
  'hormizd i',
  'horst köhler',
  'horst ludwig störmer',
  'horst seehofer',
  'horst wessel',
  'hosni mubarak',
  'hostilian',
  'hotepsekhemwy',
  'houari boumediene',
  'howard carter',
  'howard florey',
  'howard gardner',
  'howard h. aiken',
  'howard hawks',
  'howard hughes',
  'howard martin temin',
  'howard shore',
  'howard webb',
  'howard zinn',
  'hrant dink',
  'hristo stoichkov',
  'hrithik roshan',
  'hu jia (activist)',
  'hu jintao',
  'hua guofeng',
  'huang xianfan',
  'huáscar',
  'huayna capac',
  'hubert humphrey',
  'hud (prophet)',
  'huell howser',
  'hugh capet',
  'hugh david politzer',
  'hugh grant',
  'hugh hefner',
  'hugh jackman',
  'hugh laurie',
  'hugo almeida',
  'hugo chávez',
  'hugo de vries',
  'hugo grotius',
  'hugo gunckel lüer',
  'hugo lloris',
  'hugo pratt',
  'hugo sánchez',
  'hugo theorell',
  'hugo van der goes',
  'hugo viana',
  'hugo von hofmannsthal',
  'hugo weaving',
  'hugo wolf',
  'hugues de payens',
  'hulagu khan',
  'huldrych zwingli',
  'hulk (footballer)',
  'hulk hogan',
  'humayun',
  'humberto de alencar castelo branco',
  'humphrey bogart',
  'humphry davy',
  'hun sen',
  'huneric',
  'huni',
  'hunter s. thompson',
  'hussein bin ali, sharif of mecca',
  'hussein ibn ali',
  'hussein of jordan',
  'hussein-ali montazeri',
  'hypatia',
  'i. m. pei',
  'iain banks',
  'iajuddin ahmed',
  'iamblichus',
  'ian anderson',
  'ian curtis',
  'ian fleming',
  'ian gillan',
  'ian holm',
  'ian khama',
  'ian mcewan',
  'ian mckellen',
  'ian mcshane',
  'ian paice',
  'ian paisley',
  'ian rush',
  'ian smith',
  'ian somerhalder',
  'ian thorpe',
  'ian wright',
  'iannis xenakis',
  'ibn arabi',
  'ibn battuta',
  'ibn khaldun',
  'ibn saud',
  'ibn taymiyyah',
  'ibn tufail',
  'ibrahim afellay',
  'ibrahim ferrer',
  'ibrahim pasha of egypt',
  'ibrahim rugova',
  'ice cube',
  'ice-t',
  'ichiro suzuki',
  'ichirou mizuki',
  'ictinus',
  'idi amin',
  'idris (prophet)',
  'idris of libya',
  'idriss carlos kameni',
  'idriss déby',
  'iggy pop',
  'ignacy jan paderewski',
  'ignacy łukasiewicz',
  'ignacy mościcki',
  'ignatius of antioch',
  'ignatius of loyola',
  'ignazio abate',
  'igor akinfeev',
  'igor andreev',
  'igor denisov',
  'igor kurchatov',
  'igor of kiev',
  'igor semshov',
  'igor sikorsky',
  'igor smirnov',
  'igor stravinsky',
  'igor tamm',
  'igor tudor',
  'ihor belanov',
  'ike turner',
  'iker casillas',
  'ilan ramon',
  'ildibad',
  'ilham aliyev',
  'ilie năstase',
  'i̇lkay gündoğan',
  'ilona staller',
  'ilya ehrenburg',
  'ilya frank',
  'ilya prigogine',
  'ilya repin',
  'imad ad-din zengi',
  'imam shamil',
  'iman (model)',
  'imelda marcos',
  'imelda staunton',
  'imhotep',
  'immanuel kant',
  'immanuel wallerstein',
  'imran khan',
  'imre kertész',
  'imre lakatos',
  'imre nagy',
  'indira gandhi',
  'infanta leonor of spain',
  'inge de bruijn',
  'ingeborg bachmann',
  'ingmar bergman',
  'ingólfr arnarson',
  'ingrid bergman',
  'íngrid betancourt',
  'ingvar carlsson',
  'ingvar kamprad',
  'inigo jones',
  'inna',
  'intef i',
  'ioan gruffudd',
  'ioannis kapodistrias',
  'ioannis metaxas',
  'iolu abil',
  'ion antonescu',
  'ion iliescu',
  'irena sendler',
  'irenaeus',
  'irène joliot-curie',
  'irene of athens',
  'irina bokova',
  'iris murdoch',
  'irvine welsh',
  'irving berlin',
  'irving langmuir',
  'irwin rose',
  'isaac',
  'isaac albéniz',
  'isaac asimov',
  'isaac barrow',
  'isaac bashevis singer',
  'isaac cuenca',
  'isaac hayes',
  'isaac i komnenos',
  'isaac ii angelos',
  'isaac levitan',
  'isaac newton',
  'isaak babel',
  'isabeau of bavaria',
  'isabel allende',
  'isabel martínez de perón',
  'isabella i of castile',
  'isabella ii of spain',
  'isabella of france',
  'isabella of portugal',
  'isabella rossellini',
  'isabelle adjani',
  'isabelle huppert',
  'isadora duncan',
  'isaiah',
  'isaiah berlin',
  'isaias afewerki',
  'isambard kingdom brunel',
  'ish-bosheth',
  'ishmael',
  'isiah thomas',
  'isidor isaac rabi',
  'isidore of seville',
  'isla fisher',
  'islam karimov',
  "isma'il pasha",
  'ismail haniyeh',
  'ismail i',
  'ismail kadare',
  'ismaïl omar guelleh',
  'i̇smet i̇nönü',
  'isocrates',
  'isoroku yamamoto',
  'israel kamakawiwoʻole',
  'istván sándorfi',
  'italo balbo',
  'italo calvino',
  'italo svevo',
  'itamar franco',
  'itō hirobumi',
  'itumeleng khune',
  'itzhak perlman',
  'iu (singer)',
  'ivan aivazovsky',
  'ivan bagramyan',
  'ivan basso',
  'ivan bunin',
  'iván córdoba',
  'ivan franko',
  'ivan gašparovič',
  'ivan goncharov',
  'iván helguera',
  'ivan i of moscow',
  'ivan ii of moscow',
  'ivan iii of russia',
  'ivan klasnić',
  'ivan konev',
  'ivan kramskoi',
  'ivan krylov',
  'ivan lendl',
  'ivan ljubičić',
  'ivan mazepa',
  'ivan pavlov',
  'ivan perišić',
  'ivan rakitić',
  'ivan shishkin',
  'ivan the terrible',
  'ivan turgenev',
  'ivan v of russia',
  'ivan vi of russia',
  'ivan vladimirovich michurin',
  'iván zamorano',
  'ivar aasen',
  'ivar giaever',
  'ivars godmanis',
  'iveta radičová',
  'ivi adamou',
  'ivica olić',
  'ivica vastić',
  'ivo andrić',
  'ivo josipović',
  'ivo karlović',
  'ivo sanader',
  'izzy stradlin',
  'j. b. s. haldane',
  'j. christopher stevens',
  'j. d. salinger',
  'j. edgar hoover',
  'j. g. ballard',
  'j. hans d. jensen',
  'j. j. abrams',
  'j. j. thomson',
  'j. k. rowling',
  'j. l. austin',
  'j. m. barrie',
  'j. m. coetzee',
  'j. m. g. le clézio',
  'j. m. w. turner',
  'j. michael bishop',
  'j. michael straczynski',
  'j. p. morgan',
  'j. r. r. tolkien',
  'j. robert oppenheimer',
  'ja rule',
  "ja'far al-sadiq",
  'jaap de hoop scheffer',
  'jaap stam',
  'jaber al-ahmad al-jaber al-sabah',
  'jābir ibn hayyān',
  'jacinto benavente',
  'jack black',
  'jack brabham',
  'jack johnson (musician)',
  'jack kerouac',
  'jack kevorkian',
  'jack kilby',
  'jack kirby',
  'jack lemmon',
  'jack london',
  'jack nicholson',
  'jack palance',
  'jack rodwell',
  'jack ruby',
  'jack steinberger',
  'jack the ripper',
  'jack w. szostak',
  'jack white',
  'jack wilshere',
  'jackie chan',
  'jackie joyner-kersee',
  'jackie robinson',
  'jackie stewart',
  'jackson pollock',
  'jackson rathbone',
  'jaco pastorius',
  'jacob bernoulli',
  'jacob burckhardt',
  'jacob grimm',
  'jacob isaakszoon van ruisdael',
  'jacob jordaens',
  'jacob roggeveen',
  'jacob zuma',
  'jacobo árbenz',
  'jacobus arminius',
  "jacobus henricus van 't hoff",
  'jacopo peri',
  'jacqueline bisset',
  'jacqueline du pré',
  'jacqueline kennedy onassis',
  'jacques anquetil',
  'jacques brel',
  'jacques cartier',
  'jacques chaban-delmas',
  'jacques chirac',
  'jacques cousteau',
  'jacques de molay',
  'jacques delors',
  'jacques derrida',
  'jacques hadamard',
  'jacques hébert',
  'jacques ibert',
  'jacques lacan',
  'jacques le goff',
  'jacques macdonald',
  'jacques maritain',
  'jacques monod',
  'jacques necker',
  'jacques offenbach',
  'jacques prévert',
  'jacques rogge',
  'jacques santer',
  'jacques tati',
  'jacques villeneuve',
  'jacques-bénigne bossuet',
  'jacques-louis david',
  'jada pinkett smith',
  'jaden smith',
  'jadranka kosor',
  'jadwiga of poland',
  'jafar panahi',
  'jagadish chandra bose',
  'jahangir',
  'jaime alguersuari',
  'jairzinho',
  'jakaya kikwete',
  'jake gyllenhaal',
  'jakob böhme',
  'jakub błaszczykowski',
  'jalal talabani',
  'jamal ad-din al-afghani',
  'james a. garfield',
  'james abbott mcneill whistler',
  'james b. sumner',
  'james baker',
  'james baldwin',
  'james black (pharmacologist)',
  'james blake',
  'james blunt',
  'james brendan connolly',
  'james brown',
  'james buchanan',
  'james caan',
  'james cagney',
  'james callaghan',
  'james cameron',
  'james chadwick',
  'james clark ross',
  'james clerk maxwell',
  'james coburn',
  'james connolly',
  'james cook',
  'james cromwell',
  'james cronin',
  'james dean',
  'james dewar',
  'james earl jones',
  'james earl ray',
  'james ensor',
  'james fenimore cooper',
  'james francis edward stuart',
  'james franck',
  'james franco',
  'james gandolfini',
  'james garner',
  'james george frazer',
  'james gosling',
  'james harden',
  'james heckman',
  'james hetfield',
  'james horner',
  'james hunt',
  'james hutton',
  'james i of aragon',
  'james i of scotland',
  'james ii of england',
  'james ii of scotland',
  'james iii of scotland',
  'james irwin',
  'james iv of scotland',
  'james joseph sylvester',
  'james joyce',
  'james k. polk',
  'james l. brooks',
  'james labrie',
  'james lovelock',
  'james m. buchanan',
  'james macpherson',
  'james madison',
  'james marsden',
  'james mason',
  'james mcavoy',
  'james meade',
  'james michel',
  'james mill',
  'james milner',
  'james mirrlees',
  'james monroe',
  'james naismith',
  'james newton howard',
  'james prescott joule',
  'james rainwater',
  'james randi',
  'james s. sherman',
  'james spader',
  'james stewart',
  'james stirling (architect)',
  'james the just',
  'james tobin',
  'james v of scotland',
  'james van allen',
  'james vi and i',
  'james watson',
  'james watt',
  'james woods',
  'james, son of alphaeus',
  'james, son of zebedee',
  'jami',
  'jamie bell',
  'jamie carragher',
  'jamie foxx',
  'jamie lee curtis',
  'jamie lynn spears',
  'jamie oliver',
  'jan baptist van helmont',
  'jan brueghel the elder',
  'jan ceulemans',
  'jan fischer (politician)',
  'jan garbarek',
  'jan hus',
  'jan kochanowski',
  'jan koller',
  'jan łukasiewicz',
  'jan matejko',
  'ján mucha',
  'jan neruda',
  'jan oort',
  'jan palach',
  'jan peter balkenende',
  'jan pieterszoon sweelinck',
  'jan smuts',
  'jan steen',
  'jan tinbergen',
  'jan ullrich',
  'jan van eyck',
  'jan van riebeeck',
  'jan vennegoor of hesselink',
  'jan železný',
  'jan žižka',
  'jana novotná',
  'jane addams',
  'jane austen',
  'jane birkin',
  'jane fonda',
  'jane goodall',
  'jane krakowski',
  'jane lynch',
  'jane russell',
  'jane seymour',
  'jane seymour (actress)',
  'jane wyman',
  'janeane garofalo',
  'janet gaynor',
  'janet jackson',
  'janet leigh',
  'janez drnovšek',
  'janez janša',
  'janica kostelić',
  'janick gers',
  'janis joplin',
  'janko tipsarević',
  'janne ahonen',
  'jános áder',
  'jános bolyai',
  'jános kádár',
  'january jones',
  'janusz korczak',
  'japheth',
  'jared diamond',
  'jared leto',
  'jared padalecki',
  'jari litmanen',
  'jarkko nieminen',
  'jarno trulli',
  'jaromír jágr',
  'jaroslav hašek',
  'jaroslav heyrovský',
  'jaroslav plašil',
  'jaroslav seifert',
  'jarosław kaczyński',
  'jascha heifetz',
  'jason bateman',
  'jason culina',
  'jason derülo',
  'jason earles',
  'jason isaacs',
  'jason kidd',
  'jason lee (actor)',
  'jason mraz',
  'jason newsted',
  'jason robards',
  'jason segel',
  'jason statham',
  'jasper johns',
  'jaume bartumeu',
  'javi martínez',
  'javier aguirre',
  'javier bardem',
  'javier hernández balcázar',
  'javier marías',
  'javier mascherano',
  'javier pastore',
  'javier pérez de cuéllar',
  'javier saviola',
  'javier solana',
  'javier sotomayor',
  'javier zanetti',
  'jawaharlal nehru',
  'jay chou',
  'jay leno',
  'jay mohr',
  'jay sean',
  'jay spearing',
  'jay-jay okocha',
  'jay-z',
  'jayne mansfield',
  'jean alesi',
  'jean anouilh',
  'jean arp',
  'jean auguste dominique ingres',
  'jean baptiste perrin',
  'jean baudrillard',
  'jean buridan',
  'jean chrétien',
  'jean cocteau',
  'jean dausset',
  'jean de la fontaine',
  'jean dubuffet',
  'jean dujardin',
  'jean fouquet',
  'jean gabin',
  'jean gaston darboux',
  'jean genet',
  'jean giraud',
  'jean giraudoux',
  'jean harlow',
  'jean jaurès',
  'jean lannes',
  "jean le rond d'alembert",
  'jean makoun',
  'jean marais',
  'jean michel jarre',
  'jean monnet',
  'jean nouvel',
  'jean paul',
  'jean paul gaultier',
  'jean piaget',
  'jean racine',
  'jean reno',
  'jean renoir',
  'jean sibelius',
  'jean simmons',
  'jean tigana',
  'jean todt',
  'jean vigo',
  'jean-alain boumsong',
  'jean-baptiste biot',
  'jean-baptiste colbert',
  'jean-baptiste lamarck',
  'jean-baptiste lully',
  'jean-baptiste say',
  'jean-baptiste-camille corot',
  'jean-baptiste-siméon chardin',
  'jean-bédel bokassa',
  'jean-bertrand aristide',
  'jean-claude juncker',
  'jean-claude trichet',
  'jean-claude van damme',
  'jean-éric vergne',
  'jean-françois champollion',
  'jean-françois de galaup, comte de lapérouse',
  'jean-françois lyotard',
  'jean-françois millet',
  'jean-henri fabre',
  'jean-honoré fragonard',
  'jean-jacques annaud',
  'jean-jacques dessalines',
  'jean-jacques rousseau',
  'jean-léon gérôme',
  'jean-louis trintignant',
  'jean-luc dehaene',
  'jean-luc godard',
  'jean-marc ayrault',
  'jean-marie le pen',
  'jean-marie lehn',
  'jean-marie pfaff',
  'jean-martin charcot',
  'jean-michel basquiat',
  'jean-paul belmondo',
  'jean-paul marat',
  'jean-paul sartre',
  'jean-philippe rameau',
  'jean-pierre jeunet',
  'jean-pierre léaud',
  'jean-pierre papin',
  'jean-pierre raffarin',
  'jean-pierre serre',
  'jean-victor poncelet',
  'jean, grand duke of luxembourg',
  'jeanne calment',
  "jeanne d'albret",
  'jeanne moreau',
  'jeb bush',
  'jeff beck',
  'jeff bennett',
  'jeff bezos',
  'jeff bridges',
  'jeff buckley',
  'jeff daniels',
  'jeff dunham',
  'jeff goldblum',
  'jeff gordon',
  'jeff hardy',
  'jeff koons',
  'jefferson davis',
  'jefferson farfán',
  'jeffrén suárez',
  'jeffrey dahmer',
  'jehoiakim',
  'jehoram of judah',
  'jehoshaphat',
  'jelena dokic',
  'jelena janković',
  'jenna jameson',
  'jennette mccurdy',
  'jennifer aniston',
  'jennifer beals',
  'jennifer capriati',
  'jennifer carpenter',
  'jennifer connelly',
  'jennifer garner',
  'jennifer hudson',
  'jennifer jones',
  'jennifer lawrence',
  'jennifer lopez',
  'jennifer love hewitt',
  'jennifer morrison',
  'jennifer tilly',
  'jens böhrnsen',
  'jens christian skou',
  'jens fink-jensen',
  'jens lehmann',
  'jens nowotny',
  'jens stoltenberg',
  'jensen ackles',
  'jenson button',
  'jeppe aakjær',
  'jeremiah',
  'jeremy bentham',
  'jeremy brett',
  'jeremy clarkson',
  'jeremy irons',
  'jeremy lin',
  'jérémy ménez',
  'jeremy renner',
  'jérémy toulalan',
  'jeremy wariner',
  'jeri ryan',
  'jermain defoe',
  'jermaine jenas',
  'jermaine pennant',
  'jeroboam',
  'jerome',
  'jérôme boateng',
  'jérôme bonaparte',
  "jérôme d'ambrosio",
  'jerome isaac friedman',
  'jerome k. jerome',
  'jerome karle',
  'jérôme lalande',
  'jerry brown',
  'jerry bruckheimer',
  'jerry goldsmith',
  'jerry lee lewis',
  'jerry lewis',
  'jerry seinfeld',
  'jerry west',
  'jerry yang (entrepreneur)',
  'jerzy buzek',
  'jerzy dudek',
  'jesper grønkjær',
  'jesse',
  'jesse eisenberg',
  'jesse jackson',
  'jesse james',
  'jesse mccartney',
  'jesse owens',
  'jesse spencer',
  'jessica alba',
  'jessica biel',
  'jessica chastain',
  'jessica lange',
  'jessica simpson',
  'jessica tandy',
  'jessie j',
  'jesus',
  'jesús navas',
  'jet li',
  'jetro willems',
  'jewel (singer)',
  'ji yun-nam',
  'jiang qing',
  'jiang zemin',
  'jiddu krishnamurti',
  'jigme dorji wangchuck',
  'jigme khesar namgyel wangchuck',
  'jigme singye wangchuck',
  'jigme thinley',
  'jim belushi',
  'jim broadbent',
  'jim carrey',
  'jim caviezel',
  'jim clark',
  'jim courier',
  'jim cummings',
  'jim henson',
  'jim jarmusch',
  'jim jones',
  'jim lovell',
  'jim morrison',
  'jim parsons',
  'jim thorpe',
  'jim varney',
  'jim yong kim',
  'jimi hendrix',
  'jimmie johnson',
  'jimmy carter',
  'jimmy connors',
  'jimmy floyd hasselbaink',
  'jimmy greaves',
  'jimmy jump',
  'jimmy page',
  'jimmy wales',
  'jiří paroubek',
  'jo nesbø',
  'jo-wilfried tsonga',
  'joachim du bellay',
  'joachim gauck',
  'joachim löw',
  'joachim murat',
  'joachim von ribbentrop',
  'joan baez',
  'joan capdevila',
  'joan crawford',
  'joan enric vives sicília',
  'joan fontaine',
  'joan gamper',
  'joan i of navarre',
  'joan miró',
  'joan of arc',
  'joan of france, duchess of berry',
  'joan sutherland',
  'joanna of castile',
  'joanne woodward',
  'joannes',
  'joão bernardo vieira',
  'joão figueiredo',
  'joão gilberto',
  'joão goulart',
  'joão havelange',
  'joão moutinho',
  'joaquim chissano',
  'joaquim maria machado de assis',
  'joaquin phoenix',
  'joaquín rodrigo',
  'joaquín sánchez',
  'job (biblical figure)',
  'jochen rindt',
  'jochi',
  'jodie foster',
  'jody scheckter',
  'jody williams',
  'joe biden',
  'joe cocker',
  'joe cole',
  'joe dassin',
  'joe dimaggio',
  'joe frazier',
  'joe hahn',
  'joe hart',
  'joe jonas',
  'joe lieberman',
  'joe louis',
  'joe mantegna',
  'joe pantoliano',
  'joe pesci',
  'joe satriani',
  'joe strummer',
  'joel mchale',
  'joel schumacher',
  'joey barton',
  'joey jordison',
  'jogaila',
  'johan christian fabricius',
  'johan cruyff',
  'johan djourou',
  'johan elmander',
  'johan gadolin',
  'johan huizinga',
  'johan ludvig runeberg',
  'johan neeskens',
  'johann adolph hasse',
  'johann balthasar neumann',
  'johann bayer',
  'johann bernoulli',
  'johann christian bach',
  'johann christoph friedrich bach',
  'johann deisenhofer',
  'johann elert bode',
  'johann friedrich herbart',
  'johann gottfried galle',
  'johann gottfried herder',
  'johann gottlieb fichte',
  'johann heinrich lambert',
  'johann heinrich pestalozzi',
  'johann jakob balmer',
  'johann joachim winckelmann',
  'johann karl ehrenfried kegel',
  'johann ludwig burckhardt',
  'johann martin schleyer',
  'johann nepomuk hummel',
  'johann pachelbel',
  'johann palisa',
  'johann peter gustav lejeune dirichlet',
  'johann sebastian bach',
  'johann strauss i',
  'johann strauss ii',
  'johann tserclaes, count of tilly',
  'johann wolfgang von goethe',
  'jóhanna guðrún jónsdóttir',
  'jóhanna sigurðardóttir',
  'johanna spyri',
  'johannes brahms',
  'johannes diderik van der waals',
  'johannes fibiger',
  'johannes gutenberg',
  'johannes heesters',
  'johannes hevelius',
  'johannes kepler',
  'johannes ockeghem',
  'johannes rau',
  'johannes scotus eriugena',
  'johannes stark',
  'johannes vermeer',
  'johannes vilhelm jensen',
  'john a. macdonald',
  'john adams',
  'john aloisi',
  'john amos comenius',
  'john archibald wheeler',
  'john arne riise',
  'john atta mills',
  'john b. watson',
  'john backus',
  'john bardeen',
  'john barry (composer)',
  'john barrymore',
  'john bauer (illustrator)',
  'john belushi',
  'john boehner',
  'john bonham',
  'john bosco',
  'john boyd dunlop',
  'john boyd orr, 1st baron boyd-orr',
  'john brown (abolitionist)',
  'john browning',
  'john bunyan',
  'john c. breckinridge',
  'john c. calhoun',
  'john c. mather',
  'john c. reilly',
  'john cabot',
  'john cage',
  'john cale',
  'john calvin',
  'john candy',
  'john carew',
  'john carpenter',
  'john cassavetes',
  'john cazale',
  'john cena',
  'john chrysostom',
  'john churchill, 1st duke of marlborough',
  'john cleese',
  'john cockcroft',
  'john coltrane',
  'john constable',
  'john cornforth',
  'john couch adams',
  'john cusack',
  'john d. carmack',
  'john d. rockefeller',
  'john dalton',
  'john deacon',
  'john dee',
  'john demjanjuk',
  'john denver',
  'john dewey',
  'john diefenbaker',
  'john dillinger',
  'john dolmayan',
  'john donne',
  'john dos passos',
  'john dowland',
  'john dramani mahama',
  'john dryden',
  'john dunstaple',
  'john e. walker',
  'john eccles (neurophysiologist)',
  'john edward gray',
  'john edwards',
  'john entwistle',
  'john everett millais',
  'john f. kennedy',
  'john fenn (chemist)',
  'john field (composer)',
  'john flamsteed',
  'john forbes nash, jr.',
  'john ford',
  'john foster dulles',
  'john fowles',
  'john franklin',
  'john franklin enders',
  'john frusciante',
  'john galliano',
  'john galsworthy',
  'john garang',
  'john gielgud',
  'john glenn',
  'john goodman',
  'john grisham',
  'john gurdon',
  'john hancock',
  'john hannah (actor)',
  'john hanning speke',
  'john harsanyi',
  'john hasbrouck van vleck',
  'john heitinga',
  'john henry newman',
  'john herschel',
  'john hicks',
  'john higgins (snooker player)',
  'john howard',
  'john howard northrop',
  'john hughes (filmmaker)',
  'john hume',
  'john hunyadi',
  'john hurt',
  'john huston',
  'john i of france',
  'john i of portugal',
  'john i tzimiskes',
  'john ii casimir vasa',
  'john ii komnenos',
  'john ii of castile',
  'john ii of france',
  'john ii of portugal',
  'john iii doukas vatatzes',
  'john iii of portugal',
  'john iii of sweden',
  'john iii sobieski',
  'john irving',
  'john isner',
  'john iv laskaris',
  'john iv of portugal',
  'john j. pershing',
  'john james audubon',
  'john james rickard macleod',
  'john jay',
  'john keats',
  'john kendrew',
  'john kenneth galbraith',
  'john kerry',
  'john key',
  'john knox',
  'john kufuor',
  'john l. hall',
  'john le carré',
  'john lee hooker',
  'john legend',
  'john leguizamo',
  'john lennon',
  'john locke',
  'john logie baird',
  'john lydon',
  'john major',
  'john malalas',
  'john malkovich',
  'john marshall',
  'john mayer',
  'john maynard keynes',
  'john mccain',
  'john mccarthy (computer scientist)',
  'john mcenroe',
  'john mclaughlin (musician)',
  'john michael talbot',
  'john millington synge',
  'john milnor',
  'john milton',
  'john morrison (wrestler)',
  'john mott',
  'john myung',
  'john nance garner',
  'john napier',
  'john newcombe',
  "john o'shea",
  'john of austria',
  'john of bohemia',
  'john of damascus',
  'john of gaunt, 1st duke of lancaster',
  'john of nepomuk',
  'john of the cross',
  'john paintsil',
  'john paul jones (musician)',
  'john pemberton',
  'john petrucci',
  'john philip sousa',
  'john polanyi',
  'john pople',
  'john quincy adams',
  'john rawls',
  'john ray',
  'john rhys-davies',
  'john robert schrieffer',
  'john roberts',
  'john ruskin',
  'john russell hind',
  'john russell, 1st earl russell',
  'john schlesinger',
  'john searle',
  'john singer sargent',
  'john steinbeck',
  'john stockton',
  'john strutt, 3rd baron rayleigh',
  'john stuart mill',
  'john stuart, 3rd earl of bute',
  'john sulston',
  'john surtees',
  'john terry',
  'john the apostle',
  'john the baptist',
  'john the evangelist',
  'john the fearless',
  'john travolta',
  'john turner',
  'john turturro',
  'john tyler',
  'john updike',
  'john v of portugal',
  'john v palaiologos',
  'john vane',
  'john venn',
  'john vi kantakouzenos',
  'john vi of portugal',
  'john vianney',
  'john vii palaiologos',
  'john viii palaiologos',
  'john von neumann',
  'john wallis',
  'john wayne',
  'john wayne gacy',
  'john wesley',
  'john wilkes booth',
  'john william waterhouse',
  'john williams',
  'john woo',
  'john wycliffe',
  'john young (astronaut)',
  'john zápolya',
  'john, king of denmark',
  'john, king of england',
  'johnny carson',
  'johnny cash',
  'johnny depp',
  'johnny galecki',
  'johnny hallyday',
  'johnny knoxville',
  'johnny logan (singer)',
  'johnny weissmuller',
  'jojo (singer)',
  'joleon lescott',
  'jomo kenyatta',
  'jon bon jovi',
  'jon dahl tomasson',
  'jon favreau',
  'jon lord',
  'jon lovitz',
  'jon stewart',
  'jon voight',
  'jonah',
  'jonas björkman',
  'jonás gutiérrez',
  'jonas salk',
  'jonas savimbi',
  'jonathan davis',
  'jonathan demme',
  'jonathan dos santos',
  'jonathan edwards (athlete)',
  'jonathan ive',
  'jonathan rhys meyers',
  'jonathan swift',
  'jonathan woodgate',
  'joni mitchell',
  'jonny buckland',
  'jonny evans',
  'jonny greenwood',
  'jöns jacob berzelius',
  'joost van den vondel',
  'jordan henderson',
  'jordan rudess',
  'jordana brewster',
  'jordanes',
  'jordi alba',
  'jordi cruyff',
  'jordin sparks',
  'jörg haider',
  'jorge amado',
  'jorge batlle ibáñez',
  'jorge garcia',
  'jorge larrionda',
  'jorge lorenzo',
  'jorge luis borges',
  'jorge rafael videla',
  'jorge sampaio',
  'jorge valdano',
  'joris mathijsen',
  'joris-karl huysmans',
  'jørn utzon',
  'joschka fischer',
  'josé antonio primo de rivera',
  'josé antonio reyes',
  'josé bosingwa',
  'josé carreras',
  'josé de anchieta',
  'josé de espronceda',
  'josé de san martín',
  'josé echegaray',
  'josé eduardo dos santos',
  'josé enrique sánchez',
  'josé gervasio artigas',
  'josé luis chilavert',
  'josé luis rodríguez zapatero',
  'josé manuel barroso',
  'josé manuel pinto',
  'josé maría aznar',
  'josé maría callejón',
  'josé maria neves',
  'josé martí',
  'josé mourinho',
  'josé mujica',
  'josé ortega y gasset',
  'josé ramos-horta',
  'josé raúl capablanca',
  'josé rizal',
  'josé saramago',
  'josé sarney',
  'josé sócrates',
  'joseba sarrionandia',
  'josef albers',
  'josef dietrich',
  'josef masopust',
  'josef mengele',
  'josemaría escrivá',
  'joseph (son of jacob)',
  'joseph addison',
  'joseph banks',
  'joseph barbera',
  'joseph beuys',
  'joseph black',
  'joseph bonaparte',
  'joseph brodsky',
  'joseph campbell',
  'joseph conrad',
  'joseph dalton hooker',
  'joseph de maistre',
  'joseph erlanger',
  'joseph estrada',
  'joseph fiennes',
  'joseph fouché',
  'joseph fourier',
  'joseph freiherr von eichendorff',
  'joseph goebbels',
  'joseph gordon-levitt',
  'joseph greenberg',
  'joseph haydn',
  'joseph heller',
  'joseph henry',
  'joseph hooton taylor, jr.',
  'joseph i of portugal',
  'joseph i, holy roman emperor',
  'joseph ii, holy roman emperor',
  'joseph joffre',
  'joseph kabila',
  'joseph kony',
  'joseph l. goldstein',
  'joseph l. mankiewicz',
  'joseph liouville',
  'joseph lister, 1st baron lister',
  'joseph louis gay-lussac',
  'joseph louis lagrange',
  'joseph marie jacquard',
  'joseph mccarthy',
  'joseph merrick',
  'joseph murray',
  'joseph of arimathea',
  'joseph priestley',
  'joseph pulitzer',
  'joseph radetzky von radetz',
  'joseph rotblat',
  'joseph schumpeter',
  'joseph smith',
  'joseph stalin',
  'joseph stiglitz',
  'joseph von fraunhofer',
  'joseph wirth',
  'joseph wright of derby',
  'joseph yobo',
  'joseph-ignace guillotin',
  'josephine baker',
  'joséphine de beauharnais',
  'josephus',
  'josh brolin',
  'josh duhamel',
  'josh groban',
  'josh hartnett',
  'josh holloway',
  'josh hutcherson',
  'josh radnor',
  'joshua',
  'joshua jackson',
  'joshua lederberg',
  'joshua reynolds',
  'josiah',
  'josiah willard gibbs',
  'josip broz tito',
  'josip jelačić',
  'josip šimunić',
  'josquin des prez',
  'joss stone',
  'joss whedon',
  'jostein gaarder',
  'jovian (emperor)',
  'joyce banda',
  'joyce carol oates',
  'józef gosławski (sculptor)',
  'józef piłsudski',
  'józef poniatowski',
  'jozef tiso',
  'jozy altidore',
  'juan antonio samaranch',
  'juan carlos ferrero',
  'juan carlos i of spain',
  'juan carlos navarro (basketball)',
  'juan francisco torres',
  'juan gris',
  'juan gutiérrez moreno',
  'juan manuel de rosas',
  'juan manuel fangio',
  'juan manuel santos',
  'juan martín del potro',
  'juan mata',
  'juan mónaco',
  'juan pablo montoya',
  'juan pablo sorín',
  'juan perón',
  'juan ponce de león',
  'juan ramón jiménez',
  'juan rodríguez cabrillo',
  'juan román riquelme',
  'juan rulfo',
  'juan sebastián elcano',
  'juan sebastián verón',
  'juan silveira dos santos',
  'juan velasco alvarado',
  'juana inés de la cruz',
  'juande ramos',
  'juanes',
  'judah halevi',
  'judas iscariot',
  'judas maccabeus',
  'jude law',
  'jude the apostle',
  'judi dench',
  'judit polgár',
  'judith butler',
  'judy garland',
  'judy holliday',
  'jugurtha',
  'juhi chawla',
  'juho kusti paasikivi',
  'jukka nevalainen',
  'jules a. hoffmann',
  'jules bordet',
  "jules dumont d'urville",
  'jules ferry',
  'jules grévy',
  'jules massenet',
  'jules michelet',
  'jules rimet',
  'jules verne',
  'julia child',
  'julia domna',
  'julia gillard',
  'julia görges',
  'julia kristeva',
  'julia louis-dreyfus',
  'julia ormond',
  'julia roberts',
  'julia stiles',
  'julia volkova',
  'julian assange',
  'julian barnes',
  'julian huxley',
  'julian mcmahon',
  'julian schwinger',
  'julian the apostate',
  'juliana of the netherlands',
  'julianne moore',
  'juliano belletti',
  'julie andrews',
  'julie christie',
  'julie delpy',
  'julie kavner',
  'julie walters',
  'julien gracq',
  'julien offray de la mettrie',
  'juliette binoche',
  'juliette lewis',
  'júlio baptista',
  'júlio césar soares espíndola',
  'julio cortázar',
  'julio iglesias',
  'julio maría sanguinetti',
  'julio ricardo cruz',
  'julius axelrod',
  'julius caesar',
  'julius erving',
  'julius nepos',
  'julius nyerere',
  'julius streicher',
  'julius von mayer',
  'julius wagner-jauregg',
  'juliusz słowacki',
  'junichiro koizumi',
  'juninho pernambucano',
  'jupp heynckes',
  'jürgen habermas',
  'jürgen klinsmann',
  'jürgen klopp',
  'jürgen melzer',
  'juscelino kubitschek',
  'jusepe de ribera',
  'jussi jääskeläinen',
  'just fontaine',
  'justin (historian)',
  'justin bartha',
  'justin bieber',
  'justin chambers',
  'justin gatlin',
  'justin i',
  'justin ii',
  'justin long',
  'justin martyr',
  'justin timberlake',
  'justine henin',
  'justinian i',
  'justinian ii',
  'justo villar',
  'justus von liebig',
  'juvenal',
  'juvénal habyarimana',
  'jyrki katainen',
  'k. alex müller',
  'k. r. narayanan',
  "k'naan",
  'kaarlo juho ståhlberg',
  'kabir',
  'kagisho dikgacoi',
  'kahlil gibran',
  'kaʻahumanu',
  'kai siegbahn',
  'kaia kanepi',
  'kajol',
  'kajsa bergqvist',
  'kaká',
  'kakha kaladze',
  'kakuei tanaka',
  'kal penn',
  'kaley cuoco',
  'kālidāsa',
  'kalomira',
  'kaloyan of bulgaria',
  'kalpana chawla',
  'kalu uche',
  'kamehameha i',
  'kamose',
  'kamui kobayashi',
  'kane (wrestler)',
  'kangxi emperor',
  'kanō jigorō',
  'kanye west',
  'kareem abdul-jabbar',
  'kareena kapoor',
  'karel appel',
  'karel čapek',
  'karel poborský',
  'karen blixen',
  'karim benzema',
  'karim massimov',
  'karl adolph gjellerup',
  'karl barry sharpless',
  'karl barth',
  'karl benz',
  'karl brandt',
  'karl bryullov',
  'karl carstens',
  'karl dönitz',
  'karl drais',
  'karl ernst von baer',
  'karl ferdinand braun',
  'karl friedrich schinkel',
  'karl haushofer',
  'karl jaspers',
  'karl kraus',
  'karl lagerfeld',
  'karl landsteiner',
  'karl ludwig harding',
  'karl ludwig hencke',
  'karl malden',
  'karl malone',
  'karl mannheim',
  'karl marx',
  'karl may',
  'karl pearson',
  'karl popper',
  'karl renner',
  'karl schwarzschild',
  'karl shuker',
  'karl urban',
  'karl von frisch',
  'karl von habsburg',
  'karl weierstrass',
  'karl wilhelm friedrich schlegel',
  'karl wilhelm reinmuth',
  'karl ziegler',
  'karl-heinz rummenigge',
  'karl-theodor zu guttenberg',
  'karlheinz stockhausen',
  'kārlis ulmanis',
  'karol szymanowski',
  'karolina gočeva',
  'karolína kurková',
  'karolos papoulias',
  'karun chandhok',
  'kary mullis',
  'kaspar capparoni',
  'kaspar hauser',
  'kasper schmeichel',
  'katarina srebotnik',
  'katarina witt',
  'kate beckinsale',
  'kate bosworth',
  'kate bush',
  'kate hudson',
  'kate moss',
  'kate mulgrew',
  'kate ryan',
  'kate winslet',
  'kateryna bondarenko',
  'katey sagal',
  'katharina von bora',
  'katharine hepburn',
  'käthe kollwitz',
  'katherine heigl',
  'katherine mansfield',
  'katherine moennig',
  'kathleen turner',
  'kathryn bigelow',
  'kathy bates',
  'katie holmes',
  'katie leung',
  'katie melua',
  'katlego mphela',
  'katrina kaif',
  'katsura tarō',
  'katy perry',
  'kavadh i',
  'kazimierz kuratowski',
  'kazimir malevich',
  'kazuki nakajima',
  'kazuo ishiguro',
  'keanu reeves',
  'keira knightley',
  'keisuke honda',
  'keith haring',
  'keith jarrett',
  'keith moon',
  'keith richards',
  'keizō obuchi',
  'keke palmer',
  'keke rosberg',
  'kellan lutz',
  'kelly clarkson',
  'kelly kelly',
  'kelly rowland',
  'kelsey grammer',
  'ken anderson (wrestler)',
  'ken follett',
  'ken kesey',
  'ken livingstone',
  'ken loach',
  'ken russell',
  'ken saro-wiwa',
  'ken thompson',
  'ken watanabe',
  'ken wilber',
  'kenan evren',
  'kenenisa bekele',
  'kenichi fukui',
  'kenneth arrow',
  'kenneth branagh',
  'kenneth g. wilson',
  'kenneth kaunda',
  'kenneth macalpin',
  'kenny dalglish',
  'kenny g',
  'kenny rogers',
  'kenwyne jones',
  'kenzaburō ōe',
  'kenzō tange',
  'keri hilson',
  'kerry king',
  'kesha',
  'kevin anderson (tennis)',
  'kevin bacon',
  'kevin carter',
  'kevin costner',
  'kevin doyle',
  'kevin durant',
  'kevin federline',
  'kevin garnett',
  'kevin großkreutz',
  'kevin james (actor)',
  'kevin keegan',
  'kevin kline',
  'kevin kurányi',
  'kevin love',
  'kevin michael richardson',
  'kevin mitnick',
  'kevin nolan',
  'kevin phillips (footballer)',
  'kevin rudd',
  'kevin smith',
  'kevin spacey',
  'kevin-prince boateng',
  'kgalema motlanthe',
  'khaba',
  'khadija bint khuwaylid',
  'khafra',
  'khaled hosseini',
  'khaleda zia',
  'khalid boulahrouz',
  'khalid ibn al-walid',
  'khalid of saudi arabia',
  'khalifa bin zayed al nahyan',
  'khan abdul ghaffar khan',
  'khasekhemwy',
  'khorloogiin choibalsan',
  'khosrau i',
  'khosrau ii',
  'khufu',
  'kiefer sutherland',
  'kieran gibbs',
  'kieran richardson',
  'kieron dyer',
  'kim basinger',
  'kim campbell',
  'kim cattrall',
  'kim clijsters',
  'kim dae-jung',
  'kim gu',
  'kim il-sung',
  'kim jong-il',
  'kim jong-un',
  'kim källström',
  'kim kardashian',
  'kim ki-duk',
  'kim kyu-sik',
  'kim novak',
  'kim peek',
  'kim philby',
  'kim seong-su',
  'kim stanley robinson',
  'kim wilde',
  'kim yong-nam',
  'kim young-sam',
  'kim yu-na',
  'kimi räikkönen',
  'kimiko date-krumm',
  'king porus',
  'king scorpion',
  'kingsley amis',
  'kiran desai',
  'kiri te kanawa',
  'kirill i of moscow',
  'kirill meretskov',
  'kirk douglas',
  'kirk hammett',
  'kiro gligorov',
  'kirsan ilyumzhinov',
  'kirsten dunst',
  'kirstie alley',
  'kirsty coventry',
  'kitarō',
  'kjell magne bondevik',
  'kjetil andré aamodt',
  'klaas-jan huntelaar',
  'klara hitler',
  'klas pontus arnoldson',
  'klaus barbie',
  'klaus ebner',
  'klaus kinski',
  'klaus mann',
  'klaus meine',
  'klaus tschütscher',
  'klaus von klitzing',
  'klaus wowereit',
  'klemens von metternich',
  'klement gottwald',
  'kliment voroshilov',
  'knut hamsun',
  'kobe bryant',
  'kōbō abe',
  'koda kumi',
  'kofi annan',
  'kofi kingston',
  'koichi tanaka',
  'koji murofushi',
  'kolo touré',
  'konrad adenauer',
  'konrad emil bloch',
  'konrad lorenz',
  'konrad zuse',
  'konstantin chernenko',
  'konstantin novoselov',
  'konstantin päts',
  'konstantin rokossovsky',
  'konstantin simonov',
  'konstantin tsiolkovsky',
  'konstantin von neurath',
  'konstantin zyryanov',
  'konstantinos karamanlis',
  'konstantinos stephanopoulos',
  'kostas chalkias',
  'kostas karamanlis',
  'kostas katsouranis',
  'kris allen',
  'kris kristofferson',
  'krist novoselic',
  'kristanna loken',
  'kristen bell',
  'kristen schaal',
  'kristen stewart',
  'kristin davis',
  'kristin kreuk',
  'kristin scott thomas',
  'kristina (singer)',
  'kristján eldjárn',
  'krum',
  'krzysztof kieślowski',
  'krzysztof penderecki',
  'kublai khan',
  'kubrat',
  'kurmanbek bakiyev',
  'kurt alder',
  'kurt angle',
  'kurt cobain',
  'kurt georg kiesinger',
  'kurt gödel',
  'kurt lewin',
  'kurt russell',
  'kurt schuschnigg',
  'kurt schwitters',
  'kurt student',
  'kurt von schleicher',
  'kurt vonnegut',
  'kurt waldheim',
  'kurt weill',
  'kurt wüthrich',
  'kwadwo asamoah',
  'kwame nkrumah',
  'kyle maclachlan',
  'kylie minogue',
  'kyösti kallio',
  'l. frank baum',
  'l. l. zamenhof',
  'l. ron hubbard',
  'lactantius',
  'ladislaus i of hungary',
  'ladislaus the posthumous',
  'lady bird johnson',
  'lady gaga',
  'lady godiva',
  'lady jane grey',
  'laetitia casta',
  'lajos kossuth',
  'lakshmi mittal',
  'lal bahadur shastri',
  'lamar odom',
  'lamberto dini',
  'lana del rey',
  'lana turner',
  'lance armstrong',
  'landon donovan',
  'lang lang (pianist)',
  'langston hughes',
  'lansana conté',
  'lao she',
  'laozi',
  'lapu-lapu',
  'lara dutta',
  'lara fabian',
  'lara flynn boyle',
  'larisa latynina',
  'larry bird',
  'larry david',
  'larry ellison',
  'larry flynt',
  'larry hagman',
  'larry king',
  'larry mullen, jr.',
  'larry page',
  'larry sanger',
  'larry wall',
  'lars ahlfors',
  'lars bender',
  'lars jacobsen',
  'lars løkke rasmussen',
  'lars onsager',
  'lars ulrich',
  'lars von trier',
  'lashawn merritt',
  'lassana diarra',
  'lasse virén',
  'lászló bíró',
  'lászló kubala',
  'lászló moholy-nagy',
  'lászló papp',
  'lászló sólyom',
  'lata mangeshkar',
  'laura branigan',
  'laura bush',
  'laura chinchilla',
  'laura dern',
  'laura linney',
  'laura pausini',
  'laura prepon',
  'lauren bacall',
  'lauren graham',
  'laurence fishburne',
  'laurence olivier',
  'laurence sterne',
  'laurent blanc',
  'laurent fabius',
  'laurent fignon',
  'laurent gbagbo',
  'laurent koscielny',
  'laurent schwartz',
  'laurent-désiré kabila',
  'lauri kristian relander',
  'laurie holden',
  'lauryn hill',
  'lavr kornilov',
  'lavrentiy beriya',
  'lawrence alma-tadema',
  'lawrence durrell',
  'lawrence gonzi',
  'lawrence klein',
  'lawrence lessig',
  'lawrence of rome',
  'layne staley',
  'lazar kaganovich',
  'lazar of serbia',
  'lazare carnot',
  'lázaro cárdenas',
  'lazarus of bethany',
  'lazzaro spallanzani',
  'le corbusier',
  'le duc tho',
  'lea michele',
  'leah',
  'leander paes',
  'leann rimes',
  'lebron james',
  'lech kaczyński',
  'lech wałęsa',
  'leconte de lisle',
  'ledley king',
  'lee chung-yong',
  'lee de forest',
  'lee harvey oswald',
  'lee hsien loong',
  'lee jung-soo',
  'lee kuan yew',
  'lee marvin',
  'lee min-ho (actor born 1987)',
  'lee myung-bak',
  'lee strasberg',
  'lee van cleef',
  'leelee sobieski',
  'leif ericson',
  'leighton baines',
  'leighton meester',
  'leisel jones',
  'leland h. hartwell',
  'lemmy',
  'lena headey',
  'lena katina',
  'lena meyer-landrut',
  'lena olin',
  'leni riefenstahl',
  'lenka',
  'lennart meri',
  'lennox lewis',
  'lenny kravitz',
  'leo baekeland',
  'léo delibes',
  'leo esaki',
  'leo fender',
  'leo franco',
  'leo i the thracian',
  'leo ii (emperor)',
  'leo iii the isaurian',
  'leo iv the khazar',
  'leó szilárd',
  'leo tolstoy',
  'leo v the armenian',
  'leo vi the wise',
  'leo von caprivi',
  'léon bakst',
  'leon battista alberti',
  'léon blum',
  'léon bourgeois',
  'leon cooper',
  'léon degrelle',
  'léon foucault',
  'léon gambetta',
  'léon jouhaux',
  'leon m. lederman',
  "léon m'ba",
  'leon osman',
  'leon panetta',
  'leon trotsky',
  'leona lewis',
  'leonard bernstein',
  'leonard bloomfield',
  'leonard cohen',
  'leonard nimoy',
  'leonardo araújo',
  'leonardo bonucci',
  'leonardo da vinci',
  'leonardo dicaprio',
  'leonel fernández',
  'leonhard euler',
  'leonid andreyev',
  'leonid brezhnev',
  'leonid gaidai',
  'leonid govorov',
  'leonid hurwicz',
  'leonid kantorovich',
  'leonid kravchuk',
  'leonid kuchma',
  'leonidas i',
  'léonin',
  'leontios',
  'leopold i of belgium',
  'leopold i, holy roman emperor',
  'leopold ii of belgium',
  'leopold ii, holy roman emperor',
  'leopold iii of belgium',
  'leopold kronecker',
  'leopold mozart',
  'leopold ružička',
  'léopold sédar senghor',
  'leopold stokowski',
  'leopold von ranke',
  'leopold von sacher-masoch',
  'leopoldo calvo-sotelo',
  'leopoldo galtieri',
  'leoš janáček',
  'les paul',
  'leslie cheung',
  'leslie nielsen',
  'lester b. pearson',
  'lesya ukrainka',
  'leszek engelking',
  'leszek kołakowski',
  'letizia, princess of asturias',
  'letsie iii of lesotho',
  'leucippus',
  'lev kamenev',
  'lev landau',
  'lev vygotsky',
  'lev yashin',
  'levi',
  'levi eshkol',
  'levi p. morton',
  'levi strauss',
  'levon aronian',
  'levon ter-petrosyan',
  'levy mwanawasa',
  'lewis carroll',
  'lewis h. morgan',
  'lewis hamilton',
  'lewis milestone',
  'leymah gbowee',
  'lhasa de sela',
  'li bai',
  'li na (tennis)',
  'li peng',
  'li xiannian',
  'li yu (author)',
  'liam gallagher',
  'liam hemsworth',
  'liam neeson',
  'liaquat ali khan',
  'libius severus',
  'libor sionko',
  'licinius',
  'liédson',
  'liev schreiber',
  'lil jon',
  'lil wayne',
  'lila downs',
  'lilian thuram',
  'liliuokalani',
  'lillian gish',
  'lily allen',
  'lily collins',
  'lily tomlin',
  'lin biao',
  'lina medina',
  'linda b. buck',
  'linda evangelista',
  'linda hamilton',
  'linda lovelace',
  'linda maria baros',
  'linda mccartney',
  'lindsay anderson',
  'lindsay davenport',
  'lindsay lohan',
  'lindsey vonn',
  'linus pauling',
  'linus torvalds',
  'lion feuchtwanger',
  'lionel barrymore',
  'lionel jospin',
  'lionel messi',
  'lionel richie',
  'lisa edelstein',
  'lisa gerrard',
  'lisa kudrow',
  'lisa marie presley',
  'lisandro lópez',
  'lise meitner',
  'little richard',
  'liu bei',
  'liu shaoqi',
  'liu xiang',
  'liu xiaobo',
  'liu yang (astronaut)',
  'liv tyler',
  'liv ullmann',
  'livia',
  'livius andronicus',
  'livy',
  'liza minnelli',
  'll cool j',
  'lleyton hewitt',
  'lloyd banks',
  'lloyd shapley',
  'lobsang sangay',
  'lodovico ferrari',
  'logan lerman',
  'lola pagnani',
  'lolo ferrari',
  'lope de vega',
  'lord byron',
  'loreena mckennitt',
  'lorenzo da ponte',
  "lorenzo de' medici",
  'lorenzo ghiberti',
  'lorenzo valla',
  'loretta young',
  'lot (biblical person)',
  'lothair i',
  'lothair ii',
  'lothair iii, holy roman emperor',
  'lothair of france',
  'lothar matthäus',
  'lou andreas-salomé',
  'lou reed',
  'louis agassiz',
  'louis althusser',
  'louis antoine de bougainville',
  'louis antoine de saint-just',
  'louis antoine, duke of angoulême',
  'louis aragon',
  'louis armstrong',
  'louis auguste blanqui',
  'louis barthou',
  'louis blériot',
  'louis bonaparte',
  'louis braille',
  'louis daguerre',
  'louis de broglie',
  'louis de funès',
  'louis i of hungary',
  'louis i of spain',
  'louis ignarro',
  'louis ii of hungary',
  'louis ii of italy',
  'louis iii of france',
  'louis iv of france',
  'louis iv, holy roman emperor',
  'louis ix of france',
  'louis kahn',
  'louis le vau',
  'louis leakey',
  'louis mountbatten, 1st earl mountbatten of burma',
  'louis néel',
  'louis pasteur',
  'louis philippe i',
  'louis renault (industrialist)',
  'louis renault (jurist)',
  'louis saha',
  'louis spohr',
  'louis sullivan',
  'louis the child',
  'louis the german',
  'louis the pious',
  'louis the stammerer',
  'louis the younger',
  'louis v of france',
  'louis van gaal',
  'louis vi of france',
  'louis vierne',
  'louis vii of france',
  'louis viii of france',
  'louis x of france',
  'louis xi of france',
  'louis xii of france',
  'louis xiii of france',
  'louis xiv of france',
  'louis xv of france',
  'louis xvi of france',
  'louis xvii of france',
  'louis xviii of france',
  'louis-alexandre berthier',
  'louis-ferdinand céline',
  'louis-nicolas davout',
  'louisa may alcott',
  'louise bourgeois',
  'louise élisabeth vigée le brun',
  'louise fletcher',
  'louise michel',
  'louise of mecklenburg-strelitz',
  'lovis corinth',
  'lu xun',
  'luc besson',
  'luc montagnier',
  'luca antonini',
  'luca badoer',
  'luca pacioli',
  'luca signorelli',
  'luca toni',
  'lucan',
  'lucas barrios',
  'lucas cranach the elder',
  'lucas di grassi',
  'lucas grabeel',
  'lucas leiva',
  'lucas neill',
  'lucas papademos',
  'luchino visconti',
  'lucho gonzález',
  'lucía etxebarría',
  'lucian',
  'lucian freud',
  'luciano berio',
  'luciano floridi',
  'luciano pavarotti',
  'luciano spalletti',
  'lucie šafářová',
  'lucien bonaparte',
  'lucien febvre',
  'lucille ball',
  'lúcio',
  'lúcio costa',
  'lucio dalla',
  'lucius aemilius paullus macedonicus',
  'lucius cornelius cinna',
  'lucius cornelius sulla',
  'lucius junius brutus',
  'lucius tarquinius priscus',
  'lucius tarquinius superbus',
  'lucius verus',
  'lucky luciano',
  'lucretia',
  'lucretius',
  'lucrezia borgia',
  'lucullus',
  'lucy lawless',
  'lucy liu',
  'lucy maud montgomery',
  'ludacris',
  'ludmilla radchenko',
  'ludolph van ceulen',
  'ludovic giuly',
  'ludovic magnin',
  'ludovico ariosto',
  'ludovico sforza',
  'ludvig holberg',
  'ludvík svoboda',
  'ludwig achim von arnim',
  'ludwig beck',
  'ludwig boltzmann',
  'ludwig erhard',
  'ludwig feuerbach',
  'ludwig i of bavaria',
  'ludwig ii of bavaria',
  'ludwig iii of bavaria',
  'ludwig mies van der rohe',
  'ludwig quidde',
  'ludwig tieck',
  'ludwig van beethoven',
  'ludwig von mises',
  'ludwig wittgenstein',
  'luigi boccherini',
  'luigi cherubini',
  'luigi dallapiccola',
  'luigi einaudi',
  'luigi galvani',
  'luigi nono',
  'luigi pirandello',
  'luigi riva',
  'luis aragonés',
  'luis barragán',
  'luis buñuel',
  'luís de camões',
  'luis de góngora',
  'luis enrique martínez garcía',
  'luís fabiano',
  'luis federico leloir',
  'luís figo',
  'luís i of portugal',
  'luis suárez',
  'luis suárez miramontes',
  'luis walter alvarez',
  'luisa diogo',
  'luisão',
  'luise rainer',
  'luitzen egbertus jan brouwer',
  'luiz felipe scolari',
  'luiz inácio lula da silva',
  'luka modrić',
  'lukas podolski',
  'łukasz fabiański',
  'luke the evangelist',
  'luke young (footballer born 1979)',
  'luol deng',
  'lutz graf schwerin von krosigk',
  'lycurgus of sparta',
  'lyndon b. johnson',
  'lynn margulis',
  'lynn redgrave',
  'lys assia',
  'lysander',
  'lysias',
  'lysimachus',
  'lysippos',
  'lyudmila gurchenko',
  'm. c. escher',
  'm. night shyamalan',
  'm. shadows',
  'm.i.a. (artist)',
  'ma ying-jeou',
  'maarten stekelenburg',
  'macaulay culkin',
  'macbeth, king of scotland',
  'maciej żurawski',
  'macky sall',
  'macrinus',
  'madame de la fayette',
  'madame de pompadour',
  'madame du barry',
  'madeleine albright',
  'madeleine stowe',
  'madhuri dixit',
  'madonna (entertainer)',
  'mads mikkelsen',
  'mae west',
  'magda goebbels',
  'magdalena neuner',
  'maggie cheung',
  'maggie grace',
  'maggie gyllenhaal',
  'maggie q',
  'maggie smith',
  'magic johnson',
  'magnentius',
  'magnus carlsen',
  'magnus maximus',
  'mahalia jackson',
  'mahamadou diarra',
  'maharishi mahesh yogi',
  'mahathir mohamad',
  'mahatma gandhi',
  'mahavira',
  'mahesh bhupathi',
  'mahinda rajapaksa',
  'mahmoud abbas',
  'mahmoud ahmadinejad',
  'mahmoud darwish',
  'mahmoud jibril',
  'mahmud i',
  'mahmud ii',
  'mahmud of ghazni',
  'maimonides',
  'mairead maguire',
  'maite perroni',
  'majorian',
  'makarios iii',
  'makoto hasebe',
  'makoto kobayashi (physicist)',
  'maktoum bin rashid al maktoum',
  'malala yousafzai',
  'malam bacai sanhá',
  'malcolm iii of scotland',
  'malcolm mcdowell',
  'malcolm x',
  'malcolm young',
  'malena ernman',
  'malietoa tanumafili ii',
  'malik-shah i',
  'mamadou tandja',
  'mame biram diouf',
  'mamie eisenhower',
  'man ray',
  'mancini (brazilian footballer)',
  'manco cápac',
  'mandy moore',
  'manetho',
  'manfred eigen',
  'manfred von richthofen',
  'manfred, king of sicily',
  'mani (prophet)',
  'maniche',
  'manmohan singh',
  'manne siegbahn',
  'manny mori',
  'manny pacquiao',
  'manolo escobar',
  'mansur al-hallaj',
  'manu chao',
  'manu ginóbili',
  'manucho',
  'manuel almunia',
  'manuel azaña',
  'manuel belgrano',
  'manuel castells',
  'manuel de falla',
  'manuel fernandes (footballer born 1986)',
  'manuel i komnenos',
  'manuel i of portugal',
  'manuel ii of portugal',
  'manuel ii palaiologos',
  'manuel l. quezon',
  'manuel neuer',
  'manuel noriega',
  'manuel pellegrini',
  'manuel pinto da costa',
  'manuel rivera-ortiz',
  'manuel roxas',
  'manuel zelaya',
  'mao zedong',
  'marat izmailov',
  'marat safin',
  'marc albrighton',
  'marc anthony',
  'marc bartra',
  'marc bloch',
  'marc chagall',
  'marc gené',
  'marc overmars',
  'marc ravalomanana',
  'marc-antoine charpentier',
  'marc-vivien foé',
  'marcel dassault',
  'marcel desailly',
  'marcel duchamp',
  'marcel lefebvre',
  'marcel marceau',
  'marcel mauss',
  'marcel pagnol',
  'marcel proust',
  'marcel schmelzer',
  'marcell jansen',
  'marcellin berthelot',
  'marcello lippi',
  'marcello malpighi',
  'marcello mastroianni',
  'marcelo bielsa',
  'marcelo caetano',
  'marcelo h. del pilar',
  'marcelo ríos',
  'marcelo salas',
  'marcelo vieira',
  'marcia cross',
  'marcia gay harden',
  'marcian',
  'marcion of sinope',
  'marco amelia',
  'marco borriello',
  'marco di vaio',
  'marco hietala',
  'marco materazzi',
  'marco pantani',
  'marco polo',
  'marco reus',
  'marco simoncelli',
  'marco van basten',
  'marcos baghdatis',
  'marcos senna',
  'marcus aemilius lepidus (triumvir)',
  'marcus aurelius',
  'marcus aurelius probus',
  'marcus claudius marcellus',
  'marcus claudius tacitus',
  'marcus furius camillus',
  'marcus garvey',
  'marcus grönholm',
  'marcus junius brutus the younger',
  'marcus licinius crassus',
  'marcus stephen',
  'marcus terentius varro',
  'marcus vipsanius agrippa',
  'mardonius',
  'mardy fish',
  'marek edelman',
  'marek hamšík',
  'marek jankulovski',
  'margaret atwood',
  'margaret beaufort, countess of richmond and derby',
  'margaret court',
  'margaret i of denmark',
  'margaret mead',
  'margaret mitchell',
  'margaret of austria, duchess of savoy',
  'margaret of austria, queen of spain',
  'margaret of valois',
  'margaret thatcher',
  'margaret the virgin',
  'margaret tudor',
  'margaret, maid of norway',
  'margrethe ii of denmark',
  'marguerite de navarre',
  'marguerite duras',
  'marguerite yourcenar',
  'mari kiviniemi',
  'maria alexandrovna (marie of hesse)',
  'maria callas',
  'maria feodorovna (dagmar of denmark)',
  'maria gaetana agnesi',
  'maria goeppert-mayer',
  'maria i of portugal',
  'maria ii of portugal',
  'maria kaczyńska',
  'maria kirilenko',
  'maria montessori',
  'maria mutola',
  'maria schneider (actress)',
  'maria sharapova',
  'maria theresa',
  'maria theresa of spain',
  'mariah carey',
  'marian rejewski',
  'mariana of austria',
  'mariano josé de larra',
  'mariano rajoy',
  'marie antoinette',
  'marie curie',
  'marie de rabutin-chantal, marquise de sévigné',
  "marie de' medici",
  'marie dressler',
  'marie françois sadi carnot',
  'marie leszczyńska',
  'marie louise, duchess of parma',
  'marie thérèse of france',
  'marie tussaud',
  'marie-adélaïde, grand duchess of luxembourg',
  'marie-josé pérec',
  'marija gimbutas',
  'marija šerifović',
  'marilyn manson',
  'marilyn monroe',
  'marin čilić',
  'marin marais',
  'marin mersenne',
  'marina tsvetaeva',
  'marine le pen',
  'mario ančić',
  'mario andretti',
  'mario balotelli',
  'mario benedetti',
  'mario botta',
  'mario capecchi',
  'mario draghi',
  'mario gómez',
  'mario götze',
  'mario j. molina',
  'mario kempes',
  'mario lanza',
  'mario mandžukić',
  'mario monti',
  'mario puzo',
  'mário soares',
  'mario vargas llosa',
  'mario yepes',
  'marion bartoli',
  'marion cotillard',
  'marion jones',
  'māris verpakovskis',
  'marisa tomei',
  'marit bjørgen',
  'marita koch',
  'mariza',
  'marjane satrapi',
  'mark antony',
  'mark cavendish',
  'mark david chapman',
  'mark gonzález',
  'mark hamill',
  'mark harmon',
  'mark hoppus',
  'mark hughes',
  'mark knopfler',
  'mark rothko',
  'mark ruffalo',
  'mark rutte',
  'mark schwarzer',
  'mark shuttleworth',
  'mark spitz',
  'mark the evangelist',
  'mark twain',
  'mark van bommel',
  'mark viduka',
  'mark wahlberg',
  'mark webber',
  'mark zuckerberg',
  'marko marin',
  'marko pantelić',
  'markus merk',
  'markus rosenberg',
  'markus wolf',
  'marlee matlin',
  'marlene dietrich',
  'marlon brando',
  'marlon wayans',
  'marouane chamakh',
  'marouane fellaini',
  'marouf al-bakhit',
  'marquis de condorcet',
  'marquis de sade',
  'marshall allman',
  'marshall mcluhan',
  'marshall warren nirenberg',
  'marsilio ficino',
  'mart poom',
  'marta (footballer)',
  'martha argerich',
  'martha graham',
  'martha washington',
  'martial',
  'martin amis',
  'martin bormann',
  'martin buber',
  'martín cáceres',
  'martin chalfie',
  'martin de porres',
  'martín demichelis',
  'martin evans',
  'martin freeman',
  'martin frobisher',
  'martin gardner',
  'martin gore',
  'martin heinrich klaproth',
  'martin jol',
  'martin kelly',
  'martin landau',
  'martin lawrence',
  'martin lewis perl',
  'martin luther',
  'martin luther king, jr.',
  'martin niemöller',
  "martin o'neill",
  'martin of tours',
  'martín palermo',
  'martin petrov',
  'martin rodbell',
  'martin ryle',
  'martin schongauer',
  'martin schulz',
  'martin scorsese',
  'martin sheen',
  'martin škrtel',
  'martín torrijos',
  'martin van buren',
  'martin waldseemüller',
  'martin weinek',
  'martina hingis',
  'martina navratilova',
  'martine aubry',
  'martinus j. g. veltman',
  'martti ahtisaari',
  'marty friedman',
  'marvin gaye',
  'marvin minsky',
  'marwan i',
  'mary (mother of jesus)',
  'mary blair',
  'mary boleyn',
  'mary cassatt',
  'mary dyer',
  'mary elizabeth winstead',
  'mary faustina kowalska',
  'mary harris jones',
  'mary i of england',
  'mary ii of england',
  'mary j. blige',
  'mary leakey',
  'mary lynn rajskub',
  'mary magdalene',
  'mary mcaleese',
  'mary mcdonnell',
  'mary of burgundy',
  'mary of hungary (governor of the netherlands)',
  'mary of teck',
  'mary pickford',
  'mary pierce',
  'mary robinson',
  'mary shelley',
  'mary steenburgen',
  'mary todd lincoln',
  'mary tudor, queen of france',
  'mary wollstonecraft',
  'mary, crown princess of denmark',
  'mary, queen of hungary',
  'mary, queen of scots',
  'mas oyama',
  'masaccio',
  'masahiko kimura',
  'masashi kishimoto',
  'masatoshi koshiba',
  'masi oka',
  'masiela lusha',
  'massimiliano allegri',
  'massimo ambrosini',
  'massimo busacca',
  "massimo d'alema",
  'massimo moratti',
  'massimo oddo',
  'massoud barzani',
  'mata hari',
  'mateja kežman',
  'mathias rust',
  'mathieu debuchy',
  'mathieu flamini',
  'mathieu kassovitz',
  'mathieu kérékou',
  'mathieu valbuena',
  'matilda of flanders',
  'matilde camus',
  'matisyahu',
  'mats hummels',
  'mats wilander',
  'matsukata masayoshi',
  'matsuo bashō',
  'matt biondi',
  'matt busby',
  'matt damon',
  'matt dillon',
  'matt groening',
  'matt hardy',
  'matt leblanc',
  'matt stone',
  'matteo ricci',
  'matthew arnold',
  'matthew bellamy',
  'matthew broderick',
  'matthew c. perry',
  'matthew flinders',
  'matthew fox',
  'matthew lewis (actor)',
  'matthew mcconaughey',
  'matthew morrison',
  'matthew perry',
  'matthew upson',
  'matthias corvinus',
  'matthias grünewald',
  'matthias jakob schleiden',
  'matthias sammer',
  'matthias, holy roman emperor',
  'matti nykänen',
  'matti vanhanen',
  'mátyás rákosi',
  'maud of wales',
  'maumoon abdul gayoom',
  'mauno koivisto',
  "maureen o'hara",
  'maurice (emperor)',
  'maurice allais',
  'maurice béjart',
  'maurice chevalier',
  'maurice de vlaminck',
  'maurice druon',
  'maurice garin',
  'maurice gibb',
  'maurice greene (athlete)',
  'maurice jarre',
  'maurice maeterlinck',
  'maurice merleau-ponty',
  'maurice ravel',
  'maurice sendak',
  'maurice utrillo',
  'maurice wilkins',
  'mauricio funes',
  'mauricio isla',
  'mauro camoranesi',
  'mausolus',
  'max beckmann',
  'max born',
  'max brod',
  'max bruch',
  'max delbrück',
  'max ernst',
  'max euwe',
  'max frisch',
  'max horkheimer',
  'max jacob',
  'max liebermann',
  'max mirnyi',
  'max müller',
  'max perutz',
  'max planck',
  'max reger',
  'max scheler',
  'max schmeling',
  'max stirner',
  'max theiler',
  'max von laue',
  'max von sydow',
  'max weber',
  'max wolf',
  'maxentius',
  'maxi lópez',
  'maxi rodríguez',
  'maxim gorky',
  'maximian',
  'maximilian i joseph of bavaria',
  'maximilian i of mexico',
  'maximilian i, elector of bavaria',
  'maximilian i, holy roman emperor',
  'maximilian ii of bavaria',
  'maximilian ii, holy roman emperor',
  'maximilian kolbe',
  'maximilian schell',
  'maximilian von weichs',
  'maximiliano pereira',
  'maximilien de robespierre',
  'maximinus ii',
  'maximinus thrax',
  'maximus the confessor',
  'maxwell cabelino andrade',
  'maya angelou',
  'maya plisetskaya',
  'mayumi iizuka',
  'mazdak',
  'mc hammer',
  'meat loaf',
  'meg ryan',
  'megan fox',
  'megasthenes',
  'megawati sukarnoputri',
  'mehmed i',
  'mehmed iii',
  'mehmed iv',
  'mehmed the conqueror',
  'mehmed v',
  'mehmed vi',
  'mehmet ali ağca',
  'mehmet ali talat',
  'mehmet scholl',
  'meister eckhart',
  'mel brooks',
  'mel gibson',
  'melanie brown',
  'melanie chisholm',
  'melanie griffith',
  'melanie klein',
  'mélanie laurent',
  'melchizedek',
  'meles zenawi',
  'melina mercouri',
  'melinda gates',
  'melissus of samos',
  'melvil dewey',
  'melvin calvin',
  'melvin schwartz',
  'mena suvari',
  'menachem begin',
  'menander',
  'mencius',
  'menelik ii',
  'menes',
  'mengistu haile mariam',
  'menkaure',
  'mentuhotep ii',
  'mercè rodoreda',
  'mercedes ruehl',
  'mercedes sosa',
  'merneptah',
  'merovech',
  'merton miller',
  'meryl streep',
  'mesrop mashtots',
  'mesut özil',
  'metastasio',
  'method man',
  'methuselah',
  'metta world peace',
  'mia farrow',
  'mia hamm',
  'mia wasikowska',
  'micah richards',
  'michael adams (chess player)',
  'michael andreas barclay de tolly',
  'michael atiyah',
  'michael ballack',
  'michael bay',
  'michael biehn',
  'michael bloomberg',
  'michael bradley (soccer)',
  'michael bublé',
  'michael c. hall',
  'michael caine',
  'michael carrick',
  'michael cera',
  'michael chang',
  'michael cimino',
  'michael clarke duncan',
  'michael collins (astronaut)',
  'michael collins (irish leader)',
  'michael crichton',
  'michael curtiz',
  'michael d. higgins',
  'michael dawson (footballer)',
  'michael dell',
  'michael douglas',
  'michael e. brown',
  'michael emerson',
  'michael ende',
  'michael essien',
  'michael faraday',
  'michael fassbender',
  'michael gambon',
  'michael gough',
  'michael greis',
  'michael haneke',
  'michael haydn',
  'michael i of russia',
  'michael i rangabe',
  'michael ii',
  'michael iii',
  'michael iv the paphlagonian',
  'michael ix palaiologos',
  'michael j. fox',
  'michael jackson',
  'michael johnson (sprinter)',
  'michael jordan',
  'michael keaton',
  'michael krohn-dehli',
  'michael laudrup',
  'michaël llodra',
  'michael madsen',
  'michael mann (director)',
  'michael moore',
  'michael of romania',
  'michael ondaatje',
  'michael owen',
  'michael palin',
  'michael phelps',
  'michael porter',
  'michael praetorius',
  'michael psellos',
  'michael reiziger',
  'michael rensing',
  'michael sata',
  'michael schumacher',
  'michael servetus',
  'michael shanks',
  'michael sheen',
  'michael smith (chemist)',
  'michael spence',
  'michael stich',
  'michael stipe',
  'michael stuart brown',
  'michael the brave',
  'michael v kalaphates',
  'michael vartan',
  'michael ventris',
  'michael vi bringas',
  'michael vii doukas',
  'michael viii palaiologos',
  'michael wittmann',
  'michael york (actor)',
  'michaëlle jean',
  'michal kadlec',
  'michel butor',
  'michel de montaigne',
  'michel debré',
  'michel eugène chevreul',
  'michel foucault',
  'michel hazanavicius',
  'michel houellebecq',
  'michel martelly',
  'michel ney',
  'michel piccoli',
  'michel platini',
  'michel rocard',
  'míchel salgado',
  'michel suleiman',
  'michel teló',
  'michel vorm',
  'michelangelo',
  'michelangelo antonioni',
  'michele alboreto',
  'michele bachmann',
  'micheline calmy-rey',
  'michelle bachelet',
  'michelle branch',
  'michelle monaghan',
  'michelle obama',
  'michelle pfeiffer',
  'michelle rodriguez',
  'michelle trachtenberg',
  'michelle williams (actress)',
  'michelle yeoh',
  'michelozzo',
  'michio kaku',
  'mick foley',
  'mick jagger',
  'mickaël landreau',
  'mickey rooney',
  'mickey rourke',
  'mido (footballer)',
  'miep gies',
  'mieszko i of poland',
  'mieszko ii lambert',
  'miguel ángel asturias',
  'miguel ángel nadal',
  'miguel de cervantes',
  'miguel de la madrid',
  'miguel de unamuno',
  'miguel hidalgo y costilla',
  'miguel i of portugal',
  'miguel indurain',
  'miguel monteiro',
  'miguel najdorf',
  'miguel primo de rivera',
  'miguel veloso',
  'mihai eminescu',
  'mihai ghimpu',
  'mika (singer)',
  'mika häkkinen',
  'mika waltari',
  'mikael agricola',
  'mikaël silvestre',
  'mikalojus konstantinas čiurlionis',
  'mike dirnt',
  'mike epps',
  'mike hanke',
  'mike hawthorn',
  'mike huckabee',
  'mike myers',
  'mike nichols',
  'mike oldfield',
  'mike portnoy',
  'mike powell (athlete)',
  'mike shinoda',
  'mike tyson',
  'mikel arteta',
  'mikel john obi',
  'mikhail bakhtin',
  'mikhail bakunin',
  'mikhail baryshnikov',
  'mikhail botvinnik',
  'mikhail bulgakov',
  'mikhail chigorin',
  'mikhail fradkov',
  'mikhail frunze',
  'mikhail glinka',
  'mikhail gorbachev',
  'mikhail kalashnikov',
  'mikhail kalinin',
  'mikhail kasyanov',
  'mikhail khodorkovsky',
  'mikhail kutuzov',
  'mikhail lermontov',
  'mikhail lomonosov',
  'mikhail prokhorov',
  'mikhail saltykov-shchedrin',
  'mikhail sholokhov',
  'mikhail tal',
  'mikhail tukhachevsky',
  'mikhail vrubel',
  'mikhail youzhny',
  'mikheil saakashvili',
  'mikis theodorakis',
  'miklós fehér',
  'miklós horthy',
  'mikuláš dzurinda',
  'mila kunis',
  'milan baroš',
  'milan jovanović (footballer born 1981)',
  'milan kučan',
  'milan kundera',
  'milan stanković',
  'milarepa',
  'miles davis',
  'mileva marić',
  'miley cyrus',
  'milivoje novaković',
  'milla jovovich',
  'millard fillmore',
  'millvina dean',
  'milo đukanović',
  'milo ventimiglia',
  'milorad čavić',
  'milorad pavić (writer)',
  'miloš forman',
  'miloš krasić',
  'miloš obrenović i, prince of serbia',
  'miloš zeman',
  'milovan đilas',
  'miltiades',
  'milton friedman',
  'milton obote',
  'milutin milanković',
  'mily balakirev',
  'mimar sinan',
  'minamoto no yoritomo',
  'minamoto no yoshitsune',
  'mindaugas',
  'minnie driver',
  'mir-hossein mousavi',
  'mira furlan',
  'mira sorvino',
  'miralem pjanić',
  'miranda cosgrove',
  'miranda kerr',
  'miranda richardson',
  'mircea eliade',
  'mireille mathieu',
  'mirek topolánek',
  'miriam',
  'miriam makeba',
  'mirko cvetković',
  'mirko vučinić',
  'miroslav klose',
  'mirza ghulam ahmad',
  'mischa barton',
  'missy elliott',
  'missy franklin',
  'mitch mitchell',
  'mitchel musso',
  'mithridates i of parthia',
  'mithridates ii of parthia',
  'mithridates vi of pontus',
  'mitt romney',
  'miyamoto musashi',
  'mladen petrić',
  'mo farah',
  'mo yan',
  'mobutu sese seko',
  'moby',
  'moctezuma ii',
  'modest mussorgsky',
  'modibo keïta',
  'mohamed atta',
  'mohamed bouazizi',
  'mohamed elbaradei',
  'mohamed ghannouchi',
  'mohamed hussein tantawi',
  'mohamed morsi',
  'mohamed nasheed',
  'mohamed ould abdel aziz',
  'mohamed sissoko',
  'mohamed zidan',
  'mohammad khatami',
  'mohammad mosaddegh',
  'mohammad najibullah',
  'mohammad reza pahlavi',
  'mohammad-ali rajai',
  'mohammed bin rashid al maktoum',
  'mohammed daoud khan',
  'mohammed omar',
  'mohammed v of morocco',
  'mohammed vi of morocco',
  'mohammed waheed hassan',
  'mohammed zahir shah',
  'molière',
  'moncef marzouki',
  'möngke khan',
  'monica bellucci',
  'monica lewinsky',
  'monica seles',
  'monica vitti',
  'montesquieu',
  'montgomery clift',
  'montserrat caballé',
  'moon geun-young',
  'morarji desai',
  'mordechai vanunu',
  'morgan de sanctis',
  'morgan freeman',
  'morgan tsvangirai',
  'morihei ueshiba',
  'moritz bleibtreu',
  'moritz leuenberger',
  'moritz schlick',
  'morrissey',
  'morten gamst pedersen',
  'morten olsen',
  'mos def',
  'moses',
  'moses mendelssohn',
  'moshe dayan',
  'moshe katsav',
  'moshe sharett',
  'mother teresa',
  'moulay rachid ben al hassan',
  'moussa dadis camara',
  'moustapha salifou',
  'mozi',
  'mr. t',
  'mstislav rostropovich',
  'mswati iii',
  'muammar gaddafi',
  'muawiya ii',
  'muawiyah i',
  'muddy waters',
  'muhammad',
  'muhammad abduh',
  'muhammad ahmad',
  'muhammad al-baqir',
  'muhammad al-bukhari',
  'muhammad al-idrisi',
  'muhammad al-mahdi',
  'muhammad ali',
  'muhammad ali jinnah',
  'muhammad ali of egypt',
  "muhammad ibn 'abd al-karim al-khattabi",
  'muhammad ibn abd al-wahhab',
  'muḥammad ibn jābir al-ḥarrānī al-battānī',
  'muhammad ibn jarir al-tabari',
  'muḥammad ibn mūsā al-khwārizmī',
  'muhammad ibn zakariya al-razi',
  'muhammad iqbal',
  'muhammad naguib',
  'muhammad yunus',
  'muhammad zia-ul-haq',
  'mukesh ambani',
  'multatuli',
  'mumtaz mahal',
  'mungo park (explorer)',
  'muntadhar al-zaidi',
  'muqtada al-sadr',
  'murad i',
  'murad ii',
  'murad iii',
  'murad iv',
  'murad v',
  'murasaki shikibu',
  'murray gell-mann',
  'murray rothbard',
  'musa i of mali',
  'muslim ibn al-hajjaj',
  'mustafa abdul jalil',
  'mustafa i',
  'mustafa ii',
  'mustafa iii',
  'mustafa iv',
  'mustafa kemal atatürk',
  'muzio clementi',
  'mwai kibaki',
  'mykola azarov',
  'mylène farmer',
  'myron',
  'myron scholes',
  'nabonidus',
  'nabopolassar',
  'nadab of israel',
  'nadar (photographer)',
  'nader shah',
  'nadezhda krupskaya',
  'nadia boulanger',
  'nadia comăneci',
  'nadia petrova',
  'nadine gordimer',
  'nagarjuna',
  'naguib mahfouz',
  'najib razak',
  'nambaryn enkhbayar',
  'nana mouskouri',
  'nancy ajram',
  'nancy cartwright',
  'nancy pelosi',
  'nancy reagan',
  'nancy sinatra',
  'nani',
  'nanni moretti',
  'naomi campbell',
  'naomi klein',
  'naomi watts',
  'naomie harris',
  'naoto kan',
  'napoleon',
  'napoleon ii',
  'napoleon iii',
  'narain karthikeyan',
  'naram-sin of akkad',
  'narmer',
  'narseh',
  'narses',
  'nas',
  'naser al-din shah qajar',
  'nasir al-din al-tusi',
  'nasreddin',
  'nastassja kinski',
  'nat king cole',
  'natalie imbruglia',
  'natalie portman',
  'natalie wood',
  'natascha kampusch',
  'natasha bedingfield',
  'natasha richardson',
  'nate dogg',
  'nathalia dill',
  'nathalie sarraute',
  'nathan fillion',
  'nathan lane',
  'nathan söderblom',
  'nathaniel hawthorne',
  'nathuram godse',
  'natsume sōseki',
  'naveen andrews',
  'nawaz sharif',
  'nâzım hikmet ran',
  'ne win',
  'ne-yo',
  'nebojša radmanović',
  'nebuchadnezzar ii',
  'necho ii',
  'necmettin erbakan',
  'ned kelly',
  'neferirkare kakai',
  'nefertari',
  'nefertiti',
  'nehemiah',
  'neil armstrong',
  'neil degrasse tyson',
  'neil diamond',
  'neil gaiman',
  'neil patrick harris',
  'neil young',
  'nelly',
  'nelly furtado',
  'nelly sachs',
  'nelson haedo valdez',
  'nelson mandela',
  'nelson piquet',
  'nelson piquet, jr.',
  'nelson rockefeller',
  'nemanja matić',
  'nemanja vidić',
  'nena',
  'nero',
  'nero claudius drusus',
  'nerva',
  'nestor carbonell',
  'néstor kirchner',
  'nestor makhno',
  'nestorius',
  'neve campbell',
  'neven subotić',
  'nevill francis mott',
  'neville chamberlain',
  'newt gingrich',
  'neymar',
  'ngô bảo châu',
  'ngo dinh diem',
  "ngũgĩ wa thiong'o",
  'nguyen du',
  'nguyen minh triet',
  'nguyen tan dung',
  'niamh kavanagh',
  'nicanor duarte',
  'niccolò fontana tartaglia',
  'niccolò machiavelli',
  'niccolò paganini',
  'niccolò piccinni',
  'nicéphore niépce',
  'nichi vendola',
  'nicholas hoult',
  'nicholas i of montenegro',
  'nicholas i of russia',
  'nicholas ii of russia',
  'nicholas murray butler',
  'nicholas of cusa',
  'nicholas roerich',
  'nicholas sparks',
  'nick carter (musician)',
  'nick cave',
  'nick clegg',
  'nick drake',
  'nick griffin',
  'nick heidfeld',
  'nick jonas',
  'nick mason',
  'nick nolte',
  'nick vujicic',
  'nicki minaj',
  'nicklas bendtner',
  'nicko mcbrain',
  'nicky butt',
  'nicky hilton',
  'nico',
  'nico hülkenberg',
  'nico rosberg',
  'nicodemus',
  'nicola abbagnano',
  'nicolaas bloembergen',
  'nicolae ceaușescu',
  'nicolae timofti',
  'nicolás almagro',
  'nicolas anelka',
  'nicolas appert',
  'nicolas boileau-despréaux',
  'nicolás burdisso',
  'nicolas cage',
  'nicolas flamel',
  'nicolas jean-de-dieu soult',
  'nicolas léonard sadi carnot',
  'nicolas louis de lacaille',
  'nicolas malebranche',
  'nicolás massú',
  'nicolás otamendi',
  'nicolas poussin',
  'nicolas sarkozy',
  'nicolas steno',
  'nicolas-joseph cugnot',
  'nicolaus copernicus',
  'nicole (chilean singer)',
  'nicole kidman',
  'nicole oresme',
  'nicole richie',
  'nicole scherzinger',
  'nicole vaidišová',
  'nicos anastasiades',
  'niels bohr',
  'niels gade',
  'niels henrik abel',
  'niels kaj jerne',
  'niels ryberg finsen',
  'nigar jamal',
  'nigel de jong',
  'nigel hawthorne',
  'nigel mansell',
  'nigel reo-coker',
  'nihat kahveci',
  'nikephoros i',
  'nikephoros ii phokas',
  'nikephoros iii botaneiates',
  'niketas choniates',
  'niki lauda',
  'nikica jelavić',
  'nikita khrushchev',
  'nikita mikhalkov',
  'nikki reed',
  'niklas luhmann',
  'niklaus wirth',
  'niko kovač',
  'niko kranjčar',
  'niko pirosmani',
  'nikola gruevski',
  'nikola kalinić',
  'nikola tesla',
  'nikola žigić',
  'nikolaas tinbergen',
  'nikolai andrianov',
  'nikolai berdyaev',
  'nikolai bukharin',
  'nikolai fyodorovich vatutin',
  'nikolai gogol',
  'nikolai leskov',
  'nikolai lobachevsky',
  'nikolai ostrovsky',
  'nikolai podgorny',
  'nikolai rimsky-korsakov',
  'nikolai trubetzkoy',
  'nikolai vavilov',
  'nikolai yezhov',
  'nikolai yudenich',
  'nikolaus otto',
  'nikolay basov',
  'nikolay chernyshevsky',
  'nikolay davydenko',
  'nikolay karamzin',
  'nikolay nekrasov',
  'nikolay przhevalsky',
  'nikolay semyonov',
  'nikolay yegorovich zhukovsky',
  'nikos kazantzakis',
  'nilmar',
  'nílton santos',
  'nimrod',
  'nina dobrev',
  'nina hagen',
  'nina simone',
  'nino burjanadze',
  'nino rota',
  'nizam al-mulk',
  'nizami ganjavi',
  'nnamdi azikiwe',
  'noah webster',
  'noam chomsky',
  'nodar kumaritashvili',
  'noël coward',
  'noel gallagher',
  'noemi (singer)',
  'noomi rapace',
  'nora ephron',
  'norah jones',
  'norbert elias',
  'norbert wiener',
  'norma shearer',
  'norman angell',
  'norman borlaug',
  'norman cook',
  'norman finkelstein',
  'norman foster ramsey, jr.',
  'norman foster, baron foster of thames bank',
  'norman haworth',
  'norman mailer',
  'norman rockwell',
  'norman schwarzkopf, jr.',
  'norodom sihamoni',
  'norodom sihanouk',
  'nostradamus',
  'nouri al-maliki',
  'novak djokovic',
  'novalis',
  'novatian',
  'numa pompilius',
  'numerian',
  'nuno gomes',
  'nur ad-din zangi',
  'nur muhammad taraki',
  'nurhaci',
  'nuri şahin',
  'nursultan nazarbayev',
  'nusrat fateh ali khan',
  'nwankwo kanu',
  'nynetjer',
  'o. henry',
  'o. j. simpson',
  'obafemi martins',
  'octave mirbeau',
  'octavio paz',
  'oda nobunaga',
  'odd hassel',
  'odilon redon',
  'odo of france',
  'odoacer',
  'odysseas elytis',
  'offa of mercia',
  'ofra haza',
  'ögedei khan',
  'ognjen vukojević',
  'oguchi onyewu',
  'ōkuma shigenobu',
  'olaf i of norway',
  'olaf ii of norway',
  'ólafur ragnar grímsson',
  'olav v of norway',
  'ole einar bjørndalen',
  'ole gunnar solskjær',
  'ole rømer',
  'oleg of novgorod',
  'oleg salenko',
  'oleh blokhin',
  'oleh husyev',
  'oleksandr shovkovskiy',
  'olga constantinovna of russia',
  'olga korbut',
  'olga kurylenko',
  'olga of kiev',
  'oliver bierhoff',
  'oliver cromwell',
  'oliver e. williamson',
  'oliver goldsmith',
  'oliver hardy',
  'oliver heaviside',
  'oliver kahn',
  'oliver neuville',
  'oliver riedel',
  'oliver smithies',
  'oliver stone',
  'olivia de havilland',
  'olivia newton-john',
  'olivia wilde',
  'olivier giroud',
  'olivier messiaen',
  'olivier panis',
  'ollanta humala',
  'olli rehn',
  'olof mellberg',
  'olof palme',
  'olusegun obasanjo',
  'olybrius',
  'olympe de gouges',
  'olympias',
  'omar al-bashir',
  'omar bongo',
  'omar bradley',
  'omar epps',
  'omar khayyám',
  'omar mukhtar',
  'omar sharif',
  'omar sívori',
  'omar suleiman',
  'omurtag of bulgaria',
  'oprah winfrey',
  'orestes (father of romulus augustulus)',
  'orhan',
  'orhan pamuk',
  'oriana fallaci',
  'origen',
  'oriol romeu',
  'orlande de lassus',
  'orlando bloom',
  'ornella muti',
  'ornette coleman',
  'orson scott card',
  'orson welles',
  'osama bin laden',
  'osamu shimomura',
  'osamu tezuka',
  'óscar arias',
  'óscar cardozo',
  'oscar i of sweden',
  'oscar ii of sweden',
  'oscar luigi scalfaro',
  'oscar niemeyer',
  'oscar peterson',
  'oscar pistorius',
  'oscar robertson',
  'óscar romero',
  'oscar wilde',
  'osip mandelstam',
  'oskar kokoschka',
  'oskar lafontaine',
  'oskar schindler',
  'osman i',
  'osman ii',
  'osman iii',
  'ossip zadkine',
  'oswald spengler',
  'othniel charles marsh',
  'otho',
  'otis redding',
  'ottmar hitzfeld',
  'otto diels',
  'otto dix',
  'otto fritz meyerhof',
  'otto hahn',
  'otto heinrich warburg',
  'otto i, holy roman emperor',
  'otto ii, holy roman emperor',
  'otto iii, holy roman emperor',
  'otto iv, holy roman emperor',
  'otto jespersen',
  'otto klemperer',
  'otto lilienthal',
  'otto loewi',
  'otto nicolai',
  'otto of greece',
  'otto preminger',
  'otto rehhagel',
  'otto skorzeny',
  'otto stern',
  'otto von bismarck',
  'otto von guericke',
  'otto von habsburg',
  'otto wagner',
  'otto wallach',
  'otto weininger',
  'ottokar ii of bohemia',
  'ottorino respighi',
  'ovid',
  'owen chamberlain',
  'owen hargreaves',
  'owen willans richardson',
  'owen wilson',
  'ozzy osbourne',
  'p. g. wodehouse',
  'p. t. barnum',
  'p. v. narasimha rao',
  'p. w. botha',
  'paavo lipponen',
  'paavo nurmi',
  'pablo aimar',
  'pablo casals',
  'pablo de sarasate',
  'pablo escobar',
  'pablo hernández domínguez',
  'pablo neruda',
  'pablo picasso',
  'pablo zabaleta',
  'pachacuti',
  'pachomius the great',
  'paco de lucía',
  'padmasambhava',
  'pafnuty chebyshev',
  'pál schmitt',
  'palmiro togliatti',
  'pamela anderson',
  'panaetius',
  'panchen lama',
  'pancho villa',
  'pāṇini',
  'paolo bettini',
  'paolo borsellino',
  'paolo di canio',
  'paolo guerrero',
  'paolo maldini',
  'paolo rossi',
  'paolo uccello',
  'paolo veronese',
  'papias of hierapolis',
  'papiss cissé',
  'pappus of alexandria',
  'pär lagerkvist',
  'paracelsus',
  'paramahansa yogananda',
  'paris hilton',
  'park chu-young',
  'park chung-hee',
  'park geun-hye',
  'park ji-sung',
  'parker posey',
  'parmenides',
  'parmenion',
  'parmigianino',
  'pascal chimbonda',
  'pascal couchepin',
  'pascal zuberbühler',
  'pasquale paoli',
  'pastor maldonado',
  'pastora soler',
  'pat cash',
  'pat metheny',
  'pat morita',
  'pat nixon',
  'patriarch bartholomew i of constantinople',
  'patrice de mac-mahon, duke of magenta',
  'patrice evra',
  'patrice lumumba',
  'patricia arquette',
  'patricia highsmith',
  'patricia kaas',
  'patricia neal',
  'patricio aylwin',
  'patrick blackett, baron blackett',
  'patrick dempsey',
  'patrick ewing',
  'patrick hillery',
  'patrick kluivert',
  'patrick mcgoohan',
  'patrick moore',
  'patrick pearse',
  'patrick rafter',
  'patrick stewart',
  'patrick süskind',
  'patrick swayze',
  'patrick vieira',
  'patrick white',
  'patsy cline',
  'patti page',
  'patti smith',
  'patty schnyder',
  'pau gasol',
  'paul allen',
  'paul anka',
  'paul auster',
  'paul berg',
  'paul bettany',
  'paul biya',
  'paul breitner',
  'paul celan',
  'paul cézanne',
  'paul claudel',
  'paul cohen (mathematician)',
  'paul d. boyer',
  'paul deschanel',
  'paul di resta',
  'paul dirac',
  'paul doumer',
  'paul dukas',
  'paul ehrlich',
  'paul éluard',
  'paul erdős',
  'paul feyerabend',
  'paul flory',
  'paul gascoigne',
  'paul gauguin',
  'paul giamatti',
  'paul greengard',
  'paul hausser',
  'paul hermann müller',
  'paul heyse',
  'paul hindemith',
  'paul hogan',
  'paul i of russia',
  'paul ince',
  'paul j. crutzen',
  'paul kagame',
  'paul karrer',
  'paul keating',
  'paul keres',
  'paul klee',
  'paul kruger',
  'paul krugman',
  'paul landers',
  'paul langevin',
  'paul lauterbur',
  'paul ludwig ewald von kleist',
  'paul martin',
  'paul mccartney',
  'paul morphy',
  'paul muni',
  'paul newman',
  'paul nurse',
  'paul of greece',
  'paul pierce',
  'paul reuter',
  'paul reynaud',
  'paul ricœur',
  'paul robeson',
  'paul robinson (footballer born 1979)',
  'paul rudd',
  'paul ryan',
  'paul samuelson',
  'paul scholes',
  'paul scofield',
  'paul signac',
  'paul simon',
  'paul stanley',
  'paul the apostle',
  'paul the deacon',
  'paul tibbets',
  'paul tillich',
  'paul valéry',
  'paul van dyk',
  'paul verhoeven',
  'paul verlaine',
  'paul von hindenburg',
  'paul von lettow-vorbeck',
  'paul walker',
  'paul wesley',
  'paul wolfowitz',
  'paul-henri mathieu',
  'paul-henri spaak',
  "paul-henri-benjamin d'estournelles de constant",
  'paula abdul',
  'paula fernandes',
  'pauleta',
  'paulette goddard',
  'paulina rubio',
  'paulo coelho',
  'paulo ferreira',
  'paulo freire',
  'paulo mendes da rocha',
  'paulo wanchope',
  'pausanias (geographer)',
  'pavel cherenkov',
  'pavel nedvěd',
  'pavel pogrebnyak',
  'pavel tretyakov',
  'paz vega',
  'pearl s. buck',
  'pedanius dioscorides',
  'pedro almodóvar',
  'pedro álvares cabral',
  'pedro calderón de la barca',
  'pedro de alvarado',
  'pedro de la rosa',
  'pedro de valdivia',
  'pedro i of brazil',
  'pedro ii of brazil',
  'pedro passos coelho',
  'pedro pires',
  'pedro rodríguez ledesma',
  'peggy ashcroft',
  'peggy lee',
  'pehr evind svinhufvud',
  'peisistratos',
  'peja stojaković',
  'pelagius',
  'pelagius of asturias',
  'pelé',
  'penélope cruz',
  'pep guardiola',
  'pepe (footballer born 1983)',
  'pepe reina',
  'pepi i meryre',
  'pepi ii neferkare',
  'pepin of herstal',
  'pepin of italy',
  'pepin of landen',
  'pepin the short',
  'per mertesacker',
  'percival lowell',
  'percy bysshe shelley',
  'percy williams bridgman',
  'perdiccas',
  'pericles',
  'pérotin',
  'peroz i',
  'perseus of macedon',
  'pertinax',
  'pervez musharraf',
  'pescennius niger',
  'petar stoyanov',
  'pete best',
  'pete conrad',
  'pete postlethwaite',
  'pete sampras',
  'pete seeger',
  'pete townshend',
  'pete wentz',
  'peter abelard',
  'peter abrahams',
  'peter agre',
  'peter behrens',
  'peter benenson',
  'peter c. doherty',
  'peter canisius',
  'peter carl fabergé',
  'peter crouch',
  'peter cushing',
  'peter d. mitchell',
  'peter damian',
  'peter debye',
  'peter diamond',
  'peter drucker',
  'peter facinelli',
  'peter falk',
  'peter finch',
  'peter fonda',
  'peter gabriel',
  'peter graves',
  'peter greenaway',
  'peter grünberg',
  'peter handke',
  'peter higgs',
  'peter i of portugal',
  'peter i of serbia',
  'peter ii of portugal',
  'peter ii of russia',
  'peter ii of yugoslavia',
  'peter iii of aragon',
  'peter iii of portugal',
  'peter iii of russia',
  'peter jackson',
  'peter kropotkin',
  'peter leko',
  'peter lorre',
  'peter macnicol',
  'peter mandelson',
  'peter mansfield',
  'peter medawar',
  'peter nalitch',
  'peter naur',
  "peter o'toole",
  'peter paul rubens',
  'peter schmeichel',
  'peter sellers',
  'peter shilton',
  'peter simon pallas',
  'peter singer',
  'peter stormare',
  'peter the great',
  'peter the hermit',
  'peter tosh',
  'peter ustinov',
  'peter zumthor',
  'petit (portuguese footballer)',
  'petr čech',
  'petr jiráček',
  'petr nečas',
  'petra kvitová',
  'petrarch',
  'petronius',
  'petronius maximus',
  'petter solberg',
  'petula clark',
  'peyo',
  'pharrell williams',
  'pherecydes of syros',
  'phidias',
  'phil collins',
  'phil hill',
  'phil jagielka',
  'phil jones (footballer)',
  'phil lynott',
  'phil neville',
  'phil spector',
  'philip glass',
  'philip i of castile',
  'philip i of france',
  'philip ii of france',
  'philip ii of macedon',
  'philip ii of spain',
  'philip iii of france',
  'philip iii of macedon',
  'philip iii of spain',
  'philip iv of france',
  'philip iv of spain',
  'philip johnson',
  'philip josé farmer',
  'philip k. dick',
  'philip kotler',
  'philip miller',
  'philip neri',
  'philip noel-baker, baron noel-baker',
  'philip of swabia',
  'philip pullman',
  'philip roth',
  'philip selway',
  'philip seymour hoffman',
  'philip showalter hench',
  'philip the apostle',
  'philip the arab',
  'philip the bold',
  'philip the good',
  'philip v of france',
  'philip v of macedon',
  'philip v of spain',
  'philip vi of france',
  'philip warren anderson',
  'philip zimbardo',
  'philipp kirkorov',
  'philipp kohlschreiber',
  'philipp lahm',
  'philipp lenard',
  'philipp melanchthon',
  'philipp scheidemann',
  'philippa of hainault',
  'philippe gilbert',
  'philippe i, duke of orléans',
  'philippe ii, duke of orléans',
  'philippe mexès',
  'philippe noiret',
  'philippe pétain',
  'philippe senderos',
  'philippikos bardanes',
  'phillip allen sharp',
  'phillip cocu',
  'philo',
  'phocas',
  'phoebe tonkin',
  'photios i of constantinople',
  'phyllis diller',
  'pier paolo pasolini',
  'pierce brosnan',
  'pierluigi collina',
  'piero della francesca',
  'piero the unfortunate',
  'pierre bayle',
  'pierre beaumarchais',
  'pierre bérégovoy',
  'pierre bonnard',
  'pierre boulez',
  'pierre boulle',
  'pierre bourdieu',
  'pierre cardin',
  'pierre choderlos de laclos',
  'pierre corneille',
  'pierre curie',
  'pierre de coubertin',
  'pierre de fermat',
  'pierre de marivaux',
  'pierre de ronsard',
  'pierre gassendi',
  'pierre janssen',
  'pierre laval',
  'pierre louis maupertuis',
  'pierre mauroy',
  'pierre messmer',
  'pierre nkurunziza',
  'pierre puvis de chavannes',
  'pierre teilhard de chardin',
  'pierre trudeau',
  'pierre-auguste renoir',
  'pierre-gilles de gennes',
  'pierre-joseph proudhon',
  'pierre-simon laplace',
  'piet mondrian',
  'pieter bruegel the elder',
  'pieter brueghel the younger',
  'pieter van den hoogenband',
  'pieter zeeman',
  'pietro aretino',
  'pietro badoglio',
  'pietro lorenzetti',
  'pietro mascagni',
  'pietro perugino',
  'pina bausch',
  'pindar',
  'pink (singer)',
  'pío baroja',
  'pio of pietrelcina',
  'piotr trochowski',
  'piper perabo',
  'piri reis',
  'pitbull (entertainer)',
  'pixie lott',
  'piye',
  'pj harvey',
  'plácido domingo',
  'plato',
  'plautus',
  'pliny the elder',
  'pliny the younger',
  'plotinus',
  'plutarch',
  'pocahontas',
  'pol pot',
  'pola negri',
  'polybius',
  'polycarp',
  'polycrates',
  'polykarp kusch',
  'polykleitos',
  'pompey',
  'pomponius mela',
  'pontius pilate',
  'pontormo',
  'pope adeodatus i',
  'pope adeodatus ii',
  'pope adrian i',
  'pope adrian ii',
  'pope adrian iii',
  'pope adrian iv',
  'pope adrian v',
  'pope adrian vi',
  'pope agapetus i',
  'pope agapetus ii',
  'pope agatho',
  'pope alexander i',
  'pope alexander ii',
  'pope alexander iii',
  'pope alexander iv',
  'pope alexander vi',
  'pope alexander vii',
  'pope alexander viii',
  'pope anacletus',
  'pope anastasius i',
  'pope anastasius ii',
  'pope anastasius iii',
  'pope anastasius iv',
  'pope anicetus',
  'pope anterus',
  'pope benedict i',
  'pope benedict ii',
  'pope benedict iii',
  'pope benedict iv',
  'pope benedict ix',
  'pope benedict v',
  'pope benedict vi',
  'pope benedict vii',
  'pope benedict viii',
  'pope benedict xi',
  'pope benedict xii',
  'pope benedict xiii',
  'pope benedict xiv',
  'pope benedict xv',
  'pope benedict xvi',
  'pope boniface i',
  'pope boniface ii',
  'pope boniface iii',
  'pope boniface iv',
  'pope boniface ix',
  'pope boniface v',
  'pope boniface vi',
  'pope boniface viii',
  'pope caius',
  'pope callixtus i',
  'pope callixtus ii',
  'pope callixtus iii',
  'pope celestine i',
  'pope celestine ii',
  'pope celestine iii',
  'pope celestine iv',
  'pope celestine v',
  'pope clement i',
  'pope clement ii',
  'pope clement iii',
  'pope clement iv',
  'pope clement ix',
  'pope clement v',
  'pope clement vi',
  'pope clement vii',
  'pope clement viii',
  'pope clement x',
  'pope clement xi',
  'pope clement xii',
  'pope clement xiii',
  'pope clement xiv',
  'pope conon',
  'pope constantine',
  'pope cornelius',
  'pope damasus i',
  'pope damasus ii',
  'pope dionysius',
  'pope donus',
  'pope eleuterus',
  'pope eugene i',
  'pope eugene ii',
  'pope eugene iii',
  'pope eugene iv',
  'pope eusebius',
  'pope eutychian',
  'pope evaristus',
  'pope fabian',
  'pope felix i',
  'pope felix iii',
  'pope felix iv',
  'pope formosus',
  'pope gelasius i',
  'pope gelasius ii',
  'pope gregory i',
  'pope gregory ii',
  'pope gregory iii',
  'pope gregory iv',
  'pope gregory ix',
  'pope gregory v',
  'pope gregory vi',
  'pope gregory vii',
  'pope gregory viii',
  'pope gregory x',
  'pope gregory xi',
  'pope gregory xii',
  'pope gregory xiii',
  'pope gregory xiv',
  'pope gregory xv',
  'pope gregory xvi',
  'pope hilarius',
  'pope honorius i',
  'pope honorius ii',
  'pope honorius iii',
  'pope honorius iv',
  'pope hormisdas',
  'pope hyginus',
  'pope innocent i',
  'pope innocent ii',
  'pope innocent iii',
  'pope innocent iv',
  'pope innocent ix',
  'pope innocent v',
  'pope innocent vi',
  'pope innocent vii',
  'pope innocent viii',
  'pope innocent x',
  'pope innocent xi',
  'pope innocent xii',
  'pope innocent xiii',
  'pope john i',
  'pope john ii',
  'pope john iii',
  'pope john iv',
  'pope john ix',
  'pope john paul i',
  'pope john paul ii',
  'pope john v',
  'pope john vi',
  'pope john vii',
  'pope john viii',
  'pope john x',
  'pope john xi',
  'pope john xii',
  'pope john xiii',
  'pope john xiv',
  'pope john xix',
  'pope john xv',
  'pope john xvii',
  'pope john xviii',
  'pope john xxi',
  'pope john xxii',
  'pope john xxiii',
  'pope julius i',
  'pope julius ii',
  'pope julius iii',
  'pope leo i',
  'pope leo ii',
  'pope leo iii',
  'pope leo iv',
  'pope leo ix',
  'pope leo v',
  'pope leo vi',
  'pope leo vii',
  'pope leo viii',
  'pope leo x',
  'pope leo xi',
  'pope leo xii',
  'pope leo xiii',
  'pope liberius',
  'pope linus',
  'pope lucius i',
  'pope lucius ii',
  'pope lucius iii',
  'pope marcellinus',
  'pope marcellus i',
  'pope marcellus ii',
  'pope marinus i',
  'pope marinus ii',
  'pope mark',
  'pope martin i',
  'pope martin iv',
  'pope martin v',
  'pope miltiades',
  'pope nicholas i',
  'pope nicholas ii',
  'pope nicholas iii',
  'pope nicholas iv',
  'pope nicholas v',
  'pope paschal i',
  'pope paschal ii',
  'pope paul i',
  'pope paul ii',
  'pope paul iii',
  'pope paul iv',
  'pope paul v',
  'pope paul vi',
  'pope pelagius i',
  'pope pelagius ii',
  'pope pius i',
  'pope pius ii',
  'pope pius iii',
  'pope pius iv',
  'pope pius ix',
  'pope pius v',
  'pope pius vi',
  'pope pius vii',
  'pope pius viii',
  'pope pius x',
  'pope pius xi',
  'pope pius xii',
  'pope pontian',
  'pope romanus',
  'pope sabinian',
  'pope sergius i',
  'pope sergius ii',
  'pope sergius iii',
  'pope sergius iv',
  'pope severinus',
  'pope shenouda iii of alexandria',
  'pope silverius',
  'pope simplicius',
  'pope siricius',
  'pope sisinnius',
  'pope sixtus i',
  'pope sixtus ii',
  'pope sixtus iii',
  'pope sixtus iv',
  'pope sixtus v',
  'pope soter',
  'pope stephen i',
  'pope stephen ii',
  'pope stephen iii',
  'pope stephen iv',
  'pope stephen ix',
  'pope stephen v',
  'pope stephen vi',
  'pope stephen vii',
  'pope stephen viii',
  'pope sylvester i',
  'pope sylvester ii',
  'pope sylvester iii',
  'pope symmachus',
  'pope telesphorus',
  'pope theodore i',
  'pope theodore ii',
  'pope urban i',
  'pope urban ii',
  'pope urban iii',
  'pope urban iv',
  'pope urban v',
  'pope urban vi',
  'pope urban vii',
  'pope urban viii',
  'pope valentine',
  'pope victor i',
  'pope victor ii',
  'pope victor iii',
  'pope vigilius',
  'pope vitalian',
  'pope zachary',
  'pope zephyrinus',
  'pope zosimus',
  'pope-elect stephen',
  'porfirio díaz',
  'porfirio lobo sosa',
  'porphyry (philosopher)',
  'portia de rossi',
  'portia simpson-miller',
  'posidonius',
  'postumus',
  'poul anderson',
  'poul nyrup rasmussen',
  'prachanda',
  'pranab mukherjee',
  'pratibha patil',
  'praxiteles',
  'predrag mijatović',
  'preity zinta',
  'premchand',
  'primo levi',
  'primož kozmus',
  'prince (musician)',
  'prince andrew, duke of york',
  'prince carl philip, duke of värmland',
  'prince claus of the netherlands',
  'prince daniel, duke of västergötland',
  'prince edward, earl of wessex',
  'prince eugene of savoy',
  'prince harry of wales',
  'prince joachim of denmark',
  'prince maximilian of baden',
  'prince philip, duke of edinburgh',
  'prince philippe, duke of brabant',
  'prince william, duke of cambridge',
  'princess alice of the united kingdom',
  'princess beatrice of york',
  'princess madeleine, duchess of hälsingland and gästrikland',
  'princess margaret, countess of snowdon',
  'princess máxima of the netherlands',
  'princess stéphanie of monaco',
  'priscilla presley',
  'priyanka chopra',
  'proclus',
  'procopius',
  'prodicus',
  'propertius',
  'prosper mérimée',
  'protagoras',
  'psy (entertainer)',
  'ptolemy',
  'ptolemy i soter',
  'ptolemy ii philadelphus',
  'ptolemy iii euergetes',
  'ptolemy iv philopator',
  'ptolemy ix lathyros',
  'ptolemy keraunos',
  'ptolemy v epiphanes',
  'ptolemy vi philometor',
  'ptolemy viii physcon',
  'ptolemy x alexander i',
  'ptolemy xi alexander ii',
  'ptolemy xii auletes',
  'ptolemy xiii theos philopator',
  'ptolemy xiv of egypt',
  'publius quinctilius varus',
  'publius septimius geta',
  'pulcheria',
  'pupienus',
  'puyi',
  'pyotr bagration',
  'pyotr ilyich tchaikovsky',
  'pyotr kapitsa',
  'pyotr nikolayevich wrangel',
  'pyotr stolypin',
  'pyrrho',
  'pyrrhus of epirus',
  'pythagoras',
  'pytheas',
  "qa'a",
  'qaboos bin said al said',
  'qianlong emperor',
  'qin shi huang',
  'qu yuan',
  'queen elizabeth the queen mother',
  'queen latifah',
  'queen of sheba',
  'queen rania of jordan',
  'queen silvia of sweden',
  'queen sofía of spain',
  'queen sonja of norway',
  'queen victoria',
  'quentin bryce',
  'quentin tarantino',
  'quett masire',
  'quincy jones',
  'quintilian',
  'quintillus',
  'quintus curtius rufus',
  'quintus sertorius',
  'r. d. laing',
  'r. kelly',
  'r. venkataraman',
  'rabindranath tagore',
  'rachel',
  'rachel bilson',
  'rachel carson',
  'rachel corrie',
  'rachel mcadams',
  'rachel weisz',
  'radamel falcao garcía',
  'radek štěpánek',
  'radovan karadžić',
  'rafael alberti',
  'rafael benítez',
  'rafael caldera',
  'rafael correa',
  'rafael del riego',
  'rafael moneo',
  'rafael nadal',
  'rafael trujillo',
  'rafael van der vaart',
  'rafic hariri',
  'ragnar frisch',
  'ragnar granit',
  'rahm emanuel',
  'rahul gandhi',
  'raila odinga',
  'rainer maria rilke',
  'rainer werner fassbinder',
  'rainier iii, prince of monaco',
  'raj kapoor',
  'rajendra prasad',
  'rajiv gandhi',
  'rajon rondo',
  'ralf dahrendorf',
  'ralf schumacher',
  'ralph bunche',
  'ralph ellison',
  'ralph fiennes',
  'ralph lauren',
  'ralph m. steinman',
  'ralph nader',
  'ralph vaughan williams',
  'ralph waldo emerson',
  'ram baran yadav',
  'ram narayan',
  'ramakrishna',
  'ramana maharshi',
  'ramesses i',
  'ramesses ii',
  'ramesses iii',
  'ramesses iv',
  'ramesses vi',
  'ramires',
  'ramiz alia',
  'ramón del valle-inclán',
  'ramon llull',
  'ramon magsaysay',
  'ramón mercader',
  'ramsay macdonald',
  'ramzan kadyrov',
  'randal cremer',
  'randy orton',
  'randy pausch',
  'raneb',
  'rani mukerji',
  'raoul dufy',
  'raoul wallenberg',
  'raphael',
  'raphaël varane',
  'raquel welch',
  'rasheed wallace',
  'rashi',
  'rasmus christian rask',
  'rasmus lerdorf',
  'ratko mladić',
  'rauf denktaş',
  'raúl (footballer)',
  'raúl albiol',
  'raúl alfonsín',
  'raúl castro',
  'raul meireles',
  'ravi shankar',
  'ravshan irmatov',
  'ray allen',
  'ray bradbury',
  'ray charles',
  'ray ewry',
  'ray kurzweil',
  'ray liotta',
  'ray manzarek',
  'ray milland',
  'ray romano',
  'raymond aron',
  'raymond barre',
  'raymond carver',
  'raymond chandler',
  'raymond davis, jr.',
  'raymond domenech',
  'raymond iv, count of toulouse',
  'raymond kopa',
  'raymond poincaré',
  'raymond queneau',
  'reba mcentire',
  'rebecca',
  'rebecca black',
  'rebecca romijn',
  'rebecca soni',
  'rebiya kadeer',
  'recep tayyip erdoğan',
  'reese witherspoon',
  'reggie miller',
  'regina spektor',
  'regiomontanus',
  'rehoboam',
  'reinaldo arenas',
  'reinhard heydrich',
  'reinhard selten',
  'reinhold messner',
  'rem koolhaas',
  'rembrandt',
  'renata tebaldi',
  'renato dulbecco',
  'rené adler',
  'rené antoine ferchault de réaumur',
  'rené cassin',
  'rené coty',
  'rené descartes',
  'rené goscinny',
  'rené guénon',
  'rené higuita',
  'rene krhin',
  'rené lacoste',
  'rené laennec',
  'rené magritte',
  'rené préval',
  'rené thom',
  'rené van de kerkhof',
  'rené-robert cavelier, sieur de la salle',
  "renee o'connor",
  'renée zellweger',
  'renzo piano',
  'reuben (bible)',
  'rex harrison',
  'rexhep meidani',
  'rey mysterio',
  'reynaldo bignone',
  'rezā shāh',
  'rhona mitra',
  'rhys ifans',
  'ric flair',
  'ricardo carvalho',
  'ricardo costa (portuguese footballer)',
  'ricardo lagos',
  'ricardo martinelli',
  'ricardo pereira',
  'ricardo quaresma',
  'ricardo zamora',
  'riccardo giacconi',
  'riccardo montolivo',
  'richard adolf zsigmondy',
  'richard arkwright',
  'richard attenborough',
  'richard axel',
  'richard bach',
  'richard branson',
  'richard burns',
  'richard burton',
  'richard chamberlain',
  'richard clayderman',
  'richard cromwell',
  'richard dawkins',
  'richard dean anderson',
  'richard dedekind',
  'richard dreyfuss',
  'richard dunne',
  'richard e. byrd',
  'richard e. taylor',
  'richard f. heck',
  'richard feynman',
  'richard francis burton',
  'richard gasquet',
  'richard gere',
  'richard hammond',
  'richard harris',
  'richard holbrooke',
  'richard i of england',
  'richard ii of england',
  'richard iii of england',
  'richard j. roberts',
  'richard kingson',
  'richard krajicek',
  'richard kuhn',
  'richard laurence millington synge',
  'richard meier',
  'richard mentor johnson',
  'richard nikolaus von coudenhove-kalergi',
  'richard nixon',
  'richard owen',
  'richard pryor',
  'richard r. ernst',
  'richard r. schrock',
  'richard rodgers',
  'richard rogers',
  'richard rorty',
  'richard simmons',
  'richard smalley',
  'richard sorge',
  'richard stallman',
  'richard stone',
  'richard strauss',
  'richard trevithick',
  'richard von krafft-ebing',
  'richard von weizsäcker',
  'richard wagner',
  'richard willstätter',
  'richard wright (musician)',
  'richard z. kruspe',
  'richie sambora',
  'ricimer',
  'rick astley',
  'rick perry',
  'rick riordan',
  'rick ross',
  'rick rubin',
  'rick santorum',
  'ricky gervais',
  'ricky martin',
  'ricky rubio',
  'ridley scott',
  'rigobert song',
  'rigoberta menchú',
  'rihanna',
  'rinat dasayev',
  'ringo starr',
  'rinko kikuchi',
  'rinus michels',
  'rio ferdinand',
  'risto ryti',
  'rita hayworth',
  'rita levi-montalcini',
  'rita ora',
  'ritchie blackmore',
  'ritchie de laet',
  'ritchie valens',
  'rivaldo',
  'river phoenix',
  'riyo mori',
  'roald amundsen',
  'roald dahl',
  'roald hoffmann',
  'rob halford',
  'rob lowe',
  'rob rensenbrink',
  'rob schneider',
  'rob van dam',
  'rob zombie',
  'robbie coltrane',
  'robbie fowler',
  'robbie keane',
  'robbie williams',
  'robert a. heinlein',
  'robert altman',
  'robert andrews millikan',
  'robert aumann',
  'robert b. laughlin',
  'robert baden-powell, 1st baron baden-powell',
  'róbert bárány',
  'robert bellarmine',
  'robert bosch',
  'robert boyle',
  'robert bresson',
  'robert brown (botanist)',
  'robert browning',
  'robert bruce merrifield',
  'robert bunsen',
  'robert burns',
  'robert burns woodward',
  'robert byrd',
  'robert c. merton',
  'robert campin',
  'robert capa',
  'robert carlyle',
  'robert cecil, 1st viscount cecil of chelwood',
  'robert clive, 1st baron clive',
  'robert coleman richardson',
  'robert curl',
  'robert curthose',
  'robert de niro',
  'robert delaunay',
  'robert doisneau',
  'robert doornbos',
  'robert downey, jr.',
  'robert duvall',
  'robert e. howard',
  'robert e. lee',
  'robert englund',
  'robert enke',
  'robert f. engle',
  'robert f. furchgott',
  'robert f. kennedy',
  'robert falcon scott',
  'robert fico',
  'robert fisk',
  'robert fitzroy',
  'robert fogel',
  'robert fripp',
  'robert frost',
  'robert fulton',
  'robert g. edwards',
  'robert gascoyne-cecil, 3rd marquess of salisbury',
  'robert gates',
  'robert graves',
  'robert green',
  'robert guérin',
  'robert guiscard',
  'robert h. goddard',
  'robert h. grubbs',
  'robert hofstadter',
  'robert hooke',
  'robert huber',
  'robert huth',
  'robert i of france',
  'robert ii of france',
  'robert ii of scotland',
  'robert iii of scotland',
  'robert jenkinson, 2nd earl of liverpool',
  'robert johnson',
  'robert jordan',
  'robert k. merton',
  'robert kiyosaki',
  'robert knepper',
  'robert koch',
  'robert kocharyan',
  'robert koren',
  'robert kovač',
  'robert kubica',
  'robert lefkowitz',
  'robert lewandowski',
  'robert ley',
  'robert louis stevenson',
  'robert lucas, jr.',
  'robert ludlum',
  'robert mcnamara',
  'robert menzies',
  'robert mitchum',
  'robert moog',
  'robert mugabe',
  'robert mundell',
  'robert musil',
  'robert noyce',
  'robert nozick',
  'robert owen',
  'robert patrick',
  'robert pattinson',
  'robert peary',
  'robert peel',
  'robert pirès',
  'robert plant',
  'robert prosinečki',
  'robert rauschenberg',
  'robert redford',
  'robert robinson (organic chemist)',
  'robert rodriguez',
  'robert s. mulliken',
  'robert schuman',
  'robert schumann',
  'robert sean leonard',
  'robert smith (musician)',
  'robert solow',
  'robert southey',
  'robert the bruce',
  'robert trujillo',
  'robert venturi',
  'róbert vittek',
  'robert w. holley',
  'robert wadlow',
  'robert wagner',
  'robert walpole',
  'robert wise',
  'robert woodrow wilson',
  'robert zemeckis',
  'roberto abbondanzieri',
  'roberto ayala',
  'roberto baggio',
  'roberto benigni',
  'roberto bolaño',
  'roberto carlos (footballer)',
  'roberto di matteo',
  'roberto donadoni',
  'roberto mancini',
  'roberto rivelino',
  'roberto rosetti',
  'roberto rossellini',
  'roberto saviano',
  'roberto soldado',
  'robin cook',
  'robin gibb',
  'robin söderling',
  'robin tunney',
  'robin van persie',
  'robin warren',
  'robin williams',
  'robin wright',
  'robinho',
  'rock hudson',
  'rocky marciano',
  'rod laver',
  'rod steiger',
  'rod stewart',
  'roderic',
  'roderick mackinnon',
  'rodion malinovsky',
  'rodney robert porter',
  'rodrigo palacio',
  'rodrigo santoro',
  'rodrigo taddei',
  'roger bacon',
  'roger d. kornberg',
  'roger ebert',
  'roger federer',
  'roger garaudy',
  'roger glover',
  'roger guerreiro',
  'roger guillemin',
  'roger i of sicily',
  'roger ii of sicily',
  'roger martin du gard',
  'roger meddows taylor',
  'roger milla',
  'roger moore',
  'roger myerson',
  'roger penrose',
  'roger vadim',
  'roger waters',
  'roger wolcott sperry',
  'roger y. tsien',
  'roger zelazny',
  'rogério ceni',
  'rogier van der weyden',
  'roh moo-hyun',
  'roh tae-woo',
  'roland',
  'roland barthes',
  'roland emmerich',
  'roland freisler',
  'roland garros (aviator)',
  'roland ratzenberger',
  'rolandas paksas',
  'rolando (portuguese footballer)',
  'rollo',
  'romain gary',
  'romain grosjean',
  'romain rolland',
  'roman abramovich',
  'roman herzog',
  'roman jakobson',
  'roman pavlyuchenko',
  'roman polanski',
  'roman shirokov',
  'roman weidenfeller',
  'romano prodi',
  'romanos i lekapenos',
  'romanos ii',
  'romanos iii argyros',
  'romanos iv diogenes',
  'romaric (footballer)',
  'romário',
  'romelu lukaku',
  'rómulo gallegos',
  'romulus augustulus',
  'romy schneider',
  'ron howard',
  'ron paul',
  'ron perlman',
  'ron-robert zieler',
  'ronald coase',
  'ronald de boer',
  'ronald fisher',
  'ronald george wreyford norrish',
  'ronald golias',
  'ronald koeman',
  'ronald reagan',
  'ronald ross',
  'ronald venetiaan',
  'ronaldinho',
  'ronaldo',
  'ronnie james dio',
  "ronnie o'sullivan",
  'ronnie wood',
  'rooney mara',
  'roque santa cruz',
  'rosa luxemburg',
  'rosa parks',
  'rosalind franklin',
  'rosalyn sussman yalow',
  'rosalynn carter',
  'rosamund pike',
  'rosanna arquette',
  'rosario dawson',
  'roscellinus',
  'rose byrne',
  'rose mcgowan',
  'rose of lima',
  'rosen plevneliev',
  'rosie huntington-whiteley',
  "rosie o'donnell",
  'ross brawn',
  'ross turnbull',
  'rosso fiorentino',
  'rowan atkinson',
  'roxana',
  'roxelana',
  'roy emerson',
  'roy hodgson',
  'roy j. glauber',
  'roy keane',
  'roy lichtenstein',
  'roy makaay',
  'roy orbison',
  'roy scheider',
  'royston drenthe',
  'roza otunbayeva',
  'rubén darío',
  'rubén de la red',
  'rubens barrichello',
  'ruđer bošković',
  'rudi völler',
  'rudolf bultmann',
  'rudolf carnap',
  'rudolf christoph eucken',
  'rudolf clausius',
  'rudolf diesel',
  'rudolf hess',
  'rudolf höss',
  'rudolf ii, holy roman emperor',
  'rudolf kirchschläger',
  'rudolf mössbauer',
  'rudolf nureyev',
  'rudolf steiner',
  'rudolf virchow',
  'rudolf, crown prince of austria',
  'rudolph a. marcus',
  'rudolph i of germany',
  'rudolph of france',
  'rudolph valentino',
  'rudy giuliani',
  'rudyard kipling',
  'rufus sewell',
  'rufus wainwright',
  'ruggero leoncavallo',
  'ruhollah khomeini',
  'rui costa',
  'rui patrício',
  'rumi',
  'rumiko takahashi',
  'rupert everett',
  'rupert grint',
  'rupert murdoch',
  'rupiah banda',
  'rurik',
  'rush limbaugh',
  'ruslan ponomariov',
  'ruslan rotan',
  'ruslana',
  'russell alan hulse',
  'russell brand',
  'russell crowe',
  'russell westbrook',
  'rustam kasimdzhanov',
  'rüştü reçber',
  'rūta meilutytė',
  'rutger hauer',
  'ruth benedict',
  'rutherford b. hayes',
  'ruud gullit',
  'ruud lubbers',
  'ruud van nistelrooy',
  'ruy lópez de segura',
  'ryan babel',
  'ryan bertrand',
  'ryan giggs',
  'ryan gosling',
  'ryan lochte',
  'ryan nelsen',
  "ryan o'neal",
  'ryan phillippe',
  'ryan reynolds',
  'ryo miyaichi',
  'ryōji noyori',
  'ryszard kaczorowski',
  'ryszard kapuściński',
  'ryūnosuke akutagawa',
  'ryutaro hashimoto',
  'rza',
  's. r. nathan',
  'saad hariri',
  'saadi shirazi',
  'sabbatai zevi',
  'sabine lisicki',
  'sabrina salerno',
  'sacha baron cohen',
  'sachin tendulkar',
  'sadako sasaki',
  'saddam hussein',
  'sade adu',
  'safura alizadeh',
  'sahure',
  'saïd aouita',
  'saif al-islam gaddafi',
  'saif ali khan',
  'saigō takamori',
  'saina nehwal',
  'saint anne',
  'saint barbara',
  'saint blaise',
  'saint boniface',
  'saint cecilia',
  'saint christopher',
  'saint dominic',
  'saint florian',
  'saint george',
  'saint joseph',
  'saint lucy',
  'saint margaret of scotland',
  'saint marinus',
  'saint matthias',
  'saint monica',
  'saint nicholas',
  'saint patrick',
  'saint peter',
  'saint roch',
  'saint sava',
  'saint sebastian',
  'saint stephen',
  'saint timothy',
  'saint valentine',
  'saint wenceslaus i, duke of bohemia',
  'saint-john perse',
  'saints cosmas and damian',
  'saints cyril and methodius',
  'saionji kinmochi',
  'saki',
  'sakis rouvas',
  'sakon yamamoto',
  'saladin',
  'saleh',
  'sali berisha',
  'salif keita',
  'sallust',
  'sally field',
  'sally ride',
  'salma hayek',
  'salman khan',
  'salman rushdie',
  'salome',
  'salomon kalou',
  'saloninus',
  'salva kiir mayardit',
  'salvador allende',
  'salvador dalí',
  'salvador luria',
  'salvatore adamo',
  'salvatore quasimodo',
  'salvatore schillaci',
  'salvatore sirigu',
  'sam cooke',
  'sam harris (author)',
  'sam houston',
  'sam j. jones',
  'sam mendes',
  'sam neill',
  'sam nujoma',
  'sam peckinpah',
  'sam querrey',
  'sam raimi',
  'sam shepard',
  'sam walton',
  'sam worthington',
  'samak sundaravej',
  'samantha smith',
  'samantha stosur',
  'sami hyypiä',
  'sami khedira',
  'samir handanović',
  'samir nasri',
  'sammy davis, jr.',
  'samo',
  'samora machel',
  'samson',
  'samudragupta',
  'samuel',
  'samuel adams',
  'samuel barber',
  'samuel beckett',
  'samuel c. c. ting',
  'samuel colt',
  'samuel de champlain',
  'samuel doe',
  "samuel eto'o",
  'samuel hahnemann',
  'samuel johnson',
  'samuel l. jackson',
  'samuel morse',
  'samuel of bulgaria',
  'samuel p. huntington',
  'samuel pepys',
  'samuel richardson',
  'samuel sánchez',
  'samuel taylor coleridge',
  'sancho i of portugal',
  'sancho ii of portugal',
  'sancho iii of navarre',
  'sander boschker',
  'sándor kocsis',
  'sándor márai',
  'sándor petőfi',
  'sandra (singer)',
  'sandra bullock',
  'sandra oh',
  'sandro botticelli',
  'sandro pertini',
  'sani abacha',
  'sania mirza',
  'sanjay dutt',
  'santi cazorla',
  'santiago bernabéu yeste',
  'santiago calatrava',
  'santiago cañizares',
  'santiago carrillo',
  'santiago ramón y cajal',
  'saoirse ronan',
  'saparmurat niyazov',
  'sappho',
  'sara errani',
  'sarah',
  'sarah bernhardt',
  'sarah brightman',
  'sarah connor (singer)',
  'sarah jessica parker',
  'sarah mclachlan',
  'sarah michelle gellar',
  'sarah palin',
  'sarah siddons',
  'sarah vaughan',
  'sarah wayne callies',
  'sargon ii',
  'sargon of akkad',
  'sarvepalli radhakrishnan',
  'sasha cohen',
  'sasha grey',
  'saskia van uylenburgh',
  'sathya sai baba',
  'satoshi tajiri',
  'satyajit ray',
  'satyendra nath bose',
  'saud of saudi arabia',
  'saul',
  'saul bellow',
  'saul kripke',
  'saul perlmutter',
  'sauli niinistö',
  'savo milošević',
  'saxo grammaticus',
  'sayyid qutb',
  'scarlett johansson',
  'scatman john',
  'schuyler colfax',
  'scipio aemilianus',
  'scipio africanus',
  'scopas',
  'scott carson',
  'scott joplin',
  'scott parker',
  'scott s. sheppard',
  'scott speed',
  'scottie pippen',
  'seal (musician)',
  'seamus heaney',
  'sean astin',
  'sean bean',
  'sean combs',
  'sean connery',
  'sean hayes (actor)',
  'sean kingston',
  'seán macbride',
  "seán o'casey",
  'sean paul',
  'sean penn',
  'sean st ledger',
  'seann william scott',
  'sebastián abreu',
  'sebastian boenisch',
  'sebastian coe',
  'sebastian giovinco',
  'sebastian kehl',
  'sebastian larsson',
  'sebastian of portugal',
  'sebastián piñera',
  'sebastian prödl',
  'sebastian vettel',
  'sébastien bourdais',
  'sébastien buemi',
  'sébastien le prestre de vauban',
  'sébastien loeb',
  'sébastien squillaci',
  'ségolène royal',
  'sejanus',
  'sejong the great',
  'sekhemkhet',
  'selena',
  'selena gomez',
  'seleucus i nicator',
  'seleucus ii callinicus',
  'seleucus iii ceraunus',
  'seleucus iv philopator',
  'seleucus vi epiphanes',
  'selim i',
  'selim ii',
  'selim iii',
  'selma lagerlöf',
  'semerkhet',
  'semih şentürk',
  'semmy schilt',
  'semyon budyonny',
  'semyon timoshenko',
  'seneca the elder',
  'seneca the younger',
  'sennacherib',
  'senusret i',
  'senusret iii',
  'seo jae-pil',
  'sepp blatter',
  'sepp maier',
  'septimius severus',
  'serdar tasci',
  'serena williams',
  'seretse khama',
  'serge gainsbourg',
  'serge haroche',
  'sergei bagapsh',
  'sergei bondarchuk',
  'sergei diaghilev',
  'sergei eisenstein',
  'sergei ignashevich',
  'sergei ivanov',
  'sergei korolev',
  'sergei prokofiev',
  'sergei rachmaninoff',
  'sergei sidorsky',
  'sergei stanishev',
  'sergei witte',
  'sergei yesenin',
  'sergey brin',
  'sergey bubka',
  'sergey karjakin',
  'sergey kirov',
  'sergey lavrov',
  'sergey leonidovich sokolov',
  'sergey mikhalkov',
  'sergey prokudin-gorsky',
  'sergio agüero',
  'sergio badilla castillo',
  'sergio busquets',
  'sergio canales',
  'sergio leone',
  'sergio pérez',
  'sergio ramos',
  'sergio romero',
  'sergiu celibidache',
  'serhiy rebrov',
  'serj tankian',
  'sertab erener',
  'servius tullius',
  'serzh sargsyan',
  'seth',
  'seth green',
  'seth macfarlane',
  'seth rogen',
  'seti i',
  'seung-hui cho',
  'seve ballesteros',
  'severo ochoa',
  'sextus empiricus',
  'sextus martinianus',
  'sextus pompey',
  'seydou doumbia',
  'seydou keita (footballer)',
  'sezen aksu',
  'shaggy (musician)',
  'shah jahan',
  "shahar pe'er",
  'shahrukh khan',
  'shaka',
  'shakira',
  'shalmaneser i',
  'shalmaneser iii',
  'shamil basayev',
  'shane dawson',
  'shane long',
  'shane smeltz',
  'shania twain',
  'shannen doherty',
  'shapur i',
  'shapur ii',
  'shapur iii',
  "shaquille o'neal",
  'sharif sheikh ahmed',
  'sharon den adel',
  'sharon stone',
  'sharon tate',
  'shaukat aziz',
  'shaun wright-phillips',
  'shavkat mirziyoyev',
  'shavo odadjian',
  'shawn michaels',
  'shay given',
  'sheamus',
  'sheikh hasina',
  'sheikh mujibur rahman',
  'sheldon lee glashow',
  'shelley winters',
  'shelly-ann fraser-pryce',
  'shelton benjamin',
  'shem',
  'shen kuo',
  'shennong',
  'shepseskaf',
  'sher shah suri',
  'sherwood anderson',
  'sheryl crow',
  'sheshonk i',
  'shia labeouf',
  'shigeru miyamoto',
  'shilpa shetty',
  'shimon peres',
  'shinji kagawa',
  'shinji okazaki',
  'shinya yamanaka',
  'shinzō abe',
  'shirin ebadi',
  'shirley bassey',
  'shirley booth',
  'shirley maclaine',
  'shirley temple',
  'shivaji',
  'shmuel yosef agnon',
  'shohei imamura',
  'shohreh aghdashloo',
  'sholem aleichem',
  'shota rustaveli',
  'shunsuke nakamura',
  'shunzhi emperor',
  'shyla stylez',
  'siad barre',
  'sid meier',
  'sid vicious',
  'sidney altman',
  'sidney govou',
  'sidney lumet',
  'sidney poitier',
  'sidney sheldon',
  'siegbert tarrasch',
  'siegfried lenz',
  'sienna guillory',
  'sienna miller',
  'sigebert i',
  'sigebert iii',
  'sigismund i the old',
  'sigismund ii augustus',
  'sigismund iii vasa',
  'sigismund, holy roman emperor',
  'sigmund freud',
  'sigmund jähn',
  'sigourney weaver',
  'sigrid undset',
  'siim kallas',
  'silvestre varela',
  'silvia saint',
  'silvio berlusconi',
  'silvio piola',
  'sima qian',
  'simão sabrosa',
  'siméon denis poisson',
  'simeon i of bulgaria',
  'simeon of moscow',
  'simeon saxe-coburg-gotha',
  'simo häyhä',
  'simon ammann',
  'simon baker',
  'simon bar kokhba',
  'simón bolívar',
  'simon cowell',
  'simon de montfort, 6th earl of leicester',
  'simon kjær',
  'simon kuznets',
  'simon magus',
  'simon marius',
  'simon pegg',
  'simon poulsen',
  'simon rolfes',
  'simon stevin',
  'simon the zealot',
  'simon van der meer',
  'simon wiesenthal',
  'simone barone',
  'simone de beauvoir',
  'simone martini',
  'simone pepe',
  'simone perrotta',
  'simone signoret',
  'simone simons',
  'simone veil',
  'simone weil',
  'simonides of ceos',
  'sin-itiro tomonaga',
  'sinclair lewis',
  "sinéad o'connor",
  'siniša mihajlović',
  'siphiwe tshabalala',
  'sir george stokes, 1st baronet',
  'sirhan sirhan',
  'sirimavo bandaranaike',
  'sirusho',
  'sissy spacek',
  'sitting bull',
  'skandar keynes',
  'skanderbeg',
  'skrillex',
  'slash (musician)',
  'slaven bilić',
  'slavoj žižek',
  'sławomir mrożek',
  'slobodan milošević',
  'smenkhkare',
  'sneferu',
  'snoop dogg',
  'snorri sturluson',
  'sobekneferu',
  'socrates',
  'sócrates',
  'sofia coppola',
  'sofia kovalevskaya',
  'sofia rotaru',
  'sofonisba anguissola',
  'sogdianus of persia',
  'sojourner truth',
  'sokollu mehmed pasha',
  'sokratis papastathopoulos',
  'sol campbell',
  'solomon',
  'solomon burke',
  'solomon ibn gabirol',
  'solon',
  'soluna samay',
  'somchai wongsawat',
  'sonia gandhi',
  'sonia sotomayor',
  'sonja henie',
  'sonny rollins',
  'sophia bush',
  'sophia loren',
  'sophia of hanover',
  'sophie ellis-bextor',
  'sophie germain',
  'sophie marceau',
  'sophie monk',
  'sophie scholl',
  'sophie, countess of wessex',
  'sophie, duchess of hohenberg',
  'sophocles',
  'sophus lie',
  'søren kierkegaard',
  'sotirios kyrgiakos',
  'sotiris ninis',
  'spartacus',
  'spencer compton, 1st earl of wilmington',
  'spencer perceval',
  'spencer tracy',
  'spencer tunick',
  'spike lee',
  'spiro agnew',
  'spyridon louis',
  'sri aurobindo',
  'srinivasa ramanujan',
  'stamford raffles',
  'stan getz',
  'stan laurel',
  'stan lee',
  'stanford moore',
  'stanislas wawrinka',
  'stanislav petrov',
  'stanisław august poniatowski',
  'stanisław konarski',
  'stanisław lem',
  'stanisław leszczyński',
  'stanisław moniuszko',
  'stanislaw ulam',
  'stanley b. prusiner',
  'stanley baldwin',
  'stanley cohen (biochemist)',
  'stanley kubrick',
  'stanley matthews',
  'stanley milgram',
  'stanley rous',
  'stanley tucci',
  'statius',
  'staurakios',
  'stefan banach',
  'stefan edberg',
  'stefan effenberg',
  'stefan kießling',
  'stefan nemanja',
  'stefan raab',
  'stefan zweig',
  'stefanía fernández',
  'steffi graf',
  'stefka kostadinova',
  'stellan skarsgård',
  'stendhal',
  'stenka razin',
  'stepan bandera',
  'stephan andersen',
  'stephan el shaarawy',
  'stephan lichtsteiner',
  'stéphane grappelli',
  'stéphane lambiel',
  'stéphane lannoy',
  'stéphane mallarmé',
  'stephanie rice',
  'stephen appiah',
  'stephen báthory',
  'stephen chow',
  'stephen colbert',
  'stephen crane',
  'stephen fry',
  'stephen gately',
  'stephen harper',
  'stephen hawking',
  'stephen hendry',
  'stephen i of hungary',
  'stephen iii of moldavia',
  'stephen ireland',
  'stephen jay gould',
  'stephen king',
  'stephen uroš iv dušan of serbia',
  'stephen warnock',
  'stephen wolfram',
  'stephen, king of england',
  'stephenie meyer',
  'sterling knight',
  'stevan jovetić',
  'steve ballmer',
  'steve biko',
  'steve buscemi',
  'steve carell',
  'steve finnan',
  'steve fossett',
  'steve harris (musician)',
  'steve hooker',
  'steve irwin',
  'steve jobs',
  'steve mandanda',
  'steve martin',
  'steve mcclaren',
  'steve mcmanaman',
  'steve mcqueen',
  'steve morse',
  'steve nash',
  'steve redgrave',
  'steve reich',
  'steve sidwell',
  'steve vai',
  'steve wozniak',
  'steve zahn',
  'steven chu',
  'steven gerrard',
  'steven pienaar',
  'steven pinker',
  'steven seagal',
  'steven soderbergh',
  'steven spielberg',
  'steven tyler',
  'steven weinberg',
  'stevie ray vaughan',
  'stevie wonder',
  'stewart downing',
  'stieg larsson',
  'stijn schaars',
  'stilicho',
  'stiliyan petrov',
  'sting (musician)',
  'sting (wrestler)',
  'stipe pletikosa',
  'stirling moss',
  'stjepan mesić',
  'stone cold steve austin',
  'stonewall jackson',
  'strabo',
  'stuart sutcliffe',
  'subcomandante marcos',
  'subhas chandra bose',
  'subhash kak',
  'subrahmanyan chandrasekhar',
  'subutai',
  'suetonius',
  'suharto',
  'sukarno',
  'suleiman ii',
  'suleiman the magnificent',
  'süleyman demirel',
  'sulley muntari',
  'sully prudhomme',
  'sultan bin abdulaziz',
  'summer glau',
  'sun myung moon',
  'sun quan',
  'sun tzu',
  'sun yang',
  'sun yat-sen',
  'sune bergström',
  'sunita williams',
  'sunny leone',
  'suppiluliuma i',
  'surayud chulanont',
  'suryavarman ii',
  'susan b. anthony',
  'susan boyle',
  'susan hayward',
  'susan sarandon',
  'susan sontag',
  'susilo bambang yudhoyono',
  'susumu tonegawa',
  'suzanne collins',
  'suzanne vega',
  'svante arrhenius',
  'sveinn björnsson',
  'sven hedin',
  'sven kramer',
  'sven-göran eriksson',
  'svetlana alliluyeva',
  'svetlana kuznetsova',
  'svetlana savitskaya',
  'sviatoslav i of kiev',
  'sviatoslav richter',
  'swami vivekananda',
  'sweyn forkbeard',
  'sweyn ii of denmark',
  'syagrius',
  'syd barrett',
  'sydney brenner',
  'sydney pollack',
  'syed ahmad khan',
  'sylvain wiltord',
  'sylvanus olympio',
  'sylvester stallone',
  'sylvia kristel',
  'sylvia plath',
  'symon petliura',
  'syngman rhee',
  'synyster gates',
  't-pain',
  't. e. lawrence',
  't. s. eliot',
  't.i.',
  'tabaré vázquez',
  'tacitus',
  'tadamichi kuribayashi',
  'tadao ando',
  'tadeus reichstein',
  'tadeusz kościuszko',
  'tadeusz mazowiecki',
  'tage erlander',
  'tahmasp i',
  'taio cruz',
  'takeda shingen',
  'takeshi kaneshiro',
  'takeshi kitano',
  'takuma sato',
  'tal ben haim',
  'talal of jordan',
  'talcott parsons',
  'talia shire',
  'tamar of georgia',
  'tancred, prince of galilee',
  'tancredo neves',
  'tank man',
  'tansu çiller',
  'tara reid',
  'tara strong',
  'taras shevchenko',
  'tarcisio bertone',
  'tariq aziz',
  'tariq ibn ziyad',
  'tariq ramadan',
  'tarja halonen',
  'tarja turunen',
  'tarkan (singer)',
  'tarō asō',
  'taslima nasrin',
  'tassos papadopoulos',
  'tatian',
  'tāufaʻāhau tupou iv',
  'tawakkol karman',
  'taye taiwo',
  'taylor lautner',
  'taylor momsen',
  'taylor swift',
  'tayshaun prince',
  'téa leoni',
  'tecumseh',
  'ted bundy',
  'ted danson',
  'ted hughes',
  'ted kaczynski',
  'ted kennedy',
  'ted turner',
  'teddy sheringham',
  'teimour radjabov',
  'teispes',
  'telly savalas',
  'tennessee williams',
  'tenzing norgay',
  'teodoro obiang nguema mbasogo',
  'teófilo cubillas',
  'teófilo stevenson',
  'tera patrick',
  'terah',
  'terence',
  'terence hill',
  'terence stamp',
  'terence tao',
  'teresa of ávila',
  'teresa teng',
  'teri hatcher',
  'tero pitkämäki',
  'terrence howard',
  'terrence malick',
  'terry crews',
  'terry fox',
  'terry gilliam',
  'terry jones',
  "terry o'quinn",
  'terry pratchett',
  'tertullian',
  'teti',
  'tetricus i',
  'tewodros ii',
  'thabo mbeki',
  'thaksin shinawatra',
  'thales',
  'thalía',
  'than shwe',
  'the edge',
  'the great khali',
  'the miz',
  'the notorious b.i.g.',
  'the rev',
  'the undertaker',
  'theda bara',
  'thein sein',
  'thelonious monk',
  'themistocles',
  'theo jörgensmann',
  'theo van doesburg',
  'theo van gogh (film director)',
  'theo walcott',
  'theobald von bethmann-hollweg',
  'theocritus',
  'theodahad',
  'theoderic the great',
  'theodor fontane',
  'theodor herzl',
  'theodor heuss',
  'theodor mommsen',
  'theodor schwann',
  'theodor storm',
  'theodor svedberg',
  'theodor w. adorno',
  'theodor w. hänsch',
  'theodora (11th century)',
  'theodora (wife of justinian i)',
  'theodore dreiser',
  'théodore géricault',
  'theodore i laskaris',
  'theodore ii laskaris',
  'theodore roosevelt',
  'théodore rousseau',
  'theodore schultz',
  'theodore von kármán',
  'theodore william richards',
  'theodoric i',
  'theodoric ii',
  'theodoros angelopoulos',
  'theodoros zagorakis',
  'theodosios iii',
  'theodosius i',
  'theodosius ii',
  'theofanis gekas',
  'theophanes the confessor',
  'théophile gautier',
  'theophilos (emperor)',
  'theophrastus',
  'thérèse of lisieux',
  'thespis',
  'theudebald',
  'theudebert i',
  'theudebert ii',
  'theuderic i',
  'theuderic ii',
  'theuderic iii',
  'theuderic iv',
  'thiago motta',
  'thiago silva (footballer)',
  'thibaut courtois',
  'thich quang duc',
  'thierry henry',
  'thom mayne',
  'thom yorke',
  'thomas à kempis',
  'thomas a. hendricks',
  'thomas a. steitz',
  'thomas anders',
  'thomas andrews (shipbuilder)',
  'thomas aquinas',
  'thomas arne',
  'thomas bayes',
  'thomas becket',
  'thomas bernhard',
  'thomas carlyle',
  'thomas cech',
  'thomas cranmer',
  'thomas cromwell',
  'thomas eakins',
  'thomas edison',
  'thomas friedman',
  'thomas gainsborough',
  'thomas gravesen',
  'thomas hardy',
  'thomas häßler',
  'thomas henry huxley',
  'thomas hobbes',
  'thomas huckle weller',
  'thomas hunt morgan',
  'thomas j. sargent',
  'thomas jefferson',
  'thomas johansson',
  'thomas kahlenberg',
  'thomas keneally',
  'thomas klestil',
  'thomas kuhn',
  'thomas malory',
  'thomas mann',
  'thomas more',
  'thomas morgenstern',
  'thomas müller',
  'thomas müntzer',
  'thomas muster',
  'thomas newcomen',
  'thomas paine',
  'thomas pelham-holles, 1st duke of newcastle',
  'thomas pynchon',
  'thomas r. marshall',
  'thomas robert malthus',
  'thomas sankara',
  'thomas schaaf',
  'thomas schelling',
  'thomas sørensen',
  'thomas tallis',
  'thomas the apostle',
  'thomas vermaelen',
  'thomas wolsey',
  'thomas young (scientist)',
  'thor heyerdahl',
  'thor hushovd',
  'thora birch',
  'thorbjörn fälldin',
  'thorbjørn jagland',
  'thorismund',
  'thornton wilder',
  'thorstein veblen',
  'thucydides',
  'thutmose i',
  'thutmose ii',
  'thutmose iii',
  'thutmose iv',
  'tia carrere',
  'tiago mendes',
  'tiberios iii',
  'tiberius',
  'tiberius gracchus',
  'tiberius ii constantine',
  'tibor sekelj',
  'tibullus',
  'tiësto',
  'tiger woods',
  'tiglath-pileser i',
  'tiglath-pileser iii',
  'tigran petrosian',
  'tigran sargsyan',
  'tigranes the great',
  'til schweiger',
  'tilda swinton',
  'till lindemann',
  'tim allen',
  'tim berners-lee',
  'tim borowski',
  'tim burton',
  'tim cahill',
  'tim cook',
  'tim duncan',
  'tim henman',
  'tim howard',
  'tim hunt',
  'tim krul',
  'tim rice',
  'tim robbins',
  'tim roth',
  'tim wiese',
  'timbaland',
  'timo glock',
  'timo hildebrand',
  'timothy dalton',
  'timothy leary',
  'timothy mcveigh',
  'timur',
  'tina fey',
  'tina karol',
  'tina turner',
  'tintoretto',
  'tipu sultan',
  'tirso de molina',
  'tirunesh dibaba',
  'tite kubo',
  'titian',
  'tito vilanova',
  'titus',
  'tiye',
  'tiziano ferro',
  'tjalling koopmans',
  'tobey maguire',
  'tobias asser',
  'todor zhivkov',
  'tōgō heihachirō',
  'tokhtamysh',
  'tokugawa ieyasu',
  'tokugawa yoshinobu',
  'tolui',
  'tom berenger',
  'tom boonen',
  'tom clancy',
  'tom cleverley',
  'tom cruise',
  'tom delonge',
  'tom felton',
  'tom hanks',
  'tom hardy',
  'tom hiddleston',
  'tom hooper (director)',
  'tom huddlestone',
  'tom jones (singer)',
  'tom kenny',
  'tom selleck',
  'tom stoppard',
  'tom waits',
  'tom welling',
  'tom wilkinson',
  'tom wolfe',
  'tomáš berdych',
  'tomás de torquemada',
  'tomáš garrigue masaryk',
  'tomáš hübschman',
  'tomás luis de victoria',
  'tomáš necid',
  'tomáš rosický',
  'tomáš sivok',
  'tomas tranströmer',
  'tomáš ujfaluši',
  'tomaso albinoni',
  'tomasz kuszczak',
  'tomi putaansuu',
  'tomislav nikolić',
  'tommaso campanella',
  'tommi mäkinen',
  'tommy haas',
  'tommy lee jones',
  'tommy robredo',
  'toni braxton',
  'toni collette',
  'toni kroos',
  'toni kukoč',
  'toni morrison',
  'toni sailer',
  'tony adams (footballer)',
  'tony bennett',
  'tony blair',
  'tony curtis',
  'tony hawk',
  'tony hibbert',
  'tony hoare',
  'tony iommi',
  'tony jaa',
  'tony levin',
  'tony parker',
  'tony scott',
  'tony shalhoub',
  'tony tan (singaporean president)',
  'toomas hendrik ilves',
  'topa inca yupanqui',
  'topher grace',
  'tore andré flo',
  'tori amos',
  'torquato tasso',
  'torsten frings',
  'torsten wiesel',
  'toše proeski',
  'toshihide maskawa',
  'toshiro mifune',
  'totila',
  'totò',
  'toto cutugno',
  'toussaint louverture',
  'tove jansson',
  'toyotomi hideyoshi',
  'traci lords',
  'tracy austin',
  'tracy chapman',
  'tracy mcgrady',
  'traian băsescu',
  'trajan',
  'tranquillo barnetta',
  'travis barker',
  'tré cool',
  'trebonianus gallus',
  'trent reznor',
  'trey parker',
  'triple h',
  'tristan tzara',
  'trofim lysenko',
  'truman capote',
  'truong tan sang',
  'trygve haavelmo',
  'trygve lie',
  'tsai ing-wen',
  'tsakhiagiin elbegdorj',
  'tsung-dao lee',
  'tsutomu yamaguchi',
  'tsvetana pironkova',
  'tughril',
  'tullus hostilius',
  'tulsidas',
  'tunku abdul rahman',
  'tuomas holopainen',
  'túpac amaru',
  'túpac amaru ii',
  'tupac shakur',
  'tupou vi',
  'turgut özal',
  'tutankhamun',
  'twiggy',
  'tycho brahe',
  'tyra banks',
  'tyrone power',
  'tyrtaeus',
  'tyson chandler',
  'tyson gay',
  'tzipi livni',
  'u thant',
  'udo jürgens',
  'uesugi kenshin',
  'ugo foscolo',
  'ulf von euler',
  'ulfilas',
  'uli hoeneß',
  'ulrika eleonora, queen of sweden',
  'ulrike meinhof',
  'ulugh beg',
  'ulysses s. grant',
  'uma thurman',
  'umaga (wrestler)',
  'umar',
  'umar ii',
  "umaru musa yar'adua",
  'umberto boccioni',
  'umberto eco',
  'umberto giordano',
  'umberto i of italy',
  'umberto ii of italy',
  'umberto nobile',
  'umm kulthum',
  'unai emery',
  'unas',
  'upton sinclair',
  'ur-nammu',
  'urbain le verrier',
  'urby emanuelson',
  'urho kekkonen',
  'ursula andress',
  'ursula k. le guin',
  'usain bolt',
  'userkaf',
  'usher (entertainer)',
  'utamaro',
  'uthman ibn affan',
  'uwe seeler',
  'uzziah',
  'v. gordon childe',
  'v. s. naipaul',
  'v. v. giri',
  'václav havel',
  'václav klaus',
  'václav pilař',
  'václav svěrkoš',
  'vágner love',
  'väinö linna',
  'vaira vīķe-freiberga',
  'val kilmer',
  'val logsdon fitch',
  'valdas adamkus',
  'valdemar i of denmark',
  'valdemar iv of denmark',
  'valdis dombrovskis',
  'valdis zatlers',
  'valens',
  'valentin serov',
  'valentina matviyenko',
  'valentina tereshkova',
  'valentinian i',
  'valentinian ii',
  'valentinian iii',
  'valentino rossi',
  'valerian (emperor)',
  'valery chkalov',
  'valery gergiev',
  "valéry giscard d'estaing",
  'valery leontiev',
  'vallabhbhai patel',
  'valmiki',
  'valon behrami',
  'valter birsa',
  'van morrison',
  'vandana shiva',
  'vanessa hudgens',
  'vanessa l. williams',
  'vanessa paradis',
  'vanessa redgrave',
  'vanessa-mae',
  'vangelis',
  'vannevar bush',
  'varg vikernes',
  'varlam shalamov',
  'vasco da gama',
  'vasco núñez de balboa',
  'vasili iii of russia',
  'vasili iv of russia',
  'vasilis torosidis',
  'vasily blyukher',
  'vasily chuikov',
  'vasily i of moscow',
  'vasily ii of moscow',
  'vasily perov',
  'vasily smyslov',
  'vasily sokolovsky',
  'vasily surikov',
  'vasily vereshchagin',
  'vasily zaytsev',
  'vasily zhukovsky',
  'vaslav nijinsky',
  'vassily ivanchuk',
  'vavá',
  'vedad ibišević',
  'vedran ćorluka',
  'velupillai prabhakaran',
  'venkatraman ramakrishnan',
  'venus williams',
  'věra čáslavská',
  'vera farmiga',
  'vera mukhina',
  'vera zvonareva',
  'vercingetorix',
  'verka serduchka',
  'verne troyer',
  'verner von heidenstam',
  'vernon chatman',
  'vernon l. smith',
  'veronica campbell-brown',
  'veronica lake',
  'veselin topalov',
  'vespasian',
  'vicente aleixandre',
  'vicente blasco ibáñez',
  'vicente del bosque',
  'vicente fox',
  'vicente rodríguez',
  'victor amadeus ii of sardinia',
  'victor amadeus iii of sardinia',
  'victor emmanuel ii of italy',
  'victor emmanuel iii of italy',
  'victor fleming',
  'victor francis hess',
  'victor garber',
  'victor grignard',
  'victor horta',
  'victor hugo',
  'víctor jara',
  'victor moses',
  'victor obinna',
  'victor pelevin',
  'victor ponta',
  'víctor valdés',
  'victor vasarely',
  'victoria abril',
  'victoria azarenka',
  'victoria beckham',
  'victoria justice',
  'victoria silvstedt',
  'victoria, crown princess of sweden',
  'victoria, princess royal',
  'victoriano huerta',
  'vidkun quisling',
  'vigdís finnbogadóttir',
  'viggo mortensen',
  'vikash dhorasoo',
  'viktor chernomyrdin',
  'viktor dyk',
  'viktor frankl',
  'viktor hambardzumyan',
  'viktor kassai',
  'viktor korchnoi',
  'viktor orbán',
  'viktor troicki',
  'viktor tsoi',
  'viktor vasnetsov',
  'viktor yanukovych',
  'viktor yushchenko',
  'viktor zubkov',
  'vilfredo pareto',
  'ville valo',
  'vin diesel',
  'vince carter',
  'vince mcmahon',
  'vince vaughn',
  'vincent auriol',
  'vincent candela',
  'vincent cassel',
  'vincent de paul',
  'vincent du vigneaud',
  'vincent kompany',
  'vincent price',
  'vincent van gogh',
  'vincente minnelli',
  'vincenzo bellini',
  'vincenzo iaquinta',
  'vincenzo montella',
  'vincenzo scamozzi',
  'vinnie jones',
  'vint cerf',
  'viola davis',
  'violeta chamorro',
  'violetta villas',
  'virgil',
  'virgilijus alekna',
  'virginia apgar',
  'virginia ruano pascual',
  'virginia woolf',
  'vissarion belinsky',
  'viswanathan anand',
  'vitali klitschko',
  'vitaly ginzburg',
  'vitaly petrov',
  'vitaly scherbo',
  'vitantonio liuzzi',
  'vitellius',
  'vito mannone',
  'vito volterra',
  'vítor baía',
  'vitruvius',
  'vittore carpaccio',
  'vittorio alfieri',
  'vittorio de sica',
  'vittorio emanuele orlando',
  'vittorio gassman',
  'vitus',
  'vitus bering',
  'vivien leigh',
  'vivienne westwood',
  'vlad filat',
  'vlad the impaler',
  'vladimir arnold',
  'vladimir ashkenazy',
  'vladimir horowitz',
  'vladimir ii monomakh',
  'vladimir k. zworykin',
  'vladimir komarov',
  'vladimir kramnik',
  'vladimir lenin',
  'vladimir mayakovsky',
  'vladimir nabokov',
  'vladimir prelog',
  'vladimir propp',
  'vladimir putin',
  'vladimir solovyov (philosopher)',
  'vladimír špidla',
  'vladimir stojković',
  'vladimir tatlin',
  'vladimir the great',
  'vladimir voronin',
  'vladimir vysotsky',
  'vladimír weiss (footballer born 1989)',
  'vladimir zhirinovsky',
  'vladislaus ii of bohemia and hungary',
  'vladislav ardzinba',
  'vo nguyen giap',
  'vojislav koštunica',
  'vojislav šešelj',
  'volkan demirel',
  'voltaire',
  'volusianus',
  'vreni schneider',
  'vuk stefanović karadžić',
  'vukašin brajić',
  'vyacheslav malafeev',
  'vyacheslav molotov',
  'vyasa',
  'vytautas',
  'vytautas landsbergis',
  'w. b. yeats',
  'w. e. b. du bois',
  'w. h. auden',
  'w. somerset maugham',
  'wacław sierpiński',
  'wade williams',
  'wäinö aaltonen',
  'wallace shawn',
  'wallia',
  'wallis simpson',
  'wally schirra',
  'walt disney',
  'walt whitman',
  'walter baade',
  'walter benjamin',
  'walter brennan',
  'walter cronkite',
  'walter gargano',
  'walter gilbert',
  'walter gropius',
  'walter houser brattain',
  'walter kohn',
  'walter matthau',
  'walter model',
  'walter mondale',
  'walter raleigh',
  'walter rudolf hess',
  'walter samuel',
  'walter scheel',
  'walter scott',
  'walter ulbricht',
  'walter zenga',
  'walther bothe',
  'walther funk',
  'walther nernst',
  'walther rathenau',
  'walther von brauchitsch',
  'walther von der vogelweide',
  'walther von reichenau',
  'wangari maathai',
  'wanli emperor',
  'ward cunningham',
  'warren beatty',
  'warren buffett',
  'warren g. harding',
  'warwick davis',
  'washington irving',
  'washington luís',
  'wassily kandinsky',
  'wassily leontief',
  'wat tyler',
  'wayne bridge',
  'wayne gretzky',
  'wayne rooney',
  'weird al yankovic',
  'wen jiabao',
  'wenceslaus ii of bohemia',
  'wenceslaus iii of bohemia',
  'wenceslaus iv of bohemia',
  'wendell meredith stanley',
  'weneg (pharaoh)',
  'wentworth miller',
  'werner arber',
  'werner faymann',
  'werner forssmann',
  'werner heisenberg',
  'werner herzog',
  'werner mölders',
  'werner von blomberg',
  'werner von siemens',
  'wernher von braun',
  'wes anderson',
  'wes brown',
  'wes craven',
  'wes montgomery',
  'wesley sneijder',
  'wesley snipes',
  'whitney houston',
  'whoopi goldberg',
  'wilfred bouma',
  'wilfred owen',
  'wilfrid laurier',
  'wilhelm busch',
  'wilhelm canaris',
  'wilhelm cuno',
  'wilhelm dilthey',
  'wilhelm eduard weber',
  'wilhelm frick',
  'wilhelm friedemann bach',
  'wilhelm furtwängler',
  'wilhelm grimm',
  'wilhelm hauff',
  'wilhelm ii, german emperor',
  'wilhelm keitel',
  'wilhelm liebknecht',
  'wilhelm list',
  'wilhelm marx',
  'wilhelm maybach',
  'wilhelm ostwald',
  'wilhelm pieck',
  'wilhelm reich',
  'wilhelm ritter von leeb',
  'wilhelm röntgen',
  'wilhelm steinitz',
  'wilhelm tempel',
  'wilhelm von humboldt',
  'wilhelm wien',
  'wilhelm wundt',
  'wilhelmina of the netherlands',
  'wilkie collins',
  'will champion',
  'will eisner',
  'will ferrell',
  'will sasso',
  'will smith',
  'will wright (game designer)',
  'will.i.am',
  'willard boyle',
  'willard libby',
  'willard van orman quine',
  'willebrord snellius',
  'willem barentsz',
  'willem dafoe',
  'willem de kooning',
  'willem drees',
  'willem einthoven',
  'willem-alexander, prince of orange',
  'willi stoph',
  'william a. wheeler',
  'william alfred fowler',
  'william anders',
  'william baffin',
  'william bateson',
  'william blake',
  'william bligh',
  'william boeing',
  'william booth',
  'william byrd',
  'william carlos williams',
  'william cavendish-bentinck, 3rd duke of portland',
  'william cavendish, 4th duke of devonshire',
  'william crookes',
  'william dampier',
  'william daniel phillips',
  'william ewart gladstone',
  'william faulkner',
  'william fichtner',
  'william forsyth sharpe',
  'william friedkin',
  'william gallas',
  'william giauque',
  'william gibson',
  'william gilbert (astronomer)',
  'william godwin',
  'william golding',
  'william grenville, 1st baron grenville',
  'william h. macy',
  'william h. seward',
  'william hanna',
  'william harvey',
  'william henry bragg',
  'william henry harrison',
  'william henry pickering',
  'william herschel',
  'william hogarth',
  'william holden',
  'william holman hunt',
  'william howard stein',
  'william howard taft',
  'william hurt',
  'william i of the netherlands',
  'william i, german emperor',
  'william ii of england',
  'william ii of the netherlands',
  'william iii of england',
  'william iii of the netherlands',
  'william iv of the united kingdom',
  'william ix, duke of aquitaine',
  'william james',
  'william john macquorn rankine',
  'william jones (philologist)',
  'william kidd',
  'william kvist',
  'william lamb, 2nd viscount melbourne',
  'william lassell',
  'william lawrence bragg',
  'william lipscomb',
  'william makepeace thackeray',
  'william mckinley',
  'william morris',
  'william moseley (actor)',
  'william of ockham',
  'william of rubruck',
  'william of tyre',
  'william p. murphy',
  'william penn',
  'william petty, 2nd earl of shelburne',
  'william pitt the younger',
  'william pitt, 1st earl of chatham',
  'william r. king',
  'william ramsay',
  'william randolph hearst',
  'william rowan hamilton',
  'william s. burroughs',
  'william saroyan',
  'william shakespeare',
  'william shatner',
  'william shockley',
  'william standish knowles',
  'william stanley jevons',
  'william styron',
  'william tecumseh sherman',
  'william the conqueror',
  'william the lion',
  'william the silent',
  'william thomson, 1st baron kelvin',
  'william tyndale',
  'william vickrey',
  'william wallace',
  'william westmoreland',
  'william wilberforce',
  'william wordsworth',
  'william wyler',
  'william-adolphe bouguereau',
  'willie nelson',
  'willis lamb',
  'willow smith',
  'willy brandt',
  'willy messerschmitt',
  'willy sagnol',
  'willy van de kerkhof',
  'wilma rudolph',
  'wilson kipketer',
  'wilson palacios',
  'wilt chamberlain',
  'wim duisenberg',
  'wim kok',
  'wim wenders',
  'winona ryder',
  'winsor mccay',
  'winston churchill',
  'winston reid (footballer)',
  'wisława szymborska',
  'witold gombrowicz',
  'witold lutosławski',
  'wiz khalifa',
  'wladimir klitschko',
  'wladimir köppen',
  'władysław gomułka',
  'władysław i the elbow-high',
  'władysław iii of poland',
  'władysław iv vasa',
  'władysław reymont',
  'władysław sikorski',
  'władysław szpilman',
  'wojciech jaruzelski',
  'wojciech szczęsny',
  'wole soyinka',
  'wolfgang amadeus mozart',
  'wolfgang ketterle',
  'wolfgang paul',
  'wolfgang pauli',
  'wolfgang petersen',
  'wolfgang schäuble',
  'wolfgang schüssel',
  'wolfgang stark',
  'wolfram freiherr von richthofen',
  'wolfram von eschenbach',
  'wong kar-wai',
  'woodrow wilson',
  'woody allen',
  'woody guthrie',
  'woody harrelson',
  'wouter weylandt',
  "wu cheng'en",
  'wu zetian',
  'wyatt earp',
  'wyclef jean',
  'wynton marsalis',
  'xabi alonso',
  'xanana gusmão',
  'xavi',
  'xavier malisse',
  'xenocrates',
  'xenophanes',
  'xenophon',
  'xerxes i of persia',
  'xerxes ii of persia',
  'xherdan shaqiri',
  'xi jinping',
  'xuanzang',
  'xunzi',
  'xzibit',
  'yahya jammeh',
  'yakov sverdlov',
  'yakub kolas',
  'yakubu aiyegbeni',
  'yamagata aritomo',
  'yang liwei',
  'yanka kupala',
  'yann martel',
  'yann tiersen',
  'yanni',
  'yannick noah',
  'yao ming',
  'yaşar kemal',
  'yash chopra',
  'yasser arafat',
  'yasuhiro nakasone',
  'yasuhiro yamashita',
  'yasuhito endō',
  'yasujirō ozu',
  'yasunari kawabata',
  'yasuo fukuda',
  'yaya touré',
  'yayi boni',
  'yazdegerd i',
  'yazdegerd ii',
  'yazdegerd iii',
  'yazid i',
  'yeardley smith',
  'yegor gaidar',
  'yehudi menuhin',
  'yelena bonner',
  'yelena isinbayeva',
  'yelena slesarenko',
  'yellow emperor',
  'yemelyan pugachev',
  'yermak timofeyevich',
  'yevgeny kafelnikov',
  'yevgeny primakov',
  'yevgeny yevtushenko',
  'yevgeny zamyatin',
  'yi so-yeon',
  'yi sun-sin',
  'yiannis ritsos',
  'yingluck shinawatra',
  'yip man',
  'yiruma',
  'yitzhak ben-zvi',
  'yitzhak rabin',
  'yitzhak shamir',
  'yma sumac',
  'yngwie malmsteen',
  'yo-yo ma',
  'yoann gourcuff',
  'yochanan vollach',
  'yohan blake',
  'yohan cabaye',
  'yoichiro nambu',
  'yoko ono',
  'yongle emperor',
  'yoshihiko noda',
  'yoshikatsu kawaguchi',
  'yoshiki (musician)',
  'yoshirō mori',
  'yossi benayoun',
  'youri djorkaeff',
  'yousaf raza gillani',
  "youssou n'dour",
  'yoweri museveni',
  'yuan shikai',
  'yuan t. lee',
  'yukio hatoyama',
  'yukio mishima',
  'yul brynner',
  'yulia tymoshenko',
  'yun bo-seon',
  'yun chi-ho',
  'yunjin kim',
  'yuri andropov',
  'yuri dolgorukiy',
  'yuri gagarin',
  'yuri nikulin',
  'yuri zhirkov',
  'yury luzhkov',
  'yury of moscow',
  'yusuf al-qaradawi',
  'yuto nagatomo',
  'yves chauvin',
  'yves klein',
  'yves leterme',
  'yves montand',
  'yves saint laurent (designer)',
  'yvonne strahovski',
  'zac efron',
  'zach braff',
  'zachary levi',
  'zachary quinto',
  'zachary taylor',
  'zack snyder',
  'zaha hadid',
  'zahi hawass',
  'zakir hussain (politician)',
  'zalman shazar',
  'zara phillips',
  'zayed bin sultan al nahyan',
  'zbigniew boniek',
  'zbigniew brzezinski',
  'zdeněk grygera',
  'zdravko kuzmanović',
  'zé roberto',
  'zeami motokiyo',
  'zechariah (priest)',
  'zedekiah',
  'željko joksimović',
  'željko kalac',
  'željko komšić',
  'željko ražnatović',
  'zemfira',
  'zendaya',
  'zeno (emperor)',
  'zeno of citium',
  'zeno of elea',
  'zenobia',
  'zhang fei',
  'zhang heng',
  'zhang yimou',
  'zhang ziyi',
  'zhao ziyang',
  'zhelyu zhelev',
  'zheng he',
  'zheng jie',
  'zhores alferov',
  'zhou enlai',
  'zhu xi',
  'zhuangzi',
  'zhuge liang',
  'zico',
  'zilda arns',
  'zillur rahman',
  'zine el abidine ben ali',
  'zinedine zidane',
  'zita of bourbon-parma',
  'zlatan ibrahimović',
  'zlatan ljubijankič',
  'zlatko zahovič',
  'zodiac killer',
  'zoe porphyrogenita',
  'zoe saldana',
  'zog of albania',
  'zoltán gera',
  'zoltán kodály',
  'zooey deschanel',
  'zoran đinđić',
  'zoran tošić',
  'zoroaster',
  'zosimus',
  'zoya kosmodemyanskaya',
  'zsa zsa gabor',
  'zubin mehta',
  'zucchero fornaciari',
  'zulfikar ali bhutto',
  'zviad gamsakhurdia',
  'zvonimir boban',
];
